/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Customer APP API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customAxiosInstance } from './mutator/customAxiosInstance';
import type { BodyType } from './mutator/customAxiosInstance';
/**
 * Unique Identifier
 */
export type Id = number;

export type OrganisationId = number;

export type AccessToken = string;

export type Code = string;

/**
 * User id
 */
export type CreatorId = number;

export type CreatorType = string;

/**
 * amount
 */
export type Amount = string;

/**
 * Creditor account uuid
 */
export type CreditorAccountUuid = string;

export type CreatorName = string;

/**
 * Country name
 */
export type CountryName = string;

/**
 * @nullable
 */
export type CurrencyCode = string | null;

/**
 * Currency ISO code
 */
export type CurrencyIso = string;

/**
 * @nullable
 */
export type CurrencyName = string | null;

/**
 * Country ISO
 */
export type CountryIso = string;

/**
 * Unique reference end to end id
 */
export type ExternalReference = string;

export type Email = string;

export type FullName = string;

export type IdExpiryDate = string;

export type IdIssuingCountryCode = string;

export type IdIssuingDate = string;

export type IdNumber = string;

export type IdType = string;

/**
 * Our unique reference
 */
export type UniqueReference = string;

/**
 * Reference
 */
export type Reference = string;

/**
 * Status
 */
export type Status = string;

export type OkStatus = string;

/**
 * Account holder type
 */
export type CreditorType = (typeof CreditorType)[keyof typeof CreditorType];

export const CreditorType = {
  organization: 'organization',
  private: 'private'
} as const;

/**
 * Transfer amount
 * @nullable
 */
export type TransferAmount = number | null;

/**
 * Transfer currency code
 * @nullable
 */
export type TransferCurrencyCode = string | null;

/**
 * Provider capability id
 * @nullable
 */
export type ProviderCapabilityId = string | null;

/**
 * Debtor account number
 */
export type DebtorAccountNumber = string;

/**
 * virtual account number
 */
export type VirtualAccountNumber = string;

/**
 * Datetime when the record was created
 */
export type CreatedAt = string;

/**
 * Datetime when the record was last updated
 */
export type UpdatedAt = string;

/**
 * <all> is only for frontend use
 */
export type WithdrawalStatus =
  (typeof WithdrawalStatus)[keyof typeof WithdrawalStatus];

export const WithdrawalStatus = {
  received: 'received',
  processing: 'processing',
  completed: 'completed',
  rejected: 'rejected',
  returned: 'returned'
} as const;

export type State = string;

export type StreetName = string;

export type StatusTransitions = StatusTransition[];

/**
 * For Details > History section
 */
export interface StatusTransition {
  id?: Id;
  created_at?: CreatedAt;
  status_category?: WithdrawalStatus;
}

export type StatusTransitionsWithReasonCode = StatusTransitionWithReasonCode[];

/**
 * For Details > History section
 */
export interface StatusTransitionWithReasonCode {
  id?: Id;
  created_at: CreatedAt;
  status: WithdrawalStatus;
  reason_code: WithdrawalReasonCode;
}

/**
 * admin, operations member or reviewer
 */
export type RoleName = string;

export interface ReasonCodeObject {
  id: Id;
  reason_code_id: Id;
  kind: string;
  group: string;
  symbol: string;
  external_message: string;
  reason: string;
}

export interface WithdrawalReasonCode {
  reason: string;
  external_message: string;
}

/**
 * @nullable
 */
export type DisbursementPartyIdentification = {
  /** @nullable */
  full_name: string | null;
  /** @nullable */
  birthdate: string | null;
  /** @nullable */
  address: string | null;
  /** @nullable */
  city: string | null;
  country_code: CountryIso;
  /** @nullable */
  postal_code?: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  mobile_number: string | null;
  /** @nullable */
  vop_result?: string | null;
  /** @nullable */
  vop_matched_name?: string | null;
} | null;

/**
 * @nullable
 */
export type PartyIdentification = {
  /** Creditor address */
  address_lines?: string;
  /** Creditor city */
  city?: string;
  country_code?: CountryIso;
  /** Creditor name */
  name?: string;
  /** Creditor postcode */
  postcode?: string;
  /** Account holder type */
  type?: string;
  /** Dob */
  birthdate?: string;
} | null;

/**
 * @nullable
 */
export type CreditorAccount = {
  /** @nullable */
  iban: string | null;
  /** @nullable */
  account_number: string | null;
  /** @nullable */
  account_number_type: string | null;
  /** @nullable */
  bank_bic: string | null;
  /** @nullable */
  bank_name: string | null;
  /** @nullable */
  bank_clearing_system_id: string | null;
  /** @nullable */
  bank_clearing_system_code: string | null;
  /** @nullable */
  bank_branch_id: number | null;
  /** @nullable */
  bank_branch_name: number | null;
  /** @nullable */
  country_code: string | null;
} | null;

/**
 * @nullable
 */
export type PartyIdentificationAccount = {
  id?: string;
  account_number?: string;
  bank_bic?: string;
  bank_branch_id?: number;
  bank_clearing_system_code?: number;
  country_code?: string;
  iban?: string;
  type?: string;
} | null;

/**
 * @nullable
 */
export type IntermediaryAgent = {
  /** @nullable */
  bank_bic: string | null;
  /** @nullable */
  bank_name: string | null;
} | null;

/**
 * @nullable
 */
export type IntermediaryAgentAccount = {
  /** @nullable */
  account_number: string | null;
  /** @nullable */
  iban: string | null;
} | null;

export interface Success {
  /** Successful operation response */
  success?: boolean;
}

export type AttachmentOwnerType =
  (typeof AttachmentOwnerType)[keyof typeof AttachmentOwnerType];

export const AttachmentOwnerType = {
  'Disbursement::PaymentRequest': 'Disbursement::PaymentRequest',
  'Disbursement::PaymentRequestDraft': 'Disbursement::PaymentRequestDraft',
  'Disbursement::PaymentRequestBatch': 'Disbursement::PaymentRequestBatch'
} as const;

export type AttachmentCreatorType =
  (typeof AttachmentCreatorType)[keyof typeof AttachmentCreatorType];

export const AttachmentCreatorType = {
  'Customer::User': 'Customer::User',
  'Admin::User': 'Admin::User'
} as const;

export interface Attachment {
  id: Id;
  uuid: Uuid;
  file_name: FileName;
  format: string;
  owner_id: Id;
  owner_type: AttachmentOwnerType;
  creator_id?: Id;
  creator_type?: AttachmentCreatorType;
  created_at: CreatedAt;
  updated_at: CreatedAt;
}

export type CancellationsInitiatorType =
  (typeof CancellationsInitiatorType)[keyof typeof CancellationsInitiatorType];

export const CancellationsInitiatorType = {
  'Customer::User': 'Customer::User',
  'Admin::User': 'Admin::User',
  'Customer::Organisation': 'Customer::Organisation'
} as const;

export interface Cancellations {
  id?: Id;
  initiator_id?: Id;
  /** @nullable */
  initiator_name?: CreatorName;
  initiator_type?: CancellationsInitiatorType;
  created_at?: string;
  status?: string;
}

export interface FeatureFlag {
  'CBP-1761-customer-app-batches'?: boolean;
  'CBP-2001-approval-workflow-manual-payouts'?: boolean;
  'CBP-2870-withdrawal-accounts-enabled'?: boolean;
  'CBP-8000-receiver-management'?: boolean;
  'CBP-10746-e2e-test-cases-field-enabled'?: boolean;
  'PEGO-12125-insight-section-customer-app'?: boolean;
  'PEGO-12738-sandbox-customer-app-api-docs'?: boolean;
  'PEGO-12664-create-receiver'?: boolean;
  'PEGO-13634-self-service-developer-settings'?: boolean;
  'PEGO-14432-mcp-tokens'?: boolean;
}

/**
 * Approval or rejection
 */
export interface Review {
  user_id: Id;
  created_at: CreatedAt;
  user_name: CreatorName;
  approved: boolean;
}

export interface PayoutReview {
  reviewer_id?: Id;
  created_at?: string;
  /** @nullable */
  reviewer_name?: CreatorName;
  approved?: boolean;
}

/**
 * uuidV4
 */
export type Uuid = string;

/**
 * contains file type
 */
export type FileName = string;

/**
 * report_uuid
 */
export type PayoutReportName = string;

/**
 * csv content
 */
export type PayoutReportData = string;

export interface PayoutReport {
  uuid: PayoutReportName;
  /** created after filter */
  created_after: string;
  /** created before filter */
  created_before: string;
  state_categories: string[];
  reason_codes: string[];
  organisation_id: OrganisationId;
  filename: PayoutReportName;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
  /**
   * amount from filter
   * @nullable
   */
  amount_from?: string | null;
  /**
   * amount to filter
   * @nullable
   */
  amount_to?: string | null;
  currency_code?: CurrencyCode;
  virtual_account_number?: VirtualAccountNumber;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
}

export interface PayoutReports {
  uuid?: PayoutReportName;
  amount?: Amount;
  /** created after filter */
  created_after?: string;
  /** created before filter */
  created_before?: string;
  state_categories?: string[];
  /**
   * amount from filter
   * @nullable
   */
  amount_from?: string | null;
  /**
   * amount to filter
   * @nullable
   */
  amount_to?: string | null;
  reason_codes?: string[];
  /**
   * business unit filter
   * @nullable
   */
  business_unit_name?: string | null;
  /**
   * local instrument filter
   * @nullable
   */
  local_instrument?: string | null;
  currency_code?: CurrencyCode;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id?: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  filename?: PayoutReportName;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
}

/**
 * report_uuid
 */
export type OrderReportUuid = string;

/**
 * report blob filename (always <uuid>.csv)
 */
export type OrderReportFilename = string;

/**
 * csv content
 */
export type OrderReportData = string;

/**
 * report processing lifecycle state
 */
export type OrderReportProcessingState =
  (typeof OrderReportProcessingState)[keyof typeof OrderReportProcessingState];

export const OrderReportProcessingState = {
  pending: 'pending',
  available: 'available',
  failed: 'failed'
} as const;

export interface OrderReport {
  uuid: OrderReportUuid;
  /** created after filter */
  created_after: string;
  /** created before filter */
  created_before: string;
  /**
   * order status filter
   * @nullable
   */
  status?: string | null;
  /**
   * reason code filter
   * @nullable
   */
  reason_code_id?: number | null;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  processing_state: OrderReportProcessingState;
  filename: OrderReportFilename;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface OrderReports {
  uuid?: OrderReportUuid;
  /** created after filter */
  created_after?: string;
  /** created before filter */
  created_before?: string;
  /**
   * order status filter
   * @nullable
   */
  status?: string | null;
  /**
   * reason code filter
   * @nullable
   */
  reason_code_id?: number | null;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id?: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  processing_state?: OrderReportProcessingState;
  filename?: OrderReportFilename;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
}

export type PayoutRequestStatus =
  (typeof PayoutRequestStatus)[keyof typeof PayoutRequestStatus];

export const PayoutRequestStatus = {
  received: 'received',
  rejected: 'rejected',
  returned: 'returned',
  action_required: 'action_required',
  completed: 'completed',
  pending: 'pending',
  processing: 'processing'
} as const;

export type PayoutRequestCurrentStateName =
  (typeof PayoutRequestCurrentStateName)[keyof typeof PayoutRequestCurrentStateName];

export const PayoutRequestCurrentStateName = {
  created: 'created',
  capability_selected: 'capability_selected',
  validating_external: 'validating_external',
  validated: 'validated',
  unable_to_validate_external: 'unable_to_validate_external',
  waiting_future_execution: 'waiting_future_execution',
  tstm_initiated: 'tstm_initiated',
  tstm_screened: 'tstm_screened',
  ready_for_v1: 'ready_for_v1',
  scheduled_for_processing: 'scheduled_for_processing',
  converting_to_v1: 'converting_to_v1',
  conversion_to_v1_failed: 'conversion_to_v1_failed',
  converted_to_v1: 'converted_to_v1',
  ready_for_transaction_screening: 'ready_for_transaction_screening',
  transaction_screening_in_process: 'transaction_screening_in_process',
  reviewing_transaction_screening: 'reviewing_transaction_screening',
  added_to_payout_planner: 'added_to_payout_planner',
  halted: 'halted',
  rerouted_to_different_provider: 'rerouted_to_different_provider',
  accepted_by_processing_provider: 'accepted_by_processing_provider',
  reconciliation_completed: 'reconciliation_completed',
  missing_capability: 'missing_capability',
  validation_schema_failed: 'validation_schema_failed',
  external_validation_failed: 'external_validation_failed',
  payment_request_cancelled: 'payment_request_cancelled',
  payment_returned: 'payment_returned',
  awaiting_kyc_documents: 'awaiting_kyc_documents',
  awaiting_extended_kyc: 'awaiting_extended_kyc',
  insufficient_funds: 'insufficient_funds'
} as const;

export type PayoutRequestPaymentRequestStateReasonCodesItemMeta = {
  [key: string]: unknown;
};

export type PayoutRequestPaymentRequestStateReasonCodesItem = {
  reason_code_id?: Id;
  meta?: PayoutRequestPaymentRequestStateReasonCodesItemMeta;
};

export type PayoutRequestStatusTransitionsItem = {
  name: string;
  timestamp: string;
};

export type PayoutRequestErrorsItem = {
  details: string[];
  pointer: string;
};

/**
 * @nullable
 */
export type PayoutRequestErrors = {
  [key: string]: PayoutRequestErrorsItem[];
} | null;

export interface PayoutRequest {
  id: Id;
  unique_reference: UniqueReference;
  /** end-to-end id */
  end_to_end_id: string;
  local_instrument: string;
  business_unit: string;
  amount: Amount;
  /** @nullable */
  batch_id: number | null;
  /**
   * manual, csv or api
   * @nullable
   */
  source: string | null;
  currency: CurrencyCode;
  status: PayoutRequestStatus;
  /**
   * creator id
   * @nullable
   */
  creator_id: number | null;
  /** @nullable */
  creator_name: string | null;
  current_state_name: PayoutRequestCurrentStateName;
  timestamp: string;
  /** @nullable */
  requested_execution_date: CreatedAt;
  /** @nullable */
  purpose_code: string | null;
  debtor: PayoutDebtor;
  ultimate_debtor: DisbursementPartyIdentification;
  creditor: DisbursementPartyIdentification;
  creditor_account: CreditorAccount;
  intermediary_agent: IntermediaryAgent;
  intermediary_agent_account: IntermediaryAgentAccount;
  /** @nullable */
  debtor_account: ReconciliationVirtualAccount;
  reason_codes: ReasonCodeObject[];
  payment_request_state_reason_codes: PayoutRequestPaymentRequestStateReasonCodesItem[];
  status_transitions: PayoutRequestStatusTransitionsItem[];
  cancellations: Cancellations[];
  /** @nullable */
  reviews: PayoutReview[] | null;
  /** @nullable */
  errors: PayoutRequestErrors;
}

export type PayoutRequestItemSource =
  (typeof PayoutRequestItemSource)[keyof typeof PayoutRequestItemSource];

export const PayoutRequestItemSource = {
  api: 'api',
  csv: 'csv',
  manual: 'manual',
  iso_20022: 'iso_20022'
} as const;

/**
 * state category name
 */
export type PayoutRequestItemState =
  (typeof PayoutRequestItemState)[keyof typeof PayoutRequestItemState];

export const PayoutRequestItemState = {
  received: 'received',
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  rejected: 'rejected',
  returned: 'returned',
  action_required: 'action_required'
} as const;

export interface PayoutRequestItem {
  id: Id;
  business_unit_id: Id;
  created_at?: CreatedAt;
  /** @nullable */
  batch_id?: number | null;
  /** @nullable */
  execution_date: string | null;
  source?: PayoutRequestItemSource;
  /** state category name */
  state: PayoutRequestItemState;
  local_instrument: string;
  end_to_end_id?: string;
  unique_reference?: UniqueReference;
  amount: Amount;
  debtor_account: VirtualAccountNumber;
  currency: CurrencyCode;
  attachments_count: number;
}

/**
 * waiting_approval or rejected
 */
export type PayoutDraftsItemStatus =
  (typeof PayoutDraftsItemStatus)[keyof typeof PayoutDraftsItemStatus];

export const PayoutDraftsItemStatus = {
  waiting_review: 'waiting_review',
  rejected: 'rejected'
} as const;

export interface PayoutDraftsItem {
  id: Id;
  created_at: CreatedAt;
  /** manual or batch */
  source: string;
  attachments_count: number;
  /** waiting_approval or rejected */
  status: PayoutDraftsItemStatus;
  creator_name?: string;
  local_instrument?: string;
  corridor?: string;
  /** number of current approvals */
  approvers_count?: number;
  /** end-to-end id */
  end_to_end_id?: string;
  amount?: Amount;
  debtor_account?: VirtualAccountNumber;
  currency?: CurrencyCode;
}

export type PayoutDraftDebtor = {
  name?: string;
  website?: string;
};

export type PayoutDraftDebtorAccount = {
  /** @nullable */
  id?: number | null;
  scheme_name?: string;
};

/**
 * waiting_review or rejected
 */
export type PayoutDraftStatus =
  (typeof PayoutDraftStatus)[keyof typeof PayoutDraftStatus];

export const PayoutDraftStatus = {
  waiting_review: 'waiting_review',
  rejected: 'rejected'
} as const;

export interface PayoutDraft {
  id: Id;
  amount?: Amount;
  /** number of current approvals */
  approvers_count: number;
  currency_code?: CurrencyCode;
  debtor?: PayoutDraftDebtor;
  ultimate_debtor?: PartyIdentification;
  /** @nullable */
  creditor?: PartyIdentification;
  creditor_account?: PartyIdentificationAccount;
  intermediary_agent?: IntermediaryAgent;
  intermediary_agent_account?: IntermediaryAgentAccount;
  debtor_account?: PayoutDraftDebtorAccount;
  /** user name */
  creator_name: string;
  /** manual or batch */
  source: string;
  /** creator id */
  user_id?: number;
  /** waiting_review or rejected */
  status: PayoutDraftStatus;
  /** end-to-end id */
  end_to_end_id?: string;
  local_instrument: string;
  corridor: string;
  approvals?: Review[];
  rejections?: Review[];
}

export type SchemaFieldsDefinitionDataCreditor = { [key: string]: FieldObject };

export type SchemaFieldsDefinitionDataCreditorAccount = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionDataIntermediaryAgent = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionDataIntermediaryAgentAccount = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionData = {
  creditor: SchemaFieldsDefinitionDataCreditor;
  creditor_account: SchemaFieldsDefinitionDataCreditorAccount;
  intermediary_agent?: SchemaFieldsDefinitionDataIntermediaryAgent;
  intermediary_agent_account?: SchemaFieldsDefinitionDataIntermediaryAgentAccount;
};

export interface SchemaFieldsDefinition {
  data: SchemaFieldsDefinitionData;
}

export type CreatedPayoutDraftDataProductProductId = string | number;

export type CreatedPayoutDraftDataProductSchemaId = string | number;

export type CreatedPayoutDraftDataProduct = {
  local_instrument: string;
  product_id: CreatedPayoutDraftDataProductProductId;
  schema_id: CreatedPayoutDraftDataProductSchemaId;
};

export type CreatedPayoutDraftDataPayoutRequest = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataUltimateDebtor = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataCreditor = { [key: string]: FieldObject };

export type CreatedPayoutDraftDataCreditorAccount = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataDebtor = { [key: string]: FieldObject };

export type CreatedPayoutDraftDataIntermediaryAgent = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataIntermediaryAgentAccount = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftData = {
  draft_id: number;
  product: CreatedPayoutDraftDataProduct;
  payout_request: CreatedPayoutDraftDataPayoutRequest;
  ultimate_debtor: CreatedPayoutDraftDataUltimateDebtor;
  creditor: CreatedPayoutDraftDataCreditor;
  creditor_account: CreatedPayoutDraftDataCreditorAccount;
  debtor: CreatedPayoutDraftDataDebtor;
  intermediary_agent?: CreatedPayoutDraftDataIntermediaryAgent;
  intermediary_agent_account?: CreatedPayoutDraftDataIntermediaryAgentAccount;
};

export interface CreatedPayoutDraft {
  data: CreatedPayoutDraftData;
}

export type FieldObjectUiField =
  (typeof FieldObjectUiField)[keyof typeof FieldObjectUiField];

export const FieldObjectUiField = {
  text: 'text',
  datepicker: 'datepicker'
} as const;

export type FieldObjectRules = { [key: string]: string };

export type FieldObjectValue = string | number;

export interface FieldObject {
  ui_field: FieldObjectUiField;
  rules?: FieldObjectRules;
  value: FieldObjectValue;
  errors: string[];
}

export type PayoutBatchStatus =
  (typeof PayoutBatchStatus)[keyof typeof PayoutBatchStatus];

export const PayoutBatchStatus = {
  waiting_review: 'waiting_review',
  completed: 'completed',
  rejected: 'rejected'
} as const;

export type PayoutBatchCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type PayoutBatchCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface PayoutBatch {
  id: number;
  name?: FileName;
  /** batch kind (iso or csv) */
  kind?: string;
  status?: PayoutBatchStatus;
  local_instrument?: string;
  total_payout_requests_count?: number;
  total_amount?: number;
  currency?: PayoutBatchCurrency;
  country?: PayoutBatchCountry;
  approvers_count?: number;
  accepted_payout_requests_count?: number;
  /** @nullable */
  creator_id?: CreatorId;
  /** @nullable */
  creator_name?: CreatorName;
  created_at?: CreatedAt;
  approvals?: Review[];
  rejections?: Review[];
}

export type CreatedBatchMetaCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type CreatedBatchMetaCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface CreatedBatchMeta {
  local_instrument: string;
  total_payout_requests: number;
  total_payout_requests_amount: number;
  currency: CreatedBatchMetaCurrency;
  country: CreatedBatchMetaCountry;
}

export interface CreatedBatchData {
  filename: string;
  /** file format */
  format: string;
  batch_id: number;
}

export type PayoutBatchesStatus =
  (typeof PayoutBatchesStatus)[keyof typeof PayoutBatchesStatus];

export const PayoutBatchesStatus = {
  waiting_review: 'waiting_review',
  completed: 'completed',
  rejected: 'rejected'
} as const;

export type PayoutBatchesCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type PayoutBatchesCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface PayoutBatches {
  id: number;
  name: string;
  /** batch kind (iso or csv) */
  kind: string;
  status: PayoutBatchesStatus;
  local_instrument: string;
  total_payout_requests_count?: number;
  total_amount?: number;
  currency: PayoutBatchesCurrency;
  country: PayoutBatchesCountry;
  approvers_count?: number;
  attachments_count: number;
  /** @nullable */
  creator_id?: CreatorId;
  /** @nullable */
  creator_name?: CreatorName;
  created_at?: CreatedAt;
}

export interface BatchDraft {
  amount: string;
  currency_code: string;
  local_instrument: string;
  /** end-to-end id */
  end_to_end_id: string;
  /** received, waiting_approval or rejected */
  state: string;
  batch_id: string;
  /** manual, csv or api */
  source?: string;
  creditor: PartyIdentification;
  creditor_account: PartyIdentificationAccount;
  debtor: PartyIdentification;
  debtor_account: PartyIdentificationAccount;
  ultimate_debtor: PartyIdentification;
}

export interface BatchDraftsItem {
  id: Id;
  /** amount */
  amount: number;
  created_at: CreatedAt;
  currency: CurrencyCode;
  debtor_account: string;
  attachments_count: number;
  /** received, waiting_approval or rejected */
  state: string;
  /** end-to-end id */
  end_to_end_id: string;
}

export interface PreferredPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next: string | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev: string | null;
  /** Has next page */
  has_next_page: boolean;
  /** Has prev page */
  has_prev_page: boolean;
  /** Total number of items */
  total: number;
}

export interface Pagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next?: number | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev?: number | null;
  /** Has next page */
  has_next_page?: boolean;
  /** Has prev page */
  has_prev_page?: boolean;
  /** Total number of items */
  total?: number;
}

export interface OrdersIndexPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_before?: string | null;
  /**
   * Next page
   * @nullable
   */
  cursor_after?: string | null;
  /** Total number of items */
  total?: number;
  /** Has orders */
  has_orders?: boolean;
}

export interface TotalCountPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next?: number | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev?: number | null;
  /** Has next page */
  has_next_page?: boolean;
  /** Has prev page */
  has_prev_page?: boolean;
  /** Total number of items */
  total_count?: number;
}

/**
 * Status
 */
export type StatementItemKind =
  (typeof StatementItemKind)[keyof typeof StatementItemKind];

export const StatementItemKind = {
  transactions: 'transactions',
  charges: 'charges'
} as const;

export interface StatementItem {
  id?: Id;
  /** Status */
  kind?: StatementItemKind;
  file_name?: Reference;
  /** created after filter */
  from?: string;
  /** created before filter */
  to?: string;
  virtual_account_number?: VirtualAccountNumber;
  created_at?: CreatedAt;
  /** id of the csv file */
  csv_file_id?: number;
}

export interface NewStatement {
  id?: Id;
  /** created after filter */
  from?: string;
  /** created before filter */
  to?: string;
  account_id?: Id;
  reference?: Reference;
  period?: string;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
  version?: number;
  /** transactions or charges */
  kind?: string;
  /** created, scheduled, in_progress, failed or completed */
  status?: string;
}

export interface PayoutDebtor {
  full_name: string;
  /** @nullable */
  website: string | null;
}

export interface Debtor {
  email?: Email;
  full_name?: FullName;
  date_of_birth?: string;
  country_of_residence?: CountryIso;
  created_at?: CreatedAt;
}

export interface Configuration {
  /** Irrelevant */
  throttling?: string;
  /** Number */
  batch_number_of_approvers?: string;
  /** Number */
  manual_payout_number_of_approvers?: string;
  /** v1 / v2 / dual */
  virtual_bank_bookkeeping?: string;
  /** Either on/off */
  withdrawals_enabled?: string;
  /** Irrelevant */
  fx_rate_end_point?: string;
  /** 1 if turned on */
  manual_payouts_enabled?: string;
  /** Either on/off */
  batches_enabled?: string;
  /** Either on/off */
  fx_widget_enabled?: string;
  /** c2c / bigedirect / layer 1 */
  crypto_widget_variant?: string;
  /** layer1 / c2c */
  crypto_provider?: string;
  /** Either on/off */
  customer_ab_testing?: string;
}

/**
 * account can be active, suspended, terminated or inactive
 */
export type AccountStatus = (typeof AccountStatus)[keyof typeof AccountStatus];

export const AccountStatus = {
  active: 'active',
  suspended: 'suspended',
  terminated: 'terminated',
  inactive: 'inactive'
} as const;

export interface Account {
  id?: Id;
  /** Account number */
  account_number?: string;
  /** Account Name (default is '<currency> account') */
  name?: string;
  /** latest balance on account */
  balance?: string;
  currency_code?: CurrencyCode;
  currency_name?: CurrencyName;
  /** Boolean telling if the account has any transactions */
  has_transactions?: boolean;
  /** Boolean telling if the account is owned by the requesting organisation */
  owner?: boolean;
  /** account can be active, suspended, terminated or inactive */
  status?: AccountStatus;
}

export interface AccountMeta {
  /** Count of movements (typical one request and one fee) */
  count?: number;
}

export interface AccountSummary {
  currency_code?: CurrencyCode;
  current_balance?: string;
  opening_balance?: string;
  closing_balance?: string;
}

export type AddressCountry = {
  id?: Id;
  /** Country ISO code */
  iso?: string;
  /** Country name */
  name?: string;
};

export interface Address {
  id?: Id;
  /** Line 1 of the organisation address */
  line1?: string;
  /** Line 2 of the organisation address */
  line2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal code */
  postal_code?: string;
  country?: AddressCountry;
  /** Name of the organisation */
  organisation_name?: string;
}

export interface Movement {
  id?: Id;
  /** Order id */
  order_id?: string;
  reference?: Reference;
  amount?: Amount;
  payout_currency?: CurrencyCode;
  /** Amount */
  amount_payout_currency?: string;
  /** Type of movement */
  entry_type?: string;
  date?: CreatedAt;
  value_date?: CreatedAt;
  currency?: CurrencyCode;
  running_balance?: Amount;
}

export interface Movable {
  user_id?: Id;
  /** Additional info */
  internal_remarks?: string;
}

export interface AcceptedFundingConfiguration {
  banking_rail_id?: number;
  currency_iso?: CurrencyIso;
  email?: string;
  /** account number or custom */
  funding_reference?: string;
  /**
   * Operating company's account identifier from the network funding instruction.
   * @nullable
   */
  account_identifier?: string | null;
  /**
   * Network funding instruction ID
   * @nullable
   */
  network_funding_instruction_id?: number | null;
  organisation_id?: OrganisationId;
  owner_name?: string;
  /**
   * Provider account identifier from the network funding instruction.
   * @nullable
   */
  provider_account_identifier?: string | null;
  uuid?: Uuid;
  virtual_account_number?: VirtualAccountNumber;
}

export interface FundingConfiguration {
  /** states whether or not the instructions have been updated in admin */
  changed: boolean;
  uuid: Uuid;
  /** Typically account number, but can be custom */
  funding_reference: string;
  virtual_account_number: VirtualAccountNumber;
  currency_iso: CurrencyIso;
  beneficiary?: FundingConfigurationBeneficiary;
}

export interface FundingConfigurationBeneficiary {
  full_name?: string;
  bank_name?: string;
  bank_address?: string;
  iban?: string;
  account_number?: string;
  sort_code?: string;
  swift_code?: string;
  wallet_address?: string;
  crypto_network?: string;
}

export interface FundingConfigurations {
  virtual_account_number?: FundingConfiguration[];
}

export interface InternalAccountMovement {
  id?: Id;
  amount?: Amount;
  date?: CreatedAt;
  /** Type */
  reason?: string;
  reference?: Reference;
  movable_id?: Id;
  /** Type of movement */
  movable_type?: string;
  account_id?: Id;
  movable?: Movable;
}

export interface VirtualBankAccount {
  /** Unique identifier for the account */
  id?: number;
  /** The account number */
  account_number?: string;
  /** The current balance of the account */
  balance?: string;
  /** The three-letter ISO code for the account's currency */
  currency_code?: string;
  /** The name of the account's currency */
  currency_name?: string;
  /** Whether the account has any transactions */
  has_transactions?: boolean;
  /** The name of the account */
  name?: string;
  /** Whether the account is owned by the current user */
  owner?: boolean;
}

/**
 * The organisation
 */
export type SchemaExampleProductSchemaOrganisation = {
  /** The organisation id */
  id?: number;
  /** The organisation name */
  name?: string;
  /** @nullable */
  country_code?: string | null;
};

/**
 * The payout product
 */
export type SchemaExampleProductSchemaPayoutProduct = {
  /** The product id */
  id?: number;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  country?: string | null;
};

/**
 * The current schema
 */
export type SchemaExampleProductSchemaCurrentSchema = {
  /** The schema id */
  id?: number;
  /** The schema name */
  name?: string;
  /**
   * The schema description
   * @nullable
   */
  description?: string | null;
  updated_at?: string;
  label?: string;
};

export type SchemaExampleProductSchemaAvailableSchemasItem = {
  /** The schema id */
  id?: number;
  /** The schema name */
  name?: string;
  /**
   * The schema description
   * @nullable
   */
  description?: string | null;
  updated_at?: string;
  label?: string;
};

/**
 * The schema of the example
 */
export type SchemaExampleProductSchema = {
  /** The schema fields */
  schema_fields?: SchemaField[];
  /** The organisation */
  organisation?: SchemaExampleProductSchemaOrganisation;
  /** The payout product */
  payout_product?: SchemaExampleProductSchemaPayoutProduct;
  /** The current schema */
  current_schema?: SchemaExampleProductSchemaCurrentSchema;
  /** The available schemas */
  available_schemas?: SchemaExampleProductSchemaAvailableSchemasItem[];
};

export interface SchemaExampleProduct {
  /** The example string */
  example?: string;
  /** The schema of the example */
  schema?: SchemaExampleProductSchema;
}

export type SchemaFieldRulesItem = {
  /** A brief description of the rule */
  description?: string;
  /**
   * A hint for the rule
   * @nullable
   */
  hint?: string | null;
};

export interface SchemaField {
  /** The name of the field */
  field?: string;
  /** A brief description of the field */
  description?: string;
  /** The data type of the field */
  type?: string;
  rules?: SchemaFieldRulesItem[];
}

/**
 * The organisation
 */
export type V2SchemaExampleProductSchemaOrganisation = {
  /** The organisation id */
  id?: number;
  /** The organisation name */
  name?: string;
};

/**
 * The payout product
 */
export type V2SchemaExampleProductSchemaPayoutV2Product = {
  /** The product id */
  id?: number;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  country?: string | null;
};

/**
 * The schema of the example
 */
export type V2SchemaExampleProductSchema = {
  /** The schema fields */
  product_fields?: V2SchemaField[];
  /** The organisation */
  organisation?: V2SchemaExampleProductSchemaOrganisation;
  /** The payout product */
  payout_v2_product?: V2SchemaExampleProductSchemaPayoutV2Product;
};

export interface V2SchemaExampleProduct {
  /** The example string */
  example?: string;
  /** The schema of the example */
  schema?: V2SchemaExampleProductSchema;
}

export type V2SchemaFieldRulesItem = {
  /** A brief description of the rule */
  description?: string;
  /**
   * A hint for the rule
   * @nullable
   */
  hint?: string | null;
};

export interface V2SchemaField {
  /** The name of the field */
  field?: string;
  /** A brief description of the field */
  description?: string;
  /** The data type of the field */
  type?: string;
  rules?: V2SchemaFieldRulesItem[];
}

export interface ImpersonationExchangeResponse {
  access_token: AccessToken;
}

export interface InAppAlert {
  /** The unique identifier of the alert */
  id: number;
  /** The type of app the alert is for (e.g., 'customer_app', 'docs') */
  app_type: string;
  /** The type of alert (e.g., 'info', 'warning', 'error') */
  alert_type: string;
  /** The message content of the alert */
  alert_message: string;
  /** Whether the alert is currently enabled or not */
  enabled: boolean;
}

/**
 * Status
 */
export type WithdrawalAccountStatus =
  (typeof WithdrawalAccountStatus)[keyof typeof WithdrawalAccountStatus];

export const WithdrawalAccountStatus = {
  created: 'created',
  pending_approval: 'pending_approval',
  active: 'active',
  inactive: 'inactive',
  rejected: 'rejected'
} as const;

/**
 * @nullable
 */
export type WithdrawalAccountPartyIdentification = {
  /** Creditor address */
  address_lines?: string;
  /** Creditor city */
  city?: string;
  country_code?: CountryIso;
  /** Creditor name */
  name?: string;
  /** Creditor postcode */
  postcode?: string;
  /** Account holder type */
  type?: string;
} | null;

export interface WithdrawalAccount {
  id?: Id;
  uuid: Uuid;
  /** Label */
  label?: string;
  /** Organisation id */
  organisation_id: number;
  /**
   * Account number
   * @nullable
   */
  account_number?: string | null;
  /** Type */
  type?: string;
  /**
   * Bank bic
   * @nullable
   */
  bank_bic?: string | null;
  /**
   * Bank branch name
   * @nullable
   */
  bank_branch_name?: string | null;
  /**
   * Bank clearing system code
   * @nullable
   */
  bank_clearing_system_code?: string | null;
  /** Bank name */
  bank_name?: string;
  country_code: CountryIso;
  /** Currency */
  currency: string;
  /** Iban */
  iban?: string;
  /** Local instrument */
  local_instrument?: string;
  /**
   * Bank branch id
   * @nullable
   */
  bank_branch_id?: string | null;
  /**
   * Bank clearing system id
   * @nullable
   */
  bank_clearing_system_id?: string | null;
  /** Status */
  status: WithdrawalAccountStatus;
  /** @nullable */
  party_identification?: WithdrawalAccountPartyIdentification;
}

export interface WithdrawalAccountAuthorization {
  id?: Id;
  withdrawal_account_uuid?: Uuid;
  virtual_bank_account_number?: VirtualAccountNumber;
}

export interface WithdrawalRequest {
  id?: Id;
  amount?: Amount;
  creditor_account_uuid?: CreditorAccountUuid;
  currency_code?: CurrencyCode;
  external_reference?: ExternalReference;
  reference?: Reference;
  debtor_account_number?: DebtorAccountNumber;
  created_at?: CreatedAt;
}

export interface WithdrawalRequests {
  id?: Id;
  amount?: Amount;
  creditor_account_uuid?: CreditorAccountUuid;
  currency_code?: CurrencyCode;
  debtor_account_number?: DebtorAccountNumber;
  external_reference?: ExternalReference;
  reference?: Reference;
  status?: WithdrawalStatus;
  created_at?: CreatedAt;
}

export interface WithdrawalRequestWithAccount {
  id: Id;
  amount: Amount;
  creditor_account_uuid: CreditorAccountUuid;
  currency_code: CurrencyCode;
  external_reference?: ExternalReference;
  reference: Reference;
  status: WithdrawalStatus;
  transfer_amount?: TransferAmount;
  transfer_currency_code?: TransferCurrencyCode;
  provider_capability_id?: ProviderCapabilityId;
  debtor_account_number: DebtorAccountNumber;
  created_at?: CreatedAt;
  status_transitions: StatusTransitionsWithReasonCode;
  creditor_account?: WithdrawalAccount;
}

export interface Organisations {
  /** Organisation id */
  id?: number;
  /** Organisation name */
  name?: string;
  country_code?: CountryIso;
  /** Sales group */
  sales_group?: string;
}

export interface CustomerUserOrganisation {
  id: Id;
  /** organisation name */
  name: string;
  /** Public facing organisation name */
  ordering_institution: string;
  /** true means automatically chosen as active when initially logging on */
  default: boolean;
  role: RoleName;
}

export interface BusinessUnit {
  id: number;
  name: string;
  uuid: Uuid;
}

export interface Role {
  name: RoleName;
  /** optional description */
  description?: string;
}

export interface User {
  id: Id;
  email: string;
  first_name: string;
  last_name: string;
  role: RoleName;
  active: boolean;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface UserItem {
  id: Id;
  email: string;
  first_name: string;
  last_name: string;
  /** inactive means removed from organisation */
  active: boolean;
  role: RoleName;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface CustomerAppContractedProducts {
  /** ID */
  id?: number;
  /** Product Id */
  product_id?: number;
  /** Currency of the product */
  product_currency_iso?: string;
}

export interface ContractedProducts {
  /** Product id */
  id?: number;
  currency_iso?: CurrencyIso;
  country_iso?: CountryIso;
  /** label */
  label?: string;
  /** label */
  instrument?: string;
}

export interface ReconciliationVirtualAccount {
  number?: string;
  currency?: string;
}

export interface DebtorAccount {
  /** The debtor account id */
  id?: string;
  /** The scheme used for the payout request */
  scheme_name?: string;
}

export interface PublishedPayoutRequest {
  debtor_account?: DebtorAccount;
  /** Sequential end-to-end id */
  end_to_end_id?: string;
  unique_reference?: UniqueReference;
  amount?: Amount;
  /** Currency of the payout */
  currency?: string;
  /** Currency of the draft */
  currency_code?: string;
  /** Datetime */
  timestamp?: string;
  /** State of the payout request */
  state?: string;
}

export interface Order {
  uuid?: Uuid;
  /** A unique identifier in your system for this Order */
  reference?: string;
  debtor?: Debtor;
  /** Status of your order */
  status?: string;
  amount?: Amount;
  /** The amount in minor units for the currency, computed as amount * 10 ** the currency decimal scale. For 2-decimal currencies this equals amount * 100 (cents). Until the storage widening lands, amounts with more than 2 decimals are rounded to 2 decimals on persist, so amount_cents follows that rounded value. */
  amount_cents?: number;
  currency_code?: CurrencyCode;
  created_at?: CreatedAt;
  virtual_account_number?: DebtorAccountNumber;
}

export interface CollectionOrderFindOne {
  uuid: Uuid;
  reference: Reference;
  debtor: Debtor;
  status: Status;
  business_unit: string;
  currency_code?: CurrencyCode;
  amount?: Amount;
  payments: CollectionOrderPaymentItem[];
  status_history: CollectionStatusHistoryItem[];
  refunds?: CollectionOrderRefundItem[];
  reason_codes: CollectionOrderReasonCodesItem[];
}

export interface CollectionOrderRefundItem {
  amount: string;
  category: string;
  currency_iso: string;
  status: CollectionRefundStatus;
  uuid: number;
  organisation_id: number;
  end_to_end_id: string;
  full_refund: boolean;
  created_at: string;
}

export interface CollectionStatusHistoryItem {
  status: string;
  created_at: string;
}

export interface CollectionOrderPaymentItem {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
}

export type CollectionRefundStatus =
  (typeof CollectionRefundStatus)[keyof typeof CollectionRefundStatus];

export const CollectionRefundStatus = {
  created: 'created',
  processing: 'processing',
  initiated: 'initiated',
  halted: 'halted',
  returned: 'returned',
  rejected: 'rejected',
  completed: 'completed',
  cancelled: 'cancelled',
  scheduled_for_retry: 'scheduled_for_retry',
  insufficient_funds: 'insufficient_funds'
} as const;

export type CollectionPaymentType =
  (typeof CollectionPaymentType)[keyof typeof CollectionPaymentType];

export const CollectionPaymentType = {
  bank_transfer: 'bank_transfer',
  instant_bank_transfer: 'instant_bank_transfer'
} as const;

export type CollectionOrderReasonCodesItemKind =
  (typeof CollectionOrderReasonCodesItemKind)[keyof typeof CollectionOrderReasonCodesItemKind];

export const CollectionOrderReasonCodesItemKind = {
  collection: 'collection'
} as const;

export type CollectionOrderReasonCodesItemGroup =
  (typeof CollectionOrderReasonCodesItemGroup)[keyof typeof CollectionOrderReasonCodesItemGroup];

export const CollectionOrderReasonCodesItemGroup = {
  action_required_for_refund: 'action_required_for_refund',
  action_required: 'action_required',
  refund_requested: 'refund_requested',
  order_cancelled: 'order_cancelled'
} as const;

export interface CollectionOrderReasonCodesItem {
  kind: CollectionOrderReasonCodesItemKind;
  group: CollectionOrderReasonCodesItemGroup;
  reason: string;
  external_message: string;
  symbol: string;
}

export interface CancelOrderReturnType {
  status: OkStatus;
}

export type CollectionPaymentStatus =
  (typeof CollectionPaymentStatus)[keyof typeof CollectionPaymentStatus];

export const CollectionPaymentStatus = {
  created: 'created',
  consent_required: 'consent_required',
  kyc_required: 'kyc_required',
  processing: 'processing',
  user_authorised: 'user_authorised',
  extra_info_required: 'extra_info_required',
  bank_info_collected: 'bank_info_collected',
  consent_given: 'consent_given',
  external_request_created: 'external_request_created',
  redirect_to_bank: 'redirect_to_bank',
  external_transfer_required: 'external_transfer_required',
  bank_processing: 'bank_processing',
  user_cancelled: 'user_cancelled',
  bank_rejected: 'bank_rejected',
  bank_authorised: 'bank_authorised',
  completed: 'completed',
  instructions_provided: 'instructions_provided',
  sum_too_low: 'sum_too_low',
  sum_too_high: 'sum_too_high',
  refunded: 'refunded',
  extra_bank_info_required: 'extra_bank_info_required',
  redirected_to_inpay: 'redirected_to_inpay',
  returned_from_provider: 'returned_from_provider'
} as const;

export interface CollectionPaymentDetails {
  debtor_country?: string;
  debtor_bank_name?: string;
}

export interface CollectionPaymentFindOne {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
  order: CollectionOrderFromPayment;
  details?: CollectionPaymentDetails;
  status_history?: CollectionStatusHistoryItem[];
}

export interface CollectionPaymentFindByUuidOrReference {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
  order: CollectionOrderFromPayment;
}

export interface CollectionOrderFromPayment {
  uuid: Uuid;
  /** A unique identifier in your system for this Order */
  reference: string;
  debtor: Debtor;
  /** Status of your order */
  status: string;
  amount: Amount;
  /** The amount in minor units for the currency, computed as amount * 10 ** the currency decimal scale. For 2-decimal currencies this equals amount * 100 (cents). Until the storage widening lands, amounts with more than 2 decimals are rounded to 2 decimals on persist, so amount_cents follows that rounded value. */
  amount_cents: number;
  currency: CurrencyCode;
  created_at: CreatedAt;
}

export interface CollectionCountStatusReportsDataItem {
  code: string;
  name: string;
  count: number;
  items?: CollectionCountStatusReportsDataItemReasonCode[];
}

export interface CollectionCountStatusReportsDataItemReasonCode {
  code: string;
  name: string;
  id: number;
}

export interface ExternalCode {
  id: number;
  value: string;
  external_code_set_id: number;
}

export interface ProductSchemas {
  id: number;
  label: string;
}

export interface PaymentInstruments {
  local_instrument_family: string;
  products: ProductItems[];
}

export interface ProductItems {
  id: number;
  corridor: string;
  /** @nullable */
  v2_product_id?: number | null;
}

export type PayoutStateCategoryStatItemCode =
  (typeof PayoutStateCategoryStatItemCode)[keyof typeof PayoutStateCategoryStatItemCode];

export const PayoutStateCategoryStatItemCode = {
  received: 'received',
  pending: 'pending',
  action_required: 'action_required',
  processing: 'processing',
  rejected: 'rejected',
  completed: 'completed',
  returned: 'returned'
} as const;

export type PayoutStateCategoryStatItemName =
  (typeof PayoutStateCategoryStatItemName)[keyof typeof PayoutStateCategoryStatItemName];

export const PayoutStateCategoryStatItemName = {
  Received: 'Received',
  Pending: 'Pending',
  Action_required: 'Action required',
  Processing: 'Processing',
  Rejected: 'Rejected',
  Completed: 'Completed',
  Returned: 'Returned'
} as const;

export interface PayoutStateCategoryStatItem {
  code: PayoutStateCategoryStatItemCode;
  name: PayoutStateCategoryStatItemName;
  count: number;
}

export interface PayoutStateCategoryStatMeta {
  count: number;
}

export interface PayoutReasonCodeStats {
  /** Reason-code stats for payment requests in the action_required category.
category: action_required
code: awaiting_kyc_documents
description: pending additional KYC information to be provided
 */
  action_required: PayoutReasonCodeStatItem;
  completed: PayoutReasonCodeStatItem;
  pending: PayoutReasonCodeStatItem;
  processing: PayoutReasonCodeStatItem;
  received: PayoutReasonCodeStatItem;
  rejected: PayoutReasonCodeStatItem;
  returned: PayoutReasonCodeStatItem;
}

export interface PayoutReasonCodeStatItem {
  items: PayoutReasonCodeItem[];
  meta: PayoutReasonCodeStatMeta;
}

export interface PayoutReasonCodeStatMeta {
  count: number;
  percentage: number;
}

export interface PayoutReasonCodeItem {
  id: number;
  code: string;
  name: string;
  count: number;
  percentage: number;
}

export type CreditorAddressLines = string;

export type CreditorBirthdate = string;

export type CreditorCity = string;

export type CreditorCountryCode = string;

export type CreditorCreatedBy = string;

export type CreditorEmail = string;

export type CreditorFullName = string;

export type CreditorMobileNumber = string;

export type CreditorPostcode = string;

export type CreditorProductId = number;

export type CreditorSchemaId = number;

export interface CreditorKeyValuePair {
  key: string;
  value: string;
}

export interface CreditorWithDetails {
  id: number;
  address_lines?: CreditorAddressLines;
  birthdate?: CreditorBirthdate;
  city?: CreditorCity;
  country_code?: CreditorCountryCode;
  country_of_birth_code?: CreditorCountryCode;
  country_of_residence_code?: CreditorCountryCode;
  created_by: CreditorCreatedBy;
  creditor_type?: CreditorType;
  email?: CreditorEmail;
  full_name?: CreditorFullName;
  id_expiry_date?: IdExpiryDate;
  id_issuing_country_code?: IdIssuingCountryCode;
  id_issuing_date?: IdIssuingDate;
  id_number?: IdNumber;
  id_type?: IdType;
  mobile_number?: CreditorMobileNumber;
  postcode?: CreditorPostcode;
  state?: State;
  street_name?: StreetName;
  product_id?: CreditorProductId;
  schema_id?: CreditorSchemaId;
  creditor_details: CreditorKeyValuePair[];
}

export type IntegrationValidationErrorErrorDetailsOneOf = {
  [key: string]: string | string[];
};

/**
 * Map of field name to validation message(s). A value is either a single string or an array of strings depending on the source validator (dry-validation and ActiveModel `to_hash` yield arrays; ActiveModel `to_h` yields a string). For a nested request body (e.g. bulk_update's `values`) the value is itself a map of sub-field to message(s), mirroring the request structure.
 */
export type IntegrationValidationErrorErrorDetails = {
  [key: string]:
    | string
    | string[]
    | IntegrationValidationErrorErrorDetailsOneOf;
};

export type IntegrationValidationErrorError = {
  /** error code from engine */
  code: number;
  title: string;
  /** Map of field name to validation message(s). A value is either a single string or an array of strings depending on the source validator (dry-validation and ActiveModel `to_hash` yield arrays; ActiveModel `to_h` yields a string). For a nested request body (e.g. bulk_update's `values`) the value is itself a map of sub-field to message(s), mirroring the request structure. */
  details: IntegrationValidationErrorErrorDetails;
};

export interface IntegrationValidationError {
  error: IntegrationValidationErrorError;
}

export interface ErrorResponse {
  error: ValidationErrorInvalidUuid;
}

/**
 * @nullable
 */
export type ErrorGenericDetailsNilDetails = unknown | null;

export interface ErrorGenericDetailsNil {
  title: string;
  /** @nullable */
  details: ErrorGenericDetailsNilDetails;
}

export interface ErrorGenericDetailString {
  title: string;
  details: string;
}

export type ErrorGenericDetailObjectDetails = {
  status?: string;
};

export interface ErrorGenericDetailObject {
  /** error code from engine */
  code: number;
  title: string;
  details: ErrorGenericDetailObjectDetails;
}

export interface ImpersonationGrantErrorResponse {
  error: string;
}

export type ErrorAttributesAttributes = {
  content?: string;
};

export interface ErrorAttributes {
  attributes: ErrorAttributesAttributes;
}

export interface NoOrganisationMembershipError {
  errors: NoOrganisationMembershipErrorsItem[];
}

export interface NoOrganisationMembershipErrorsItem {
  title: string;
  details: string[];
}

export interface RefundNoAmountError {
  title: string;
  details: string;
}

export interface RefundBadAmountError {
  title: string;
  details: string;
}

export interface RefundNotConfiguredError {
  title: string;
  details: string;
}

export interface ErrorGenericWithCodeDetailObject {
  /** error code from engine */
  code: number;
  title: string;
  details: string;
}

export type ValidationErrorInvalidUuidDetails = {
  uuid?: string[];
};

export interface ValidationErrorInvalidUuid {
  /** error code from engine */
  code: number;
  title: string;
  details: ValidationErrorInvalidUuidDetails;
}

export type UnauthorizedErrorItem = {
  title: string;
};

export type UnauthorizedError = UnauthorizedErrorItem[];

export type BadBatchStatusErrorDetails = {
  batch_id: string[];
};

export interface BadBatchStatusError {
  code: number;
  title: string;
  details: BadBatchStatusErrorDetails;
}

export type BatchBadFilterErrorDetailsFilter = {
  kind: string[];
};

export type BatchBadFilterErrorDetails = {
  filter: BatchBadFilterErrorDetailsFilter;
};

export interface BatchBadFilterError {
  code: number;
  title: string;
  details: BatchBadFilterErrorDetails;
}

export interface BatchNotFoundError {
  title: string;
  details: string;
}

export interface UsersNotAuthorized {
  title: string;
}

export interface UserValidationError {
  /** error code from engine */
  code: number;
  title: string;
  details: UserValidationAttributes;
}

export interface UserValidationAttributes {
  first_name: string[];
  last_name: string[];
  email: string[];
  active: string[];
  role: string[];
}

export type PayoutDraftValidationErrorErrorItemSource = {
  pointer?: string;
};

export type PayoutDraftValidationErrorErrorItem = {
  title?: string;
  details: string[];
  source?: PayoutDraftValidationErrorErrorItemSource;
};

export interface PayoutDraftValidationError {
  error: PayoutDraftValidationErrorErrorItem[];
}

export type InternalAccountMovementErrorsDetailsOneOf = {
  [key: string]: string[];
};

export type InternalAccountMovementErrorsDetails =
  | InternalAccountMovementErrorsDetailsOneOf
  | string;

export interface InternalAccountMovementErrors {
  /** error code from engine */
  code?: number;
  title?: string;
  details?: InternalAccountMovementErrorsDetails;
}

export interface PayoutBatchData {
  filename: string;
  format: string;
  batch_id: number;
  content: string;
}

export type PayoutBatchMetaCurrency = {
  iso: string;
  name: string;
};

export type PayoutBatchMetaCountry = {
  iso: string;
  name: string;
};

export interface PayoutBatchMeta {
  local_instrument: string;
  total_payout_requests: number;
  total_payout_requests_amount: number;
  currency: PayoutBatchMetaCurrency;
  country: PayoutBatchMetaCountry;
}

export type PayoutBatchErrorsItemSource = {
  pointer: string;
};

export type PayoutBatchErrorsItem = {
  title: string;
  details: string[];
  source: PayoutBatchErrorsItemSource;
};

/**
 * @nullable
 */
export type PayoutBatchErrors = PayoutBatchErrorsItem[] | null;

/**
 * @nullable
 */
export type PayoutError = {
  details: string[];
  pointer: string;
} | null;

export interface PayoutBatchErrorData {
  filename: string;
  format: string;
  /** CSV file content with errors */
  content: string;
}

export type PayoutBatchErrorMetaCountry = {
  /** @nullable */
  iso?: string | null;
  /** @nullable */
  name?: string | null;
};

export type PayoutBatchErrorMetaCurrency = {
  /** @nullable */
  iso?: string | null;
  /** @nullable */
  name?: string | null;
};

export interface PayoutBatchErrorMeta {
  country: PayoutBatchErrorMetaCountry;
  currency: PayoutBatchErrorMetaCurrency;
  local_instrument: string;
}

export type AuthSchemeType =
  (typeof AuthSchemeType)[keyof typeof AuthSchemeType];

export const AuthSchemeType = {
  pkcs: 'pkcs',
  jwt: 'jwt'
} as const;

/**
 * Customer-facing auth scheme as returned from read endpoints (index / enable / disable). The raw `secret` is never present here — only `secret_preview` (masked) for PKCS schemes. The scope is implicit (always external_app on this surface) and therefore omitted from the payload.
 */
export interface AuthScheme {
  uuid: Uuid;
  name: string;
  /**
   * PEM-encoded certificate (PKCS with encryption) or RSA public key (JWT).
   * @nullable
   */
  certificate?: string | null;
  scopes: string[];
  enabled: boolean;
  created_at: CreatedAt;
  type: AuthSchemeType;
  /** Masked view of the shared secret (8 bullets + last 4 characters). Omitted entirely for JWT schemes which have no shared secret. */
  secret_preview?: string;
  /** Only present on the disable (DELETE) response. The https webhooks that were deactivated as part of disabling this scheme (PEGO-14645-auth-scheme-disable-cascade flag ON). Empty when no webhook depended on this scheme. */
  deactivated_hooks?: AuthSchemeDependentHook[];
  /** Only present on the disable (DELETE) response. The https webhooks the cascade could NOT deactivate — they are still active and still reference the now-disabled scheme, so their next delivery will fail and deactivate them. A failed webhook never blocks the disable (leaving the credential live is the worse failure); it is reported here so it can be dealt with deliberately. Empty on a clean cascade. */
  failed_hooks?: AuthSchemeFailedHook[];
  /** Only present on the enable (POST .../enable) response. The https webhooks that are currently inactive and reference this scheme's auth_uuid — enabling never reactivates them; the caller must reactivate deliberately. */
  inactive_hooks?: AuthSchemeDependentHook[];
}

/**
 * Minimal summary of a webhook affected by an auth scheme disable/enable action.
 */
export interface AuthSchemeDependentHook {
  uuid?: Uuid;
  active?: boolean;
}

/**
 * Field-keyed validation messages from the webhook that refused to save.
 */
export type AuthSchemeFailedHookDetails = { [key: string]: unknown };

/**
 * A webhook the disable cascade could not deactivate, with the reason it could not be saved.
 */
export interface AuthSchemeFailedHook {
  uuid?: Uuid;
  /** Short title of the underlying error. */
  reason?: string;
  /** Field-keyed validation messages from the webhook that refused to save. */
  details?: AuthSchemeFailedHookDetails;
}

export type AuthSchemeWithSecretType =
  (typeof AuthSchemeWithSecretType)[keyof typeof AuthSchemeWithSecretType];

export const AuthSchemeWithSecretType = {
  pkcs: 'pkcs',
  jwt: 'jwt'
} as const;

/**
 * Auth scheme returned at creation time (`POST /auth_schemes` and `POST /auth_schemes/sign`) — includes the raw `secret` exactly once. The raw secret is not recoverable after this response; clients must persist it immediately. The scope is implicit (always external_app on this surface) and therefore omitted from the payload.
 */
export interface AuthSchemeWithSecret {
  uuid: Uuid;
  name: string;
  /** @nullable */
  certificate?: string | null;
  scopes: string[];
  enabled: boolean;
  created_at: CreatedAt;
  type: AuthSchemeWithSecretType;
  /** Raw shared secret. Returned ONCE at creation time and never recoverable afterwards. Absent for JWT schemes which use a customer-provided public key instead. */
  secret?: string;
}

export type McpTokenStatus =
  (typeof McpTokenStatus)[keyof typeof McpTokenStatus];

export const McpTokenStatus = {
  active: 'active',
  revoked: 'revoked',
  expired: 'expired'
} as const;

/**
 * Customer-facing MCP token as returned from read endpoints (index / revoke). The raw token value is never present here — only `token_preview` (masked).
 */
export interface McpToken {
  uuid: Uuid;
  /** Display label. Not unique — revoke-and-recreate under the same name is supported. */
  name: string;
  /** Masked view of the token (8 bullets + last 4 characters). */
  token_preview: string;
  status: McpTokenStatus;
  /** Expiry timestamp, set at creation (90 days). */
  expires_at: string;
  created_at: CreatedAt;
}

export type McpTokenWithTokenStatus =
  (typeof McpTokenWithTokenStatus)[keyof typeof McpTokenWithTokenStatus];

export const McpTokenWithTokenStatus = {
  active: 'active',
  revoked: 'revoked',
  expired: 'expired'
} as const;

/**
 * MCP token returned at creation time (`POST /mcp_tokens`) — includes the raw `token` exactly once.
 */
export interface McpTokenWithToken {
  uuid: Uuid;
  name: string;
  /** Raw MCP token (`tenant_mcp_` prefix + 40 alphanumerics). Returned ONCE at creation time and not recoverable after this response; clients must persist it immediately. A retried create issues a new token — revoke any orphaned token or let it expire. */
  token: string;
  /** Masked view of the token (8 bullets + last 4 characters). */
  token_preview: string;
  status: McpTokenWithTokenStatus;
  /** Expiry timestamp, set at creation (90 days). */
  expires_at: string;
  created_at: CreatedAt;
}

/**
 * Customer-facing business unit. `default` is true for the BU currently set as the organisation default; the SPA uses this to highlight the default in the list.
 */
export interface IntegrationBusinessUnit {
  uuid: Uuid;
  name: string;
  default: boolean;
}

export type WebhookCreatorType =
  (typeof WebhookCreatorType)[keyof typeof WebhookCreatorType];

export const WebhookCreatorType = {
  'Admin::User': 'Admin::User',
  'Customer::User': 'Customer::User',
  'Customer::Organisation': 'Customer::Organisation'
} as const;

/**
 * Customer-facing webhook — a 1:1 mirror of a Notification::Hook, addressed by `uuid`. Only hooks on the `https` channel are returned; other channels (email, sftp, swift_gateway) are admin-managed and out of scope for the customer app until a dedicated management surface ships. `editable` is kept as a defense-in-depth flag — true only when the row is also in customer scope on format (json or iso_20022) and engine (disbursement or collection); a row failing that check is still returned, but read-only. `creator_id` is omitted (null) for `creator_type: Admin::User` — those hooks are administrator-managed; only `Customer::*` creators expose an id.

 */
export interface Webhook {
  uuid: Uuid;
  creator_type: WebhookCreatorType;
  /**
   * Id of the creator; null for Admin::User (administrator-managed hook).
   * @nullable
   */
  creator_id?: number | null;
  editable: boolean;
  business_unit_uuid: Uuid;
  business_unit_name: string;
  engine: string;
  event: string;
  /** Always `https` on the customer surface; other channels are admin-managed. */
  channel: string;
  /** json or iso_20022 on the customer surface; other values appear only on read-only (editable: false) admin-managed rows.
   */
  format: string;
  /** @nullable */
  destination_url?: string | null;
  /** @nullable */
  auth_uuid?: string | null;
  active: boolean;
  created_at: CreatedAt;
}

/**
 * Optional call-level fallback, applied to entries that name no format of their own. Prefer the per-entry `format`. When neither is given the event's own default applies — see `GET /webhooks/events`.

 */
export type WebhookCreateRequestFormat =
  (typeof WebhookCreateRequestFormat)[keyof typeof WebhookCreateRequestFormat];

export const WebhookCreateRequestFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookCreateRequestEventsItemOneOfFormat =
  (typeof WebhookCreateRequestEventsItemOneOfFormat)[keyof typeof WebhookCreateRequestEventsItemOneOfFormat];

export const WebhookCreateRequestEventsItemOneOfFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookCreateRequestEventsItemOneOf = {
  event: string;
  format?: WebhookCreateRequestEventsItemOneOfFormat;
};

export type WebhookCreateRequestEventsItem =
  | string
  | WebhookCreateRequestEventsItemOneOf;

export interface WebhookCreateRequest {
  destination_url: string;
  /** Optional; defaults to the org's default business unit. */
  business_unit_uuid?: string;
  /** Required; an external_app-scoped auth scheme of the current organisation. */
  auth_uuid: string;
  /** Optional call-level fallback, applied to entries that name no format of their own. Prefer the per-entry `format`. When neither is given the event's own default applies — see `GET /webhooks/events`.
   */
  format?: WebhookCreateRequestFormat;
  /** Each entry is either an object `{event, format?}` or a bare event-name string, which is equivalent to `{event: "<name>"}`. Both shapes may be mixed in one array. `format` resolves per entry as: entry `format` → call-level `format` → the event's `default_format`. Since `format` is part of a subscription's identity, the same event may appear twice with two different formats to create two hooks. An entry naming an unknown event, or a format the event does not publish, does not fail the call — it comes back in `rejected`.
   */
  events: WebhookCreateRequestEventsItem[];
}

export type WebhookCreateResponseConflictsItemReason =
  (typeof WebhookCreateResponseConflictsItemReason)[keyof typeof WebhookCreateResponseConflictsItemReason];

export const WebhookCreateResponseConflictsItemReason = {
  already_active: 'already_active',
  inactive_exists: 'inactive_exists'
} as const;

export type WebhookCreateResponseConflictsItem = {
  event?: string;
  uuid?: Uuid;
  reason?: WebhookCreateResponseConflictsItemReason;
};

export type WebhookCreateResponseRejectedItemReason =
  (typeof WebhookCreateResponseRejectedItemReason)[keyof typeof WebhookCreateResponseRejectedItemReason];

export const WebhookCreateResponseRejectedItemReason = {
  unknown_event: 'unknown_event',
  format_not_supported_for_event: 'format_not_supported_for_event'
} as const;

export type WebhookCreateResponseRejectedItem = {
  event: string;
  /**
   * The format that was attempted; null when none was resolved.
   * @nullable
   */
  format: string | null;
  reason: WebhookCreateResponseRejectedItemReason;
};

export interface WebhookCreateResponse {
  data: Webhook[];
  /** One entry per event that already had a matching subscription (engine, event, url, auth_uuid, format). reason inactive_exists → FE offers reactivate via PATCH /webhooks/:uuid {active:true}; already_active → nothing to do.
   */
  conflicts: WebhookCreateResponseConflictsItem[];
  /** One entry per requested event that could not be subscribed. Sits beside `conflicts` rather than replacing it: a conflict is an existing subscription, a rejection is an unusable request entry. Neither is fatal — the remaining entries are still created, and the status is 201 whenever anything was created (200 when nothing was). `reason` is a stable, machine-readable value the FE can branch on for per-row copy: unknown_event → the event name is not in the registry, or belongs to an engine outside the customer surface (check for a typo); format_not_supported_for_event → the event does not publish in the requested format (see `GET /webhooks/events` for what it does publish).
   */
  rejected: WebhookCreateResponseRejectedItem[];
}

export type WebhookUpdateRequestFormat =
  (typeof WebhookUpdateRequestFormat)[keyof typeof WebhookUpdateRequestFormat];

export const WebhookUpdateRequestFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export interface WebhookUpdateRequest {
  destination_url?: string;
  auth_uuid?: string;
  active?: boolean;
  /** Move the hook to another BU within the same organisation. */
  business_unit_uuid?: string;
  format?: WebhookUpdateRequestFormat;
}

export type WebhookBulkUpdateRequestValuesFormat =
  (typeof WebhookBulkUpdateRequestValuesFormat)[keyof typeof WebhookBulkUpdateRequestValuesFormat];

export const WebhookBulkUpdateRequestValuesFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookBulkUpdateRequestValues = {
  destination_url?: string;
  auth_uuid?: string;
  active?: boolean;
  business_unit_uuid?: string;
  format?: WebhookBulkUpdateRequestValuesFormat;
};

export interface WebhookBulkUpdateRequest {
  uuids: Uuid[];
  values: WebhookBulkUpdateRequestValues;
}

export type WebhookBulkUpdateResponseDataItemStatus =
  (typeof WebhookBulkUpdateResponseDataItemStatus)[keyof typeof WebhookBulkUpdateResponseDataItemStatus];

export const WebhookBulkUpdateResponseDataItemStatus = {
  succeeded: 'succeeded',
  failed: 'failed'
} as const;

export type WebhookBulkUpdateResponseDataItemErrorDetailsOneOf = {
  [key: string]: string[];
};

export type WebhookBulkUpdateResponseDataItemErrorDetails =
  | string
  | WebhookBulkUpdateResponseDataItemErrorDetailsOneOf;

/**
 * Present only when status is failed. details is either a short reason string (e.g. not_found, not_editable) or a map of field to message(s), mirroring the per-uuid validation failure.

 * @nullable
 */
export type WebhookBulkUpdateResponseDataItemError = {
  details?: WebhookBulkUpdateResponseDataItemErrorDetails;
} | null;

export type WebhookBulkUpdateResponseDataItem = {
  uuid: Uuid;
  status: WebhookBulkUpdateResponseDataItemStatus;
  hook?: Webhook;
  /**
   * Present only when status is failed. details is either a short reason string (e.g. not_found, not_editable) or a map of field to message(s), mirroring the per-uuid validation failure.

   * @nullable
   */
  error?: WebhookBulkUpdateResponseDataItemError;
};

export interface WebhookBulkUpdateResponse {
  data: WebhookBulkUpdateResponseDataItem[];
}

export type WebhookEventEngine =
  (typeof WebhookEventEngine)[keyof typeof WebhookEventEngine];

export const WebhookEventEngine = {
  disbursement: 'disbursement',
  collection: 'collection'
} as const;

export type WebhookEventFormatsItem =
  (typeof WebhookEventFormatsItem)[keyof typeof WebhookEventFormatsItem];

export const WebhookEventFormatsItem = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

/**
 * The format POST /webhooks applies to this event when the request names none. Not always json — payment_request_batch_processed publishes only iso_20022.

 */
export type WebhookEventDefaultFormat =
  (typeof WebhookEventDefaultFormat)[keyof typeof WebhookEventDefaultFormat];

export const WebhookEventDefaultFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

/**
 * One subscribable event on the customer webhook surface. This is the authoritative list — the set of event names POST /webhooks accepts, and the formats each one publishes. Only events on the https channel belonging to an in-scope engine (disbursement, collection) appear; email-only events and other engines are omitted.

 */
export interface WebhookEvent {
  engine: WebhookEventEngine;
  event: string;
  /** Every format this event publishes, in registry order. Most events have exactly one, so a picker is only meaningful where this has more than one entry.
   */
  formats: WebhookEventFormatsItem[];
  /** The format POST /webhooks applies to this event when the request names none. Not always json — payment_request_batch_processed publishes only iso_20022.
   */
  default_format: WebhookEventDefaultFormat;
}

export interface WebhookEventsResponse {
  /** Sorted by (engine, event). */
  data: WebhookEvent[];
}

export interface WebhookResponse {
  data: Webhook;
}

export type PostAuthenticationImpersonationsExchangeBody = {
  code: string;
};

export type GetAuthenticationMcpTokensIntrospection200ScopesItem =
  (typeof GetAuthenticationMcpTokensIntrospection200ScopesItem)[keyof typeof GetAuthenticationMcpTokensIntrospection200ScopesItem];

export const GetAuthenticationMcpTokensIntrospection200ScopesItem = {
  'mcp:onboarding': 'mcp:onboarding'
} as const;

export type GetAuthenticationMcpTokensIntrospection200 = {
  organisation_id: number;
  scopes: GetAuthenticationMcpTokensIntrospection200ScopesItem[];
  expires_at: string;
};

export type GetAuthenticationMcpTokensIntrospection401ErrorsItemTitle =
  (typeof GetAuthenticationMcpTokensIntrospection401ErrorsItemTitle)[keyof typeof GetAuthenticationMcpTokensIntrospection401ErrorsItemTitle];

export const GetAuthenticationMcpTokensIntrospection401ErrorsItemTitle = {
  Not_authorized: 'Not authorized'
} as const;

export type GetAuthenticationMcpTokensIntrospection401ErrorsItemDetailsItem =
  (typeof GetAuthenticationMcpTokensIntrospection401ErrorsItemDetailsItem)[keyof typeof GetAuthenticationMcpTokensIntrospection401ErrorsItemDetailsItem];

export const GetAuthenticationMcpTokensIntrospection401ErrorsItemDetailsItem = {
  missing_token: 'missing_token',
  unknown_token: 'unknown_token',
  revoked_token: 'revoked_token',
  expired_token: 'expired_token'
} as const;

export type GetAuthenticationMcpTokensIntrospection401ErrorsItem = {
  title: GetAuthenticationMcpTokensIntrospection401ErrorsItemTitle;
  details: GetAuthenticationMcpTokensIntrospection401ErrorsItemDetailsItem[];
};

export type GetAuthenticationMcpTokensIntrospection401 = {
  errors: GetAuthenticationMcpTokensIntrospection401ErrorsItem[];
};

export type PostAuthenticationMfaRequestSms200 = {
  message?: string;
};

export type PostAuthenticationMfaRequestSms422 = {
  error?: string;
};

export type PostAuthenticationMfaVerifySmsBody = {
  auth_payload: string;
};

export type PostAuthenticationMfaVerifySms200Data = {
  access_token?: string;
  refresh_token?: string;
};

export type PostAuthenticationMfaVerifySms200 = {
  data?: PostAuthenticationMfaVerifySms200Data;
};

export type PostAuthenticationMfaVerifySms422 = {
  error?: string;
};

export type GetAuthenticationMfaRequestTotpFactor200 = {
  data?: string;
};

export type GetAuthenticationMfaRequestTotpFactor401 = {
  error?: string;
};

export type GetAuthenticationMfaRequestTotpFactor422 = {
  error?: string;
};

export type PostAuthenticationMfaValidateTotpFactorBody = {
  auth_payload: string;
};

export type PostAuthenticationMfaValidateTotpFactor200Data = {
  access_token?: string;
  refresh_token?: string;
};

export type PostAuthenticationMfaValidateTotpFactor200 = {
  data?: PostAuthenticationMfaValidateTotpFactor200Data;
};

export type PostAuthenticationMfaValidateTotpFactor422 = {
  error?: string;
};

export type PostAuthenticationMfaVerifyTotpFactorBody = {
  auth_payload: string;
};

export type PostAuthenticationMfaVerifyTotpFactor200Data = {
  access_token?: string;
  refresh_token?: string;
};

export type PostAuthenticationMfaVerifyTotpFactor200 = {
  data?: PostAuthenticationMfaVerifyTotpFactor200Data;
};

export type PostAuthenticationMfaVerifyTotpFactor422 = {
  error?: string;
};

export type GetCollectionFundingInstructions200 = {
  data?: FundingConfigurations;
};

export type PutCollectionFundingInstructionsAccountNumberAcceptChangesBody = {
  configuration_uuid: string;
};

export type PutCollectionFundingInstructionsAccountNumberAcceptChanges200 = {
  data?: AcceptedFundingConfiguration;
};

export type PutCollectionFundingInstructionsAccountNumberAcceptChanges422 = {
  error?: ValidationErrorInvalidUuid;
};

export type PostCollectionOrderReportsBody = {
  virtual_account_number?: string;
  /** Date */
  created_after: string;
  /** Date */
  created_before: string;
  /** Order status filter */
  status?: string;
  reason_code_id?: number;
};

export type PostCollectionOrderReports200 = {
  data?: OrderReportUuid;
};

export type PostCollectionOrderReports404Error = { [key: string]: unknown };

export type PostCollectionOrderReports404 = {
  error?: PostCollectionOrderReports404Error;
};

export type PostCollectionOrderReports422Error = { [key: string]: unknown };

export type PostCollectionOrderReports422 = {
  error?: PostCollectionOrderReports422Error;
};

export type GetCollectionOrderReportsParams = {
  'filter[virtual_account_number]'?: string;
  'filter[date_from]'?: string;
  'filter[date_to]'?: string;
  'page[cursor_after]'?: string;
  'page[cursor_before]'?: string;
};

export type GetCollectionOrderReports200 = {
  data?: OrderReports[];
  meta?: TotalCountPagination;
};

export type GetCollectionOrderReportsUuid200 = {
  data?: OrderReport;
};

export type GetCollectionOrderReportsUuid404Error = { [key: string]: unknown };

export type GetCollectionOrderReportsUuid404 = {
  error?: GetCollectionOrderReportsUuid404Error;
};

export type DeleteCollectionOrdersUuid200 = {
  data?: CancelOrderReturnType;
};

export type GetCollectionOrdersUuid200 = {
  data?: CollectionOrderFindOne;
};

export type GetCollectionOrdersFindByUuidOrExternalReferenceParams = {
  /**
   * Search reference / Order UUID
   */
  search_reference: string;
  /**
   * Start Date
   */
  start_date: string;
  /**
   * End Date
   */
  end_date: string;
};

export type GetCollectionOrdersFindByUuidOrExternalReference200 = {
  data?: Order;
};

export type GetCollectionOrdersParams = {
  /**
   * Filter by date
   */
  created_after?: string;
  /**
   * Filter by date
   */
  created_before?: string;
  /**
   * Find by status category
   */
  status?: string;
  /**
   * Find by virtual account number
   */
  virtual_account_number?: string;
  /**
   * Cursor after
   */
  'meta[cursor_after]'?: string;
  /**
   * Cursor before
   */
  'meta[cursor_before]'?: string;
  /**
   * Sort param. Sort by -date is default
   */
  'meta[sort]'?: string;
  /**
   * Plain cursor
   */
  'meta[plain_cursor]'?: string;
  /**
   * Include cursor
   */
  'meta[include_cursor]'?: boolean;
  /**
   * Page size
   */
  'meta[page_size]'?: number;
  /**
   * Default page size
   */
  'meta[page_size_default]'?: number;
};

export type GetCollectionOrders200 = {
  data?: Order[];
  meta?: OrdersIndexPagination;
};

export type PostCollectionOrdersUuidRefundBody = {
  amount: string;
};

export type PostCollectionOrdersUuidRefund200 = {
  data?: Success;
};

export type PostCollectionOrdersUuidRefund422 = {
  error?: RefundNotConfiguredError;
};

export type GetCollectionPaymentsFindByUuidOrUniqueReferenceParams = {
  /**
   * Search reference / Payment UUID
   */
  search_reference: string;
  /**
   * Start Date
   */
  start_date: string;
  /**
   * End Date
   */
  end_date: string;
};

export type GetCollectionPaymentsFindByUuidOrUniqueReference200 = {
  data?: CollectionPaymentFindByUuidOrReference;
};

export type GetCollectionPaymentsUuid200 = {
  data?: CollectionPaymentFindOne;
};

export type GetCollectionStatsOrdersStatusCountsReportsParams = {
  /**
   * Filter by date
   */
  created_after: string;
  /**
   * Filter by date
   */
  created_before?: string;
};

export type GetCollectionStatsOrdersStatusCountsReports200 = {
  data?: CollectionCountStatusReportsDataItem[];
  count?: number;
};

export type GetCoreCountries200DataItem = {
  id: number;
  iso: string;
  name: string;
};

export type GetCoreCountries200 = {
  data: GetCoreCountries200DataItem[];
};

export type GetCoreCountries422Error = {
  code: number;
  title: string;
  details: string;
};

export type GetCoreCountries422 = {
  error: GetCoreCountries422Error;
};

export type GetCryptoBalancesParams = {
  /**
   * Virtual account number. Required for c2c-backed organisations; ignored for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoBalances200DataBalancesItem = {
  asset?: string;
  balance?: number;
  formatted_balance?: string;
};

export type GetCryptoBalances200DataBalancesByNetworkItem = {
  asset?: string;
  network?: string;
  balance?: number;
  formatted_balance?: string;
};

export type GetCryptoBalances200Data = {
  balances?: GetCryptoBalances200DataBalancesItem[];
  balances_by_network?: GetCryptoBalances200DataBalancesByNetworkItem[];
};

export type GetCryptoBalances200 = {
  data?: GetCryptoBalances200Data;
};

export type GetCryptoBalances401ErrorsItem = {
  title: string;
};

export type GetCryptoBalances401 = {
  errors: GetCryptoBalances401ErrorsItem[];
};

export type GetCryptoDepositAddressesParams = {
  /**
   * Crypto asset to get the deposit address for
   */
  asset: string;
  /**
   * Network the deposit address is on. For c2c-backed organisations this is the adapter network key (e.g. ERC20 or TRC20); for layer1 it is the internal network name (e.g. ETHEREUM).
   */
  network: string;
  /**
   * Virtual account whose funding instructions scope the address. Required for c2c; optional for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoDepositAddresses200 = {
  asset?: string;
  network?: string;
  /** @nullable */
  address?: string | null;
};

export type GetCryptoDepositAddresses401ErrorsItem = {
  title: string;
};

export type GetCryptoDepositAddresses401 = {
  errors: GetCryptoDepositAddresses401ErrorsItem[];
};

export type GetCryptoDepositFromCurrenciesParams = {
  /**
   * Virtual account number. Required for c2c-backed organisations; ignored for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoDepositFromCurrencies200DataCurrenciesItemNetworksItem = {
  /** @nullable */
  protocol?: string | null;
  network?: string;
};

export type GetCryptoDepositFromCurrencies200DataCurrenciesItem = {
  asset?: string;
  /** @nullable */
  name?: string | null;
  networks?: GetCryptoDepositFromCurrencies200DataCurrenciesItemNetworksItem[];
};

export type GetCryptoDepositFromCurrencies200Data = {
  currencies?: GetCryptoDepositFromCurrencies200DataCurrenciesItem[];
};

export type GetCryptoDepositFromCurrencies200 = {
  data?: GetCryptoDepositFromCurrencies200Data;
};

export type GetCryptoDepositFromCurrencies401ErrorsItem = {
  title: string;
};

export type GetCryptoDepositFromCurrencies401 = {
  errors: GetCryptoDepositFromCurrencies401ErrorsItem[];
};

export type GetCryptoDepositFromNetworksParams = {
  /**
   * Virtual account number. Required for c2c-backed organisations; ignored for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoDepositFromNetworks200DataNetworksItem = {
  asset?: string;
  network?: string;
  /** @nullable */
  protocol?: string | null;
};

export type GetCryptoDepositFromNetworks200Data = {
  networks?: GetCryptoDepositFromNetworks200DataNetworksItem[];
};

export type GetCryptoDepositFromNetworks200 = {
  data?: GetCryptoDepositFromNetworks200Data;
};

export type GetCryptoDepositFromNetworks401ErrorsItem = {
  title: string;
};

export type GetCryptoDepositFromNetworks401 = {
  errors: GetCryptoDepositFromNetworks401ErrorsItem[];
};

export type GetCryptoDepositsParams = {
  /**
   * Forward pagination cursor returned from a previous request
   */
  cursor_after?: string;
  /**
   * Backward pagination cursor returned from a previous request
   */
  cursor_before?: string;
  /**
   * Number of results per page
   */
  per_page?: number;
  /**
   * Funding virtual bank account the history is scoped to (required for c2c)
   */
  virtual_account_number?: string;
};

export type GetCryptoDeposits200DataItemSourcesItem = {
  address?: string;
  amount?: string;
};

export type GetCryptoDeposits200DataItemStatusHistoryItem = {
  status?: string;
  timestamp?: string;
};

export type GetCryptoDeposits200DataItem = {
  id?: number;
  layer1_deposit_id?: string;
  data_digest?: string;
  status: string;
  asset: string;
  amount: number;
  formatted_amount?: string;
  network?: string;
  deposit_address?: string;
  from_address?: string;
  /** @nullable */
  sources?: GetCryptoDeposits200DataItemSourcesItem[] | null;
  layer1_customer_id?: string;
  organisation_id?: number;
  reference?: string;
  tx_hash?: string;
  /** @nullable */
  failure_reason?: string | null;
  /** @nullable */
  failure_message?: string | null;
  /** @nullable */
  currency_type?: string | null;
  /** @nullable */
  credit_type?: string | null;
  layer1_created_at: string;
  layer1_updated_at?: string;
  received_webhook_id?: number;
  created_at?: string;
  updated_at?: string;
  status_history?: GetCryptoDeposits200DataItemStatusHistoryItem[];
};

export type GetCryptoDeposits200Meta = {
  per_page?: number;
  total?: number;
  /** @nullable */
  cursor_next?: string | null;
  /** @nullable */
  cursor_prev?: string | null;
  has_next_page?: boolean;
  has_prev_page?: boolean;
};

export type GetCryptoDeposits200 = {
  data?: GetCryptoDeposits200DataItem[];
  meta?: GetCryptoDeposits200Meta;
};

export type GetCryptoDeposits401ErrorsItem = {
  title: string;
};

export type GetCryptoDeposits401 = {
  errors: GetCryptoDeposits401ErrorsItem[];
};

export type GetCryptoDeposits422Error = {
  title?: string;
  details?: string;
};

export type GetCryptoDeposits422 = {
  error?: GetCryptoDeposits422Error;
};

export type GetCryptoEligibleVbasParams = {
  /**
   * Crypto asset the accounts must be receivable from, e.g. USDT. When omitted, accounts receivable from any asset are returned
   */
  asset?: string;
};

export type GetCryptoEligibleVbas200Data = {
  vbas?: string[];
  /**
   * Account the widget opens on: the only eligible one, else the latest created. Null when no account is eligible
   * @nullable
   */
  default_vba?: string | null;
};

export type GetCryptoEligibleVbas200 = {
  data?: GetCryptoEligibleVbas200Data;
};

export type GetCryptoEligibleVbas401ErrorsItem = {
  title: string;
};

export type GetCryptoEligibleVbas401 = {
  errors: GetCryptoEligibleVbas401ErrorsItem[];
};

export type GetCryptoExchangeFromCurrenciesParams = {
  /**
   * Selected virtual account number. Required for c2c; used to fetch Layer1 trade limits.
   */
  virtual_account_number?: string;
};

export type GetCryptoExchangeFromCurrencies200DataCurrenciesItemNetworksItem = {
  protocol?: string;
  network?: string;
};

export type GetCryptoExchangeFromCurrencies200DataCurrenciesItem = {
  asset?: string;
  name?: string;
  /** @nullable */
  min_amount?: string | null;
  /** @nullable */
  max_amount?: string | null;
  networks?: GetCryptoExchangeFromCurrencies200DataCurrenciesItemNetworksItem[];
};

export type GetCryptoExchangeFromCurrencies200Data = {
  currencies?: GetCryptoExchangeFromCurrencies200DataCurrenciesItem[];
};

export type GetCryptoExchangeFromCurrencies200 = {
  data?: GetCryptoExchangeFromCurrencies200Data;
};

export type GetCryptoExchangeFromCurrencies401ErrorsItem = {
  title: string;
};

export type GetCryptoExchangeFromCurrencies401 = {
  errors: GetCryptoExchangeFromCurrencies401ErrorsItem[];
};

export type GetCryptoExchangeFromNetworksParams = {
  /**
   * Virtual account number. Required for c2c-backed organisations; ignored for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoExchangeFromNetworks200DataNetworksItem = {
  asset?: string;
  network?: string;
  /** @nullable */
  protocol?: string | null;
  balance?: number;
  formatted_balance?: string;
};

export type GetCryptoExchangeFromNetworks200Data = {
  networks?: GetCryptoExchangeFromNetworks200DataNetworksItem[];
};

export type GetCryptoExchangeFromNetworks200 = {
  data?: GetCryptoExchangeFromNetworks200Data;
};

export type GetCryptoExchangeFromNetworks401ErrorsItem = {
  title: string;
};

export type GetCryptoExchangeFromNetworks401 = {
  errors: GetCryptoExchangeFromNetworks401ErrorsItem[];
};

export type GetCryptoExchangeRatesParams = {
  /**
   * Currency pair, e.g. USDC_EUR
   */
  pair: string;
  /**
   * Amount of crypto to exchange
   */
  amount: string;
  /**
   * Virtual account number. Required for c2c-backed organisations; ignored for layer1.
   */
  virtual_account_number?: string;
};

export type GetCryptoExchangeRates200 = {
  quote_price?: string;
  vwap?: string;
  proceeds?: string;
  total_available_depth?: string;
  max_amount?: string;
  transaction_fee?: string;
  fetched_at?: number;
  expiry_at?: number;
  /** Unix timestamp when the crypto service allows the next quote refresh. */
  refresh_at?: number;
  quote_uuid?: string;
  proceeds_after_fx_markup?: string;
  fx_markup?: string;
};

export type GetCryptoExchangeRates401ErrorsItem = {
  title: string;
};

export type GetCryptoExchangeRates401 = {
  errors: GetCryptoExchangeRates401ErrorsItem[];
};

export type GetCryptoExchangeRates422 = {
  error?: string;
};

export type GetCryptoExchangesParams = {
  /**
   * Number of results per page
   */
  per_page?: number;
  /**
   * Forward pagination cursor returned from a previous request
   */
  cursor_after?: string;
  /**
   * Backward pagination cursor returned from a previous request
   */
  cursor_before?: string;
  /**
   * Funding virtual bank account the history is scoped to (required for c2c)
   */
  virtual_account_number?: string;
};

export type GetCryptoExchanges200DataItemStatusHistoriesItem = {
  status?: string;
  created_at?: string;
};

export type GetCryptoExchanges200DataItem = {
  id?: number;
  organisation_id?: number;
  from_currency?: string;
  from_network?: string;
  from_amount?: number;
  to_currency?: string;
  to_amount?: number;
  /** @nullable */
  to_network?: string | null;
  rate?: number;
  virtual_bank_account?: string;
  created_at?: string;
  updated_at?: string;
  formatted_from_amount?: string;
  formatted_to_amount?: string;
  status_histories?: GetCryptoExchanges200DataItemStatusHistoriesItem[];
};

export type GetCryptoExchanges200Meta = {
  per_page?: number;
  total?: number;
  /** @nullable */
  cursor_next?: string | null;
  /** @nullable */
  cursor_prev?: string | null;
  has_next_page?: boolean;
  has_prev_page?: boolean;
};

export type GetCryptoExchanges200 = {
  data?: GetCryptoExchanges200DataItem[];
  meta?: GetCryptoExchanges200Meta;
};

export type GetCryptoExchanges401ErrorsItem = {
  title: string;
};

export type GetCryptoExchanges401 = {
  errors: GetCryptoExchanges401ErrorsItem[];
};

export type GetCryptoExchanges422 = {
  error?: string;
};

export type PostCryptoExchangesBody = {
  quote_uuid: string;
  virtual_account_number: string;
};

export type PostCryptoExchanges200 = {
  success?: boolean;
};

export type PostCryptoExchanges401ErrorsItem = {
  title: string;
};

export type PostCryptoExchanges401 = {
  errors: PostCryptoExchanges401ErrorsItem[];
};

export type PostCryptoExchanges422 = {
  error?: string;
};

export type GetCryptoBigedirectTokenParams = {
  /**
   * Virtual account number
   */
  virtual_account_number: string;
};

export type GetCryptoBigedirectToken200 = {
  data?: string;
};

export type GetCryptoBigedirectToken401ErrorsItem = {
  title?: string;
};

export type GetCryptoBigedirectToken401 = {
  errors?: GetCryptoBigedirectToken401ErrorsItem[];
};

export type GetCryptoBigedirectToken422Error = {
  code?: number;
  title?: string;
  details?: string;
};

export type GetCryptoBigedirectToken422 = {
  error?: GetCryptoBigedirectToken422Error;
};

export type GetCryptoC2cTokenParams = {
  /**
   * Virtual account number
   */
  virtual_account_number: string;
};

export type GetCryptoC2cToken200 = {
  data?: string;
};

export type GetCryptoC2cToken401ErrorsItem = {
  title?: string;
};

export type GetCryptoC2cToken401 = {
  errors?: GetCryptoC2cToken401ErrorsItem[];
};

export type GetCryptoC2cToken422Error = {
  code?: number;
  title?: string;
  details?: string;
};

export type GetCryptoC2cToken422 = {
  error?: GetCryptoC2cToken422Error;
};

export type GetCryptoTransactionsParams = {
  /**
   * Forward pagination cursor returned from a previous request
   */
  cursor_after?: string;
  /**
   * Backward pagination cursor returned from a previous request
   */
  cursor_before?: string;
  /**
   * Number of results per page
   */
  per_page?: number;
};

export type GetCryptoTransactions200DataItem = {
  type?: string;
  display_type?: string;
  record_uuid?: string;
  display_at?: string;
  status?: string;
  /** @nullable */
  layer1_created_at?: string | null;
  /** @nullable */
  asset?: string | null;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  formatted_amount?: string | null;
  /** @nullable */
  network?: string | null;
  /** @nullable */
  deposit_address?: string | null;
  /** @nullable */
  from_address?: string | null;
  /** @nullable */
  tx_hash?: string | null;
  /** @nullable */
  created_at?: string | null;
  /** @nullable */
  from_currency?: string | null;
  /** @nullable */
  from_network?: string | null;
  /** @nullable */
  from_amount?: number | null;
  /** @nullable */
  formatted_from_amount?: string | null;
  /** @nullable */
  to_currency?: string | null;
  /** @nullable */
  to_amount?: number | null;
  /** @nullable */
  formatted_to_amount?: string | null;
  /** @nullable */
  rate?: number | null;
};

export type GetCryptoTransactions200Meta = {
  per_page?: number;
  total?: number;
  /** @nullable */
  cursor_next?: string | null;
  /** @nullable */
  cursor_prev?: string | null;
  has_next_page?: boolean;
  has_prev_page?: boolean;
};

export type GetCryptoTransactions200 = {
  data?: GetCryptoTransactions200DataItem[];
  meta?: GetCryptoTransactions200Meta;
};

export type GetCryptoTransactions401ErrorsItem = {
  title: string;
};

export type GetCryptoTransactions401 = {
  errors: GetCryptoTransactions401ErrorsItem[];
};

export type GetCryptoTransactions422 = {
  error?: string;
};

export type GetCustomerAddress200 = {
  data?: Address;
};

export type GetCustomerBusinessUnits200 = {
  data?: BusinessUnit[];
};

export type GetCustomerConfigurations200 = {
  data?: Configuration;
};

export type GetCustomerContractedProducts200Meta = {
  collection_products_count?: number;
  payout_products_count?: number;
};

export type GetCustomerContractedProducts200Data = {
  payout_products?: CustomerAppContractedProducts[];
  collection_products?: CustomerAppContractedProducts[];
};

export type GetCustomerContractedProducts200 = {
  meta?: GetCustomerContractedProducts200Meta;
  data?: GetCustomerContractedProducts200Data;
};

export type GetCustomerCreditorsId200 = {
  data?: CreditorWithDetails;
};

export type DeleteCustomerCreditorsId200 = {
  data?: CreditorWithDetails;
};

export type PostCustomerCreditorsValidateBodyCreditor = {
  [key: string]: unknown;
};

export type PostCustomerCreditorsValidateBodyCreditorAccount = {
  [key: string]: unknown;
};

export type PostCustomerCreditorsValidateBodyIntermediaryAgent = {
  [key: string]: unknown;
};

export type PostCustomerCreditorsValidateBodyIntermediaryAgentAccount = {
  [key: string]: unknown;
};

export type PostCustomerCreditorsValidateBody = {
  schema_id: number;
  product_id: number;
  creditor?: PostCustomerCreditorsValidateBodyCreditor;
  creditor_account?: PostCustomerCreditorsValidateBodyCreditorAccount;
  intermediary_agent?: PostCustomerCreditorsValidateBodyIntermediaryAgent;
  intermediary_agent_account?: PostCustomerCreditorsValidateBodyIntermediaryAgentAccount;
};

export type GetCustomerCreditorsParams = {
  /**
   * Product ID
   */
  product_id?: number;
  /**
   * Schema ID
   */
  schema_id?: number;
  /**
   * Cursor next
   */
  cursor_next?: string;
  /**
   * Cursor prev
   */
  cursor_prev?: string;
  /**
   * Sort param. Sort by -date is default
   */
  sort?: string;
  /**
   * Page size
   */
  page_size?: string;
};

export type GetCustomerCreditors200 = {
  data?: CreditorWithDetails[];
  meta?: Pagination;
};

export type PostCustomerCreditorsBodyCreditor = {
  address_lines?: CreditorAddressLines;
  birthdate?: CreditorBirthdate;
  city?: CreditorCity;
  country_code?: CreditorCountryCode;
  country_of_birth_code?: CreditorCountryCode;
  country_of_residence_code?: CreditorCountryCode;
  creditor_type?: CreditorType;
  email?: CreditorEmail;
  full_name?: CreditorFullName;
  id_expiry_date?: IdExpiryDate;
  id_issuing_country_code?: IdIssuingCountryCode;
  id_issuing_date?: IdIssuingDate;
  id_number?: IdNumber;
  id_type?: IdType;
  mobile_number?: CreditorMobileNumber;
  postcode?: CreditorPostcode;
  state?: State;
  street_name?: StreetName;
  product_id?: CreditorProductId;
  schema_id?: CreditorSchemaId;
  creditor_details?: CreditorKeyValuePair[];
};

export type PostCustomerCreditorsBody = {
  creditor?: PostCustomerCreditorsBodyCreditor;
};

export type PostCustomerCreditors200 = {
  data?: CreditorWithDetails;
};

export type GetCustomerOrganisations200 = {
  organisations: CustomerUserOrganisation[];
};

export type GetCustomerRoles200 = {
  data?: Role[];
};

export type GetCustomerUsers200 = {
  data?: UserItem[];
};

export type GetCustomerUsers401 = {
  errors?: UsersNotAuthorized[];
};

export type PostCustomerUsersBodyData = {
  first_name: string;
  last_name: string;
  email: string;
  role: string;
};

export type PostCustomerUsersBody = {
  data?: PostCustomerUsersBodyData;
};

export type PostCustomerUsers200 = {
  data?: User;
};

export type PostCustomerUsers401 = {
  errors?: UsersNotAuthorized[];
};

export type PostCustomerUsers422 = {
  data?: UserValidationError;
};

export type GetCustomerUsersUserId200 = {
  data?: User;
};

export type GetCustomerUsersUserId401 = {
  errors?: UsersNotAuthorized[];
};

export type PutCustomerUsersUserIdBodyData = {
  first_name: string;
  last_name: string;
  email: string;
  role?: string;
  active?: boolean;
};

export type PutCustomerUsersUserIdBody = {
  data?: PutCustomerUsersUserIdBodyData;
};

export type PutCustomerUsersUserId200 = {
  data?: User;
};

export type PutCustomerUsersUserId401 = {
  errors?: UnauthorizedError;
};

export type PutCustomerUsersUserId422 = {
  errors?: UserValidationError;
};

export type GetCustomerCurrentUser200User = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  mfa_enabled: boolean;
  mfa_configured: boolean;
  skip_mfa: boolean;
  /** @nullable */
  has_verify_setup: boolean | null;
  has_phone: boolean;
};

export type GetCustomerCurrentUser200 = {
  user?: GetCustomerCurrentUser200User;
};

export type GetCustomerCurrentUser401ErrorsItem = {
  title?: string;
};

export type GetCustomerCurrentUser401 = {
  errors?: GetCustomerCurrentUser401ErrorsItem[];
};

export type GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams = {
  /**
   * For required headers only
   */
  required_headers_only?: boolean;
};

export type GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422 = {
  error: unknown;
};

export type GetDisbursementExternalCodesParams = {
  /**
   * External code set name
   */
  name: string;
};

export type GetDisbursementExternalCodes200 = {
  data: ExternalCode[];
};

export type GetDisbursementExternalCodes422 = {
  error: ErrorGenericDetailsNil;
};

export type GetDisbursementPaymentInstruments200 = {
  data: PaymentInstruments[];
};

export type PostDisbursementPayoutBatchesPayoutBatchIdAttachments200 = {
  data: Attachment;
};

export type PostDisbursementPayoutBatchesPayoutBatchIdAttachments422 = {
  error: ErrorAttributes;
};

export type GetDisbursementPayoutBatchesPayoutBatchIdAttachments200 = {
  data: Attachment[];
};

export type DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid200 = {
  data: Attachment;
};

export type DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid422 = {
  error: ErrorGenericDetailsNil;
};

export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams = {
  /**
   * Page size
   */
  'page[size]'?: number;
  /**
   * Cursor after
   */
  'page[cursor_after]'?: string;
  /**
   * Cursor before
   */
  'page[cursor_before]'?: string;
  /**
   * Include cursor
   */
  'page[include_cursor]'?: boolean;
};

export type GetDisbursementPayoutBatchesBatchIdPayoutDrafts200 = {
  meta?: PreferredPagination;
  data?: BatchDraftsItem[];
};

export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId200 = {
  data?: BatchDraft;
};

export type PostDisbursementPayoutBatchesBody = {
  /** CSV file to upload */
  file: Blob;
  /** Optional name for the batch */
  name?: string;
};

export type PostDisbursementPayoutBatches202Data = {
  filename: string;
  format: string;
  batch_id: number;
};

export type PostDisbursementPayoutBatches202 = {
  data?: PostDisbursementPayoutBatches202Data;
  meta?: PayoutBatchMeta;
  errors?: PayoutBatchErrors;
};

export type PostDisbursementPayoutBatches422 = {
  data?: PayoutBatchErrorData;
  meta?: PayoutBatchErrorMeta;
  errors?: PayoutBatchErrors;
};

export type GetDisbursementPayoutBatchesParams = {
  /**
   * Filter by kind
   */
  'filter[kind]'?: string;
  /**
   * Filter by state
   */
  'filter[state]'?: string;
  /**
   * Cursor after
   */
  'page[cursor_after]'?: string;
  /**
   * Cursor before
   */
  'page[cursor_before]'?: string;
  /**
   * Include cursor
   */
  'page[include_cursor]'?: boolean;
  /**
   * Page size
   */
  'page[size]'?: number;
  /**
   * Sort by date
   */
  sort?: string;
  /**
   * Filter created after date
   */
  created_after?: string;
  /**
   * Filter created before date
   */
  created_before?: string;
};

export type GetDisbursementPayoutBatches200 = {
  meta?: Pagination;
  data?: PayoutBatches[];
};

export type GetDisbursementPayoutBatches422 = {
  error?: BatchBadFilterError;
};

export type GetDisbursementPayoutBatchesBatchId200 = {
  data?: PayoutBatch;
};

export type GetDisbursementPayoutBatchesBatchId422 = {
  error?: BatchNotFoundError;
};

export type PostDisbursementPayoutBatchesBatchIdApprove200 = {
  data?: Success;
};

export type PostDisbursementPayoutBatchesBatchIdApprove401 = {
  errors?: UnauthorizedError;
};

export type PostDisbursementPayoutBatchesBatchIdReject200 = {
  data?: Success;
};

export type PostDisbursementPayoutBatchesBatchIdReject422 = {
  error?: BadBatchStatusError;
};

export type PostDisbursementPayoutDraftsPayoutDraftIdAttachments200 = {
  data: Attachment;
};

export type PostDisbursementPayoutDraftsPayoutDraftIdAttachments422 = {
  error: ErrorAttributes;
};

export type GetDisbursementPayoutDraftsPayoutDraftIdAttachments200 = {
  data: Attachment[];
};

export type DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid200 = {
  data: Attachment;
};

export type DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid422 = {
  error: ErrorGenericDetailsNil;
};

export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutDraftsParams = {
  /**
   * Filter by status
   */
  'filter[status]'?: string;
  /**
   * Created after
   */
  created_after?: string;
  /**
   * Created before
   */
  created_before?: string;
  /**
   * Cursor after
   */
  'page[cursor_after]'?: string;
  /**
   * Cursor before
   */
  'page[cursor_before]'?: string;
  /**
   * Include cursor
   */
  'page[include_cursor]'?: boolean;
  /**
   * Page size
   */
  'page[size]'?: number;
};

export type GetDisbursementPayoutDrafts200 = {
  data: PayoutDraftsItem[];
  meta?: PreferredPagination;
};

export type PostDisbursementPayoutDraftsBody = {
  schema_id?: number;
  product_id?: number;
};

export type GetDisbursementPayoutDraftsDraftId200 = {
  data: PayoutDraft;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfPayoutRequest = {
  [key: string]: unknown;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOf = {
  payout_request: PutDisbursementPayoutDraftsDraftIdBodyOneOfPayoutRequest;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfThreeCreditor = {
  [key: string]: unknown;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfThree = {
  creditor: PutDisbursementPayoutDraftsDraftIdBodyOneOfThreeCreditor;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfFiveCreditorAccount = {
  [key: string]: unknown;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfFive = {
  creditor_account: PutDisbursementPayoutDraftsDraftIdBodyOneOfFiveCreditorAccount;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfSevenUltimateDebtor = {
  [key: string]: unknown;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfSeven = {
  ultimate_debtor: PutDisbursementPayoutDraftsDraftIdBodyOneOfSevenUltimateDebtor;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfNineIntermediaryAgent = {
  [key: string]: unknown;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfNine = {
  intermediary_agent?: PutDisbursementPayoutDraftsDraftIdBodyOneOfNineIntermediaryAgent;
};

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfOneoneIntermediaryAgentAccount =
  { [key: string]: unknown };

export type PutDisbursementPayoutDraftsDraftIdBodyOneOfOneone = {
  intermediary_agent_account?: PutDisbursementPayoutDraftsDraftIdBodyOneOfOneoneIntermediaryAgentAccount;
};

export type PutDisbursementPayoutDraftsDraftIdBody =
  | PutDisbursementPayoutDraftsDraftIdBodyOneOf
  | PutDisbursementPayoutDraftsDraftIdBodyOneOfThree
  | PutDisbursementPayoutDraftsDraftIdBodyOneOfFive
  | PutDisbursementPayoutDraftsDraftIdBodyOneOfSeven
  | PutDisbursementPayoutDraftsDraftIdBodyOneOfNine
  | PutDisbursementPayoutDraftsDraftIdBodyOneOfOneone;

export type PutDisbursementPayoutDraftsDraftId200 = {
  data: boolean;
};

export type PutDisbursementPayoutDraftsDraftId401 = {
  errors: UnauthorizedError;
};

export type PostDisbursementPayoutDraftsDraftIdApprove200 = {
  data: unknown;
};

export type PostDisbursementPayoutDraftsDraftIdApprove401 = {
  errors: UnauthorizedError;
};

export type PostDisbursementPayoutDraftsDraftIdApprove422 = {
  error: unknown;
};

export type PostDisbursementPayoutDraftsDraftIdReject200 = {
  data: unknown;
};

export type PostDisbursementPayoutDraftsDraftIdReject401 = {
  errors: unknown;
};

export type PostDisbursementPayoutDraftsDraftIdReject422 = {
  error: unknown;
};

export type PostDisbursementPayoutDraftsIdPublish200 = {
  data?: PublishedPayoutRequest;
};

export type PostDisbursementPayoutReportsBodyStatusCategoriesItem =
  (typeof PostDisbursementPayoutReportsBodyStatusCategoriesItem)[keyof typeof PostDisbursementPayoutReportsBodyStatusCategoriesItem];

export const PostDisbursementPayoutReportsBodyStatusCategoriesItem = {
  received: 'received',
  pending: 'pending',
  rejected: 'rejected',
  action_required: 'action_required',
  returned: 'returned',
  processing: 'processing',
  completed: 'completed'
} as const;

export type PostDisbursementPayoutReportsBody = {
  virtual_account_number?: string;
  /** Date */
  created_after: string;
  /** Date */
  created_before: string;
  amount_from?: string;
  amount_to?: string;
  currency_code?: string;
  business_unit_name?: string;
  local_instrument?: string;
  /** Payment request state categories */
  status_categories?: PostDisbursementPayoutReportsBodyStatusCategoriesItem[];
};

export type PostDisbursementPayoutReports200 = {
  data?: PayoutReportName;
};

export type GetDisbursementPayoutReportsParams = {
  'filter[virtual_account_number]'?: string;
  'filter[date_from]'?: string;
  'filter[date_to]'?: string;
  'page[cursor_after]'?: string;
  'page[cursor_before]'?: string;
  'page[include_cursor]'?: boolean;
};

export type GetDisbursementPayoutReports200 = {
  data?: PayoutReports[];
  meta?: TotalCountPagination;
};

export type GetDisbursementPayoutReportsUuid200 = {
  data?: PayoutReport;
};

export type PostDisbursementPayoutRequestsUniqueReferenceAttachments200 = {
  data: Attachment;
};

export type PostDisbursementPayoutRequestsUniqueReferenceAttachments422 = {
  error: ErrorAttributes;
};

export type GetDisbursementPayoutRequestsUniqueReferenceAttachments200 = {
  data: Attachment[];
};

export type DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid200 =
  {
    data: Attachment;
  };

export type DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid422 =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two =
  {
    error: ErrorGenericDetailsNil;
  };

export type GetDisbursementPayoutRequestsParams = {
  /**
   * Unique identifier
   */
  unique_identifier?: string;
  business_unit_id?: string;
  reason_code_id?: string;
  currency_code?: string;
  source?: string;
  state_category?: string;
  local_instrument?: string;
  batch_id?: string;
  amount_from?: string;
  amount_to?: string;
  virtual_account_number?: string;
  created_after?: string;
  created_before?: string;
  cursor_after?: string;
  cursor_before?: string;
  include_cursor?: string;
  sort?: string;
  page_size?: string;
};

export type GetDisbursementPayoutRequests200 = {
  meta: PreferredPagination;
  data: PayoutRequestItem[];
};

export type GetDisbursementPayoutRequests422 = {
  error: ErrorGenericDetailObject;
};

export type GetDisbursementPayoutRequestsUniqueReference200 = {
  data: PayoutRequest;
};

export type GetDisbursementPayoutRequestsUniqueReference422 = {
  error: ErrorGenericDetailString;
};

export type DeleteDisbursementPayoutRequestsUniqueReference200DataStatus =
  (typeof DeleteDisbursementPayoutRequestsUniqueReference200DataStatus)[keyof typeof DeleteDisbursementPayoutRequestsUniqueReference200DataStatus];

export const DeleteDisbursementPayoutRequestsUniqueReference200DataStatus = {
  pending: 'pending'
} as const;

export type DeleteDisbursementPayoutRequestsUniqueReference200Data = {
  status: DeleteDisbursementPayoutRequestsUniqueReference200DataStatus;
};

export type DeleteDisbursementPayoutRequestsUniqueReference200 = {
  data: DeleteDisbursementPayoutRequestsUniqueReference200Data;
};

export type DeleteDisbursementPayoutRequestsUniqueReference422 = {
  error: ErrorGenericDetailObject;
};

export type GetDisbursementProductSchemasParams = {
  /**
   * Product id
   */
  product_id: number;
};

export type GetDisbursementProductSchemas200 = {
  data: ProductSchemas[];
};

export type GetDisbursementProductSchemas422 = {
  error: ErrorGenericWithCodeDetailObject;
};

export type GetDisbursementSchemaFieldsDefinitionSchemaId422 = {
  error: unknown;
};

export type GetDisbursementStatsPayoutRequestsReasonCodesParams = {
  /**
   * Date filter
   */
  created_after?: string;
  /**
   * Date filter
   */
  created_before?: string;
  'categories[]'?: GetDisbursementStatsPayoutRequestsReasonCodesCategoriesItem[];
};

export type GetDisbursementStatsPayoutRequestsReasonCodesCategoriesItem =
  (typeof GetDisbursementStatsPayoutRequestsReasonCodesCategoriesItem)[keyof typeof GetDisbursementStatsPayoutRequestsReasonCodesCategoriesItem];

export const GetDisbursementStatsPayoutRequestsReasonCodesCategoriesItem = {
  action_required: 'action_required',
  completed: 'completed',
  pending: 'pending',
  processing: 'processing',
  received: 'received',
  rejected: 'rejected',
  returned: 'returned'
} as const;

export type GetDisbursementStatsPayoutRequestsReasonCodes200 = {
  data: PayoutReasonCodeStats;
};

export type GetDisbursementStatsPayoutRequestsReasonCodes422 = {
  error: PayoutError[];
};

export type GetDisbursementStatsPayoutRequestsStateCategoriesParams = {
  /**
   * Date filter
   */
  created_after?: string;
  /**
   * Date filter
   */
  created_before?: string;
  'categories[]'?: GetDisbursementStatsPayoutRequestsStateCategoriesCategoriesItem[];
};

export type GetDisbursementStatsPayoutRequestsStateCategoriesCategoriesItem =
  (typeof GetDisbursementStatsPayoutRequestsStateCategoriesCategoriesItem)[keyof typeof GetDisbursementStatsPayoutRequestsStateCategoriesCategoriesItem];

export const GetDisbursementStatsPayoutRequestsStateCategoriesCategoriesItem = {
  action_required: 'action_required',
  completed: 'completed',
  pending: 'pending',
  processing: 'processing',
  received: 'received',
  rejected: 'rejected',
  returned: 'returned'
} as const;

export type GetDisbursementStatsPayoutRequestsStateCategories200 = {
  data: PayoutStateCategoryStatItem[];
  meta: PayoutStateCategoryStatMeta;
};

export type GetDisbursementStatsPayoutRequestsStateCategories422 = {
  error: PayoutError[];
};

export type GetDisbursementWithdrawalAccountAuthorizationsParams = {
  /**
   * Withdrawal account status
   */
  withdrawal_account_status?: GetDisbursementWithdrawalAccountAuthorizationsWithdrawalAccountStatus;
};

export type GetDisbursementWithdrawalAccountAuthorizationsWithdrawalAccountStatus =
  (typeof GetDisbursementWithdrawalAccountAuthorizationsWithdrawalAccountStatus)[keyof typeof GetDisbursementWithdrawalAccountAuthorizationsWithdrawalAccountStatus];

export const GetDisbursementWithdrawalAccountAuthorizationsWithdrawalAccountStatus =
  {
    created: 'created',
    pending_approval: 'pending_approval',
    active: 'active',
    inactive: 'inactive',
    rejected: 'rejected'
  } as const;

export type GetDisbursementWithdrawalAccountAuthorizations200 = {
  data?: WithdrawalAccountAuthorization[];
};

export type GetDisbursementWithdrawalAccounts200 = {
  data?: WithdrawalAccount[];
};

export type PostDisbursementWithdrawalRequestsBodyCreditorAccount = {
  /** Creditor account UUID */
  id: string;
};

export type PostDisbursementWithdrawalRequestsBodyDebtorAccount = {
  /**
   * Schema type
   * @maxLength 50
   */
  scheme_name: string;
  /**
   * Debitor account id
   * @maxLength 50
   */
  id: string;
};

export type PostDisbursementWithdrawalRequestsBody = {
  /**
   * End to end id
   * @maxLength 50
   */
  end_to_end_id: string;
  /** Withdrawal request amount */
  amount: number;
  /**
   * Country code
   * @maxLength 50
   */
  currency_code: string;
  creditor_account: PostDisbursementWithdrawalRequestsBodyCreditorAccount;
  debtor_account: PostDisbursementWithdrawalRequestsBodyDebtorAccount;
};

export type PostDisbursementWithdrawalRequests201 = {
  data?: WithdrawalRequest;
};

export type GetDisbursementWithdrawalRequestsParams = {
  /**
   * Pagination parameters
   */
  page?: {
    /** @nullable */
    cursor_before?: string | null;
    /** @nullable */
    cursor_after?: string | null;
    /** @nullable */
    per_page?: number | null;
  };
  /**
   * Filtering options
   */
  filter?: {
    status?: GetDisbursementWithdrawalRequestsFilterStatus;
    reference?: string;
    debtor_account_number?: string;
  };
  /**
   * Sort param. Sort by id is default
   */
  sort?: GetDisbursementWithdrawalRequestsSort;
  /**
   * Filter by date
   */
  created_after?: string;
  /**
   * Filter by date
   */
  created_before?: string;
};

export type GetDisbursementWithdrawalRequestsFilterStatus =
  (typeof GetDisbursementWithdrawalRequestsFilterStatus)[keyof typeof GetDisbursementWithdrawalRequestsFilterStatus];

export const GetDisbursementWithdrawalRequestsFilterStatus = {
  received: 'received',
  processing: 'processing',
  rejected: 'rejected',
  returned: 'returned',
  completed: 'completed'
} as const;

export type GetDisbursementWithdrawalRequestsSort =
  (typeof GetDisbursementWithdrawalRequestsSort)[keyof typeof GetDisbursementWithdrawalRequestsSort];

export const GetDisbursementWithdrawalRequestsSort = {
  amount: 'amount',
  '-amount': '-amount',
  id: 'id',
  '-id': '-id',
  created_at: 'created_at',
  '-created_at': '-created_at',
  updated_at: 'updated_at',
  '-updated_at': '-updated_at'
} as const;

export type GetDisbursementWithdrawalRequests200 = {
  data: WithdrawalRequests[];
  meta: PreferredPagination;
};

export type GetDisbursementWithdrawalRequestsWithdrawalRequestId200 = {
  data?: WithdrawalRequestWithAccount;
};

export type GetDocumentationOrganisationsParams = {
  /**
   * magic token
   */
  token?: string;
};

export type GetDocumentationOrganisations200 = {
  data?: Organisations[];
};

export type GetDocumentationParams = {
  /**
   * magic token
   */
  token?: string;
};

export type GetDocumentation200 = {
  data?: Organisations;
};

export type GetDocumentationProductsParams = {
  /**
   * Magic token
   */
  token?: string;
  /**
   * Type of product
   */
  origin: string;
};

export type GetDocumentationProducts200 = {
  data?: ContractedProducts[];
};

export type GetDocumentationProductsProductIdParams = {
  /**
   * Magic token
   */
  token: string;
  /**
   * V2 Product ID
   */
  v2_product_id?: number;
};

export type GetDocumentationProductsProductId200 = {
  data?: SchemaExampleProduct;
};

export type GetFeatureFlags200 = {
  data: FeatureFlag;
};

export type GetFxCurrencies200DataItem = {
  /** three-letter ISO (4217) code for currency in question */
  iso_code?: string;
  /** Id of the currency */
  id?: number;
  /** Name of the currency */
  name?: string;
};

export type GetFxCurrencies200 = {
  data?: GetFxCurrencies200DataItem[];
};

export type GetFxExchangeRateParams = {
  /**
   * buy currency. Format does not fully conform to ISO standard 4217 - can potentially also return crypto currencies.
   */
  buy_currency: string;
  /**
   * pay currency. Format does not fully conform to ISO standard 4217 - can potentially also return crypto currencies.
   */
  pay_currency: string;
  /**
   * FX rate side.
   */
  fixed_side: GetFxExchangeRateFixedSide;
};

export type GetFxExchangeRateFixedSide =
  (typeof GetFxExchangeRateFixedSide)[keyof typeof GetFxExchangeRateFixedSide];

export const GetFxExchangeRateFixedSide = {
  bid: 'bid',
  mid: 'mid',
  ask: 'ask'
} as const;

export type GetFxExchangeRate200Data = {
  /** Format does not fully conform to ISO standard 4217 - can potentially also return crypto currencies. */
  buy_currency?: string;
  /** Format does not fully conform to ISO standard 4217 - can potentially also return crypto currencies. */
  pay_currency?: string;
  /** the exchange rate value */
  exchange_rate?: string;
  /** the reciprocal exchange rate value, is the same as (1/exchange_rate) */
  reciprocal_exchange_rate?: string;
  /** time when the request was processed in UTC time zone. */
  utc_time?: string;
};

export type GetFxExchangeRate200 = {
  data?: GetFxExchangeRate200Data;
};

export type GetFxExchangeRate404ErrorsItem = {
  details?: string;
  title?: string;
};

export type GetFxExchangeRate404 = {
  errors?: GetFxExchangeRate404ErrorsItem[];
};

export type GetFxExchangeRate422ErrorsItemDetails = { [key: string]: unknown };

export type GetFxExchangeRate422ErrorsItem = {
  details?: GetFxExchangeRate422ErrorsItemDetails;
  title?: string;
};

export type GetFxExchangeRate422 = {
  errors?: GetFxExchangeRate422ErrorsItem[];
};

export type GetFxMarkups200DataItem = {
  /** Id */
  id?: number;
  /** three-letter ISO (4217) code for currency in question */
  buy_currency_iso?: string;
  /** three-letter ISO (4217) code for currency in question */
  pay_currency_iso?: string;
};

export type GetFxMarkups200 = {
  data?: GetFxMarkups200DataItem[];
};

export type GetIntegrationAuthSchemesParams = {
  /**
   * Filter schemes by enabled state
   */
  'filter[enabled]'?: boolean;
};

export type GetIntegrationAuthSchemes200 = {
  data: AuthScheme[];
};

export type PostIntegrationAuthSchemesBodyScopesItem =
  (typeof PostIntegrationAuthSchemesBodyScopesItem)[keyof typeof PostIntegrationAuthSchemesBodyScopesItem];

export const PostIntegrationAuthSchemesBodyScopesItem = {
  'payouts:read': 'payouts:read',
  'payouts:create': 'payouts:create',
  'payouts:update': 'payouts:update',
  'payouts:delete': 'payouts:delete',
  'payins:read': 'payins:read',
  'payins:create': 'payins:create',
  'payins:update': 'payins:update',
  'payins:delete': 'payins:delete',
  'reconciliation:read': 'reconciliation:read',
  'reconciliation:create': 'reconciliation:create',
  'reconciliation:update': 'reconciliation:update',
  'reconciliation:delete': 'reconciliation:delete',
  'fx:read': 'fx:read',
  'virtual_bank:read': 'virtual_bank:read',
  'sandbox:all': 'sandbox:all'
} as const;

/**
 * Three valid combinations: (1) PKCS without encryption — `name` only; (2) PKCS with encryption, bring-your-own-certificate — `name` + `encryption_enabled: true` + `use_certificate: true` + `certificate`; (3) PKCS with encryption, certificate generated for you — `name` + `encryption_enabled: true` + `csr`.
 */
export type PostIntegrationAuthSchemesBody = {
  /** Human-readable label for the scheme; must be unique within the organisation. */
  name: string;
  /** Whether the scheme uses PKCS#7 payload encryption. When true, either `certificate` or `csr` must be supplied. */
  encryption_enabled?: boolean;
  /** Only applies when `encryption_enabled` is true. `true` = provide your own `certificate` (BYOC). `false` = provide a `csr` and it is signed for you. */
  use_certificate?: boolean;
  /** PEM-encoded X.509 certificate. Required when `encryption_enabled` and `use_certificate` are both true. */
  certificate?: string;
  /** PEM-encoded Certificate Signing Request. Required when `encryption_enabled` is true and `use_certificate` is false. */
  csr?: string;
  /** Permission scopes granted to the scheme. Omit or send an empty array to grant every available scope; a non-empty array grants exactly those scopes. Unknown values are rejected with 422. */
  scopes?: PostIntegrationAuthSchemesBodyScopesItem[];
};

export type PostIntegrationAuthSchemes201 = {
  data: AuthSchemeWithSecret;
};

export type PostIntegrationAuthSchemesSignBodyScopesItem =
  (typeof PostIntegrationAuthSchemesSignBodyScopesItem)[keyof typeof PostIntegrationAuthSchemesSignBodyScopesItem];

export const PostIntegrationAuthSchemesSignBodyScopesItem = {
  'payouts:read': 'payouts:read',
  'payouts:create': 'payouts:create',
  'payouts:update': 'payouts:update',
  'payouts:delete': 'payouts:delete',
  'payins:read': 'payins:read',
  'payins:create': 'payins:create',
  'payins:update': 'payins:update',
  'payins:delete': 'payins:delete',
  'reconciliation:read': 'reconciliation:read',
  'reconciliation:create': 'reconciliation:create',
  'reconciliation:update': 'reconciliation:update',
  'reconciliation:delete': 'reconciliation:delete',
  'fx:read': 'fx:read',
  'virtual_bank:read': 'virtual_bank:read',
  'sandbox:all': 'sandbox:all'
} as const;

/**
 * JWT schemes authenticate via signed JWTs rather than a shared secret. The customer provides an RSA public key that the API uses to verify incoming JWT signatures.
 */
export type PostIntegrationAuthSchemesSignBody = {
  /** Human-readable label for the scheme; must be unique within the organisation. */
  name: string;
  /** PEM-encoded RSA public key. Used to verify the customer-signed JWTs presented in `Authorization` headers. */
  certificate: string;
  /** Permission scopes granted to the scheme. Omit or send an empty array to grant every available scope; a non-empty array grants exactly those scopes. Unknown values are rejected with 422. */
  scopes?: PostIntegrationAuthSchemesSignBodyScopesItem[];
};

export type PostIntegrationAuthSchemesSign201 = {
  data: AuthSchemeWithSecret;
};

export type PostIntegrationAuthSchemesUuidEnable200 = {
  data: AuthScheme;
};

export type DeleteIntegrationAuthSchemesUuid200 = {
  data: AuthScheme;
};

export type GetIntegrationBusinessUnitsParams = {
  /**
   * Cursor next
   */
  cursor_next?: string;
  /**
   * Cursor prev
   */
  cursor_prev?: string;
  /**
   * Sort param. Sort by created_at desc is default. The organisation's default business unit is always returned as the first entry of the first page, regardless of sort direction, and is not repeated on later pages.
   */
  sort?: string;
  /**
   * Page size (default 100, min 5, max 200)
   */
  page_size?: string;
  /**
   * Case-insensitive partial name search
   */
  'filter[name]'?: string;
};

export type GetIntegrationBusinessUnits200Meta = {
  /** @nullable */
  cursor_next?: number | null;
  /** @nullable */
  cursor_prev?: number | null;
  has_next_page?: boolean;
  has_prev_page?: boolean;
  total?: number;
};

export type GetIntegrationBusinessUnits200 = {
  data: IntegrationBusinessUnit[];
  meta: GetIntegrationBusinessUnits200Meta;
};

export type PostIntegrationBusinessUnitsBody = {
  /** Human-readable label; must be unique within the organisation. */
  name: string;
};

export type PostIntegrationBusinessUnits201 = {
  data: IntegrationBusinessUnit;
};

export type PatchIntegrationBusinessUnitsUuidBody = {
  /** New human-readable label. */
  name: string;
};

export type PatchIntegrationBusinessUnitsUuid200 = {
  data: IntegrationBusinessUnit;
};

export type DeleteIntegrationBusinessUnitsUuid200 = {
  data: IntegrationBusinessUnit;
};

export type PostIntegrationBusinessUnitsUuidSetDefault200 = {
  data: IntegrationBusinessUnit;
};

export type GetIntegrationMcpTokens200 = {
  data: McpToken[];
};

/**
 * Creates an MCP token for the organisation. The raw token value is returned exactly once, in this response.
 */
export type PostIntegrationMcpTokensBody = {
  /** Human-readable label for the token. Not unique — revoking a token and creating a new one under the same name is supported. */
  name: string;
};

export type PostIntegrationMcpTokens201 = {
  data: McpTokenWithToken;
};

export type DeleteIntegrationMcpTokensUuid200 = {
  data: McpToken;
};

export type GetIntegrationWebhooksParams = {
  'filter[active]'?: boolean;
  'filter[business_unit_uuid]'?: string;
};

export type GetIntegrationWebhooks200 = {
  data: Webhook[];
};

export type GetMcpDocumentationLink200 = {
  documentation_link: string;
};

export type GetMcpDocumentationLink401ErrorsItemTitle =
  (typeof GetMcpDocumentationLink401ErrorsItemTitle)[keyof typeof GetMcpDocumentationLink401ErrorsItemTitle];

export const GetMcpDocumentationLink401ErrorsItemTitle = {
  Not_authorized: 'Not authorized'
} as const;

export type GetMcpDocumentationLink401ErrorsItemDetailsItem =
  (typeof GetMcpDocumentationLink401ErrorsItemDetailsItem)[keyof typeof GetMcpDocumentationLink401ErrorsItemDetailsItem];

export const GetMcpDocumentationLink401ErrorsItemDetailsItem = {
  missing_token: 'missing_token',
  unknown_token: 'unknown_token',
  revoked_token: 'revoked_token',
  expired_token: 'expired_token'
} as const;

export type GetMcpDocumentationLink401ErrorsItem = {
  title: GetMcpDocumentationLink401ErrorsItemTitle;
  details: GetMcpDocumentationLink401ErrorsItemDetailsItem[];
};

export type GetMcpDocumentationLink401 = {
  errors: GetMcpDocumentationLink401ErrorsItem[];
};

export type GetMcpDocumentationLink404ErrorsItemTitle =
  (typeof GetMcpDocumentationLink404ErrorsItemTitle)[keyof typeof GetMcpDocumentationLink404ErrorsItemTitle];

export const GetMcpDocumentationLink404ErrorsItemTitle = {
  Not_found: 'Not found'
} as const;

export type GetMcpDocumentationLink404ErrorsItemDetailsItem =
  (typeof GetMcpDocumentationLink404ErrorsItemDetailsItem)[keyof typeof GetMcpDocumentationLink404ErrorsItemDetailsItem];

export const GetMcpDocumentationLink404ErrorsItemDetailsItem = {
  documentation_link_not_available: 'documentation_link_not_available'
} as const;

export type GetMcpDocumentationLink404ErrorsItem = {
  title: GetMcpDocumentationLink404ErrorsItemTitle;
  details: GetMcpDocumentationLink404ErrorsItemDetailsItem[];
};

export type GetMcpDocumentationLink404 = {
  errors: GetMcpDocumentationLink404ErrorsItem[];
};

export type GetNotificationsAlertsParams = {
  /**
   * Filter alerts by app type
   */
  app_type?: string;
};

export type GetNotificationsAlerts200 = {
  data?: InAppAlert[];
};

export type GetVirtualBankAccounts200 = {
  data?: Account[];
};

export type GetVirtualBankAccountsAccountNumberSummaryParams = {
  /**
   * summary from date
   */
  created_after: string;
  /**
   * summary to date
   */
  created_before: string;
};

export type GetVirtualBankAccountsAccountNumberSummary200 = {
  data: AccountSummary;
};

export type PostVirtualBankInterAccountMovementsBody = {
  amount: string;
  from_account_number: string;
  to_account_number: string;
  end_to_end_id: string;
};

export type PostVirtualBankInterAccountMovements200 = {
  data?: InternalAccountMovement;
};

export type PostVirtualBankInterAccountMovements422 = {
  error?: InternalAccountMovementErrors;
};

export type GetVirtualBankAccountsAccountNumberMovementsParams = {
  /**
   * created after
   */
  created_after?: string;
  /**
   * Created before
   */
  created_before?: string;
  /**
   * Cursor after
   */
  cursor_after?: string;
  /**
   * Cursor before
   */
  cursor_before?: string;
  /**
   * Entry type
   */
  'filter[entry_type]'?: GetVirtualBankAccountsAccountNumberMovementsFilterEntryType;
};

export type GetVirtualBankAccountsAccountNumberMovementsFilterEntryType =
  (typeof GetVirtualBankAccountsAccountNumberMovementsFilterEntryType)[keyof typeof GetVirtualBankAccountsAccountNumberMovementsFilterEntryType];

export const GetVirtualBankAccountsAccountNumberMovementsFilterEntryType = {
  collection: 'collection',
  collection_refund: 'collection_refund',
  collection_fee: 'collection_fee',
  collection_refund_fee: 'collection_refund_fee',
  refund_canceled: 'refund_canceled',
  refund_returned: 'refund_returned',
  payout: 'payout',
  payout_fee: 'payout_fee',
  payout_returned: 'payout_returned',
  payout_cancelled: 'payout_cancelled',
  incident_charges_fee: 'incident_charges_fee',
  monthly_fee: 'monthly_fee',
  minimum_processing_fee: 'minimum_processing_fee',
  inter_account_transfer: 'inter_account_transfer',
  correction: 'correction',
  contract_trx_fee_adjustment: 'contract_trx_fee_adjustment',
  contract_trx_fx_adjustment: 'contract_trx_fx_adjustment',
  funding: 'funding'
} as const;

export type GetVirtualBankAccountsAccountNumberMovements200 = {
  data?: Movement[];
  meta?: Pagination;
};

export type GetVirtualBankMovementsSearchParams = {
  /**
   * Unique identifier of movement
   */
  unique_identifier: string;
};

export type GetVirtualBankMovementsSearch200 = {
  data?: Movement[];
  meta?: AccountMeta;
};

export type PostVirtualBankStatementsBody = {
  virtual_account_number?: string;
  /** Date */
  created_after: string;
  /** Date */
  created_before: string;
  /** transactions or charges */
  kind?: string;
};

export type PostVirtualBankStatements200 = {
  data?: NewStatement;
};

export type GetVirtualBankStatementsParams = {
  /**
   * Filter by virtual account number
   */
  'filter[account_number]'?: string;
  /**
   * Filter statements from this date
   */
  'filter[date_from]'?: string;
  /**
   * Filter statements up to this date
   */
  'filter[date_to]'?: string;
  /**
   * Cursor for next page
   */
  'page[cursor_after]'?: string;
  /**
   * Cursor for previous page
   */
  'page[cursor_before]'?: string;
  /**
   * Include cursor item in results
   */
  'page[include_cursor]'?: boolean;
};

export type GetVirtualBankStatements200 = {
  data?: StatementItem[];
  meta?: TotalCountPagination;
};

export type GetVirtualBankStatementsStatementId200 = {
  data?: StatementItem;
};

export type GetVirtualBankStatementsStatementId422 = {
  error?: ErrorGenericWithCodeDetailObject;
};

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Exchange
 */
export const postAuthenticationImpersonationsExchange = (
  postAuthenticationImpersonationsExchangeBody: BodyType<PostAuthenticationImpersonationsExchangeBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<ImpersonationExchangeResponse>(
    {
      url: `/authentication/impersonations/exchange`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAuthenticationImpersonationsExchangeBody
    },
    options
  );
};

export const getPostAuthenticationImpersonationsExchangeMutationOptions = <
  TError = ImpersonationGrantErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>,
    TError,
    { data: BodyType<PostAuthenticationImpersonationsExchangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>,
  TError,
  { data: BodyType<PostAuthenticationImpersonationsExchangeBody> },
  TContext
> => {
  const mutationKey = ['postAuthenticationImpersonationsExchange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>,
    { data: BodyType<PostAuthenticationImpersonationsExchangeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthenticationImpersonationsExchange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthenticationImpersonationsExchangeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>
  >;
export type PostAuthenticationImpersonationsExchangeMutationBody =
  BodyType<PostAuthenticationImpersonationsExchangeBody>;
export type PostAuthenticationImpersonationsExchangeMutationError =
  ImpersonationGrantErrorResponse;

/**
 * @summary Exchange
 */
export const usePostAuthenticationImpersonationsExchange = <
  TError = ImpersonationGrantErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>,
      TError,
      { data: BodyType<PostAuthenticationImpersonationsExchangeBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthenticationImpersonationsExchange>>,
  TError,
  { data: BodyType<PostAuthenticationImpersonationsExchangeBody> },
  TContext
> => {
  const mutationOptions =
    getPostAuthenticationImpersonationsExchangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Validates a customer-presented MCP token and returns the owning
organisation, the token's scopes, and its expiry.

Authentication: the presented MCP token is the sole credential
(`Authorization: Bearer tenant_mcp_…`); no user session/JWT is involved.

Exposure model: the endpoint lives on the customer_app_api surface. The
supported consumer is the Onboarding MCP server calling backend_v2
directly on its internal address. It is also reachable via the Customer
App proxy (same credential gate), but that path is not part of the
contract — it strips `Cache-Control: no-store`. Rate limiting is deferred
to PEGO-13907; per-token revocation via the management endpoints is the
primary abuse lever. Every response carries `Cache-Control: no-store` so
no intermediary on the supported path outlives revocation.

Consumer of the contract: PEGO-13910 (mcp_onboarding).

 * @summary Introspect an MCP token
 */
export const getAuthenticationMcpTokensIntrospection = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetAuthenticationMcpTokensIntrospection200>(
    { url: `/authentication/mcp_tokens/introspection`, method: 'GET' },
    options
  );
};

export const getGetAuthenticationMcpTokensIntrospectionQueryKey = () => {
  return [`/authentication/mcp_tokens/introspection`] as const;
};

export const getGetAuthenticationMcpTokensIntrospectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
  TError = GetAuthenticationMcpTokensIntrospection401
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAuthenticationMcpTokensIntrospectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>
  > = () => getAuthenticationMcpTokensIntrospection(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuthenticationMcpTokensIntrospectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>
>;
export type GetAuthenticationMcpTokensIntrospectionQueryError =
  GetAuthenticationMcpTokensIntrospection401;

export function useGetAuthenticationMcpTokensIntrospection<
  TData = Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
  TError = GetAuthenticationMcpTokensIntrospection401
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAuthenticationMcpTokensIntrospection<
  TData = Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
  TError = GetAuthenticationMcpTokensIntrospection401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAuthenticationMcpTokensIntrospection<
  TData = Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
  TError = GetAuthenticationMcpTokensIntrospection401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Introspect an MCP token
 */

export function useGetAuthenticationMcpTokensIntrospection<
  TData = Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
  TError = GetAuthenticationMcpTokensIntrospection401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMcpTokensIntrospection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAuthenticationMcpTokensIntrospectionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Request SMS
 */
export const postAuthenticationMfaRequestSms = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostAuthenticationMfaRequestSms200>(
    { url: `/authentication/mfa/request_sms`, method: 'POST' },
    options
  );
};

export const getPostAuthenticationMfaRequestSmsMutationOptions = <
  TError = PostAuthenticationMfaRequestSms422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postAuthenticationMfaRequestSms'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>,
    void
  > = () => {
    return postAuthenticationMfaRequestSms(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthenticationMfaRequestSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>
>;

export type PostAuthenticationMfaRequestSmsMutationError =
  PostAuthenticationMfaRequestSms422;

/**
 * @summary Request SMS
 */
export const usePostAuthenticationMfaRequestSms = <
  TError = PostAuthenticationMfaRequestSms422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthenticationMfaRequestSms>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostAuthenticationMfaRequestSmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Verify SMS
 */
export const postAuthenticationMfaVerifySms = (
  postAuthenticationMfaVerifySmsBody: BodyType<PostAuthenticationMfaVerifySmsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostAuthenticationMfaVerifySms200>(
    {
      url: `/authentication/mfa/verify_sms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAuthenticationMfaVerifySmsBody
    },
    options
  );
};

export const getPostAuthenticationMfaVerifySmsMutationOptions = <
  TError = PostAuthenticationMfaVerifySms422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>,
    TError,
    { data: BodyType<PostAuthenticationMfaVerifySmsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>,
  TError,
  { data: BodyType<PostAuthenticationMfaVerifySmsBody> },
  TContext
> => {
  const mutationKey = ['postAuthenticationMfaVerifySms'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>,
    { data: BodyType<PostAuthenticationMfaVerifySmsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthenticationMfaVerifySms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthenticationMfaVerifySmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>
>;
export type PostAuthenticationMfaVerifySmsMutationBody =
  BodyType<PostAuthenticationMfaVerifySmsBody>;
export type PostAuthenticationMfaVerifySmsMutationError =
  PostAuthenticationMfaVerifySms422;

/**
 * @summary Verify SMS
 */
export const usePostAuthenticationMfaVerifySms = <
  TError = PostAuthenticationMfaVerifySms422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>,
      TError,
      { data: BodyType<PostAuthenticationMfaVerifySmsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifySms>>,
  TError,
  { data: BodyType<PostAuthenticationMfaVerifySmsBody> },
  TContext
> => {
  const mutationOptions =
    getPostAuthenticationMfaVerifySmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Request TOTP Factor
 */
export const getAuthenticationMfaRequestTotpFactor = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetAuthenticationMfaRequestTotpFactor200>(
    { url: `/authentication/mfa/request_totp_factor`, method: 'GET' },
    options
  );
};

export const getGetAuthenticationMfaRequestTotpFactorQueryKey = () => {
  return [`/authentication/mfa/request_totp_factor`] as const;
};

export const getGetAuthenticationMfaRequestTotpFactorQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
  TError =
    | GetAuthenticationMfaRequestTotpFactor401
    | GetAuthenticationMfaRequestTotpFactor422
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAuthenticationMfaRequestTotpFactorQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>
  > = () => getAuthenticationMfaRequestTotpFactor(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuthenticationMfaRequestTotpFactorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>
>;
export type GetAuthenticationMfaRequestTotpFactorQueryError =
  | GetAuthenticationMfaRequestTotpFactor401
  | GetAuthenticationMfaRequestTotpFactor422;

export function useGetAuthenticationMfaRequestTotpFactor<
  TData = Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
  TError =
    | GetAuthenticationMfaRequestTotpFactor401
    | GetAuthenticationMfaRequestTotpFactor422
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAuthenticationMfaRequestTotpFactor<
  TData = Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
  TError =
    | GetAuthenticationMfaRequestTotpFactor401
    | GetAuthenticationMfaRequestTotpFactor422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAuthenticationMfaRequestTotpFactor<
  TData = Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
  TError =
    | GetAuthenticationMfaRequestTotpFactor401
    | GetAuthenticationMfaRequestTotpFactor422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Request TOTP Factor
 */

export function useGetAuthenticationMfaRequestTotpFactor<
  TData = Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
  TError =
    | GetAuthenticationMfaRequestTotpFactor401
    | GetAuthenticationMfaRequestTotpFactor422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAuthenticationMfaRequestTotpFactor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAuthenticationMfaRequestTotpFactorQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Validate TOTP factor
 */
export const postAuthenticationMfaValidateTotpFactor = (
  postAuthenticationMfaValidateTotpFactorBody: BodyType<PostAuthenticationMfaValidateTotpFactorBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostAuthenticationMfaValidateTotpFactor200>(
    {
      url: `/authentication/mfa/validate_totp_factor`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAuthenticationMfaValidateTotpFactorBody
    },
    options
  );
};

export const getPostAuthenticationMfaValidateTotpFactorMutationOptions = <
  TError = PostAuthenticationMfaValidateTotpFactor422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>,
    TError,
    { data: BodyType<PostAuthenticationMfaValidateTotpFactorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>,
  TError,
  { data: BodyType<PostAuthenticationMfaValidateTotpFactorBody> },
  TContext
> => {
  const mutationKey = ['postAuthenticationMfaValidateTotpFactor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>,
    { data: BodyType<PostAuthenticationMfaValidateTotpFactorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthenticationMfaValidateTotpFactor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthenticationMfaValidateTotpFactorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>
>;
export type PostAuthenticationMfaValidateTotpFactorMutationBody =
  BodyType<PostAuthenticationMfaValidateTotpFactorBody>;
export type PostAuthenticationMfaValidateTotpFactorMutationError =
  PostAuthenticationMfaValidateTotpFactor422;

/**
 * @summary Validate TOTP factor
 */
export const usePostAuthenticationMfaValidateTotpFactor = <
  TError = PostAuthenticationMfaValidateTotpFactor422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>,
      TError,
      { data: BodyType<PostAuthenticationMfaValidateTotpFactorBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthenticationMfaValidateTotpFactor>>,
  TError,
  { data: BodyType<PostAuthenticationMfaValidateTotpFactorBody> },
  TContext
> => {
  const mutationOptions =
    getPostAuthenticationMfaValidateTotpFactorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Verify TOTP factor
 */
export const postAuthenticationMfaVerifyTotpFactor = (
  postAuthenticationMfaVerifyTotpFactorBody: BodyType<PostAuthenticationMfaVerifyTotpFactorBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostAuthenticationMfaVerifyTotpFactor200>(
    {
      url: `/authentication/mfa/verify_totp_factor`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postAuthenticationMfaVerifyTotpFactorBody
    },
    options
  );
};

export const getPostAuthenticationMfaVerifyTotpFactorMutationOptions = <
  TError = PostAuthenticationMfaVerifyTotpFactor422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>,
    TError,
    { data: BodyType<PostAuthenticationMfaVerifyTotpFactorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>,
  TError,
  { data: BodyType<PostAuthenticationMfaVerifyTotpFactorBody> },
  TContext
> => {
  const mutationKey = ['postAuthenticationMfaVerifyTotpFactor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>,
    { data: BodyType<PostAuthenticationMfaVerifyTotpFactorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthenticationMfaVerifyTotpFactor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthenticationMfaVerifyTotpFactorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>
>;
export type PostAuthenticationMfaVerifyTotpFactorMutationBody =
  BodyType<PostAuthenticationMfaVerifyTotpFactorBody>;
export type PostAuthenticationMfaVerifyTotpFactorMutationError =
  PostAuthenticationMfaVerifyTotpFactor422;

/**
 * @summary Verify TOTP factor
 */
export const usePostAuthenticationMfaVerifyTotpFactor = <
  TError = PostAuthenticationMfaVerifyTotpFactor422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>,
      TError,
      { data: BodyType<PostAuthenticationMfaVerifyTotpFactorBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthenticationMfaVerifyTotpFactor>>,
  TError,
  { data: BodyType<PostAuthenticationMfaVerifyTotpFactorBody> },
  TContext
> => {
  const mutationOptions =
    getPostAuthenticationMfaVerifyTotpFactorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index funding instructions
 */
export const getCollectionFundingInstructions = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionFundingInstructions200>(
    {
      url: `/collection/organisations/${organisationId}/funding_instructions`,
      method: 'GET'
    },
    options
  );
};

export const getGetCollectionFundingInstructionsQueryKey = (
  organisationId?: number
) => {
  return [
    `/collection/organisations/${organisationId}/funding_instructions`
  ] as const;
};

export const getGetCollectionFundingInstructionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionFundingInstructionsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionFundingInstructions>>
  > = () => getCollectionFundingInstructions(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionFundingInstructionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionFundingInstructions>>
>;
export type GetCollectionFundingInstructionsQueryError = unknown;

export function useGetCollectionFundingInstructions<
  TData = Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
          TError,
          Awaited<ReturnType<typeof getCollectionFundingInstructions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionFundingInstructions<
  TData = Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
          TError,
          Awaited<ReturnType<typeof getCollectionFundingInstructions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionFundingInstructions<
  TData = Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index funding instructions
 */

export function useGetCollectionFundingInstructions<
  TData = Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionFundingInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionFundingInstructionsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Accept funding updates
 */
export const putCollectionFundingInstructionsAccountNumberAcceptChanges = (
  organisationId: number,
  accountNumber: number,
  putCollectionFundingInstructionsAccountNumberAcceptChangesBody: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutCollectionFundingInstructionsAccountNumberAcceptChanges200>(
    {
      url: `/collection/organisations/${organisationId}/funding_instructions/${accountNumber}/accept_changes`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putCollectionFundingInstructionsAccountNumberAcceptChangesBody
    },
    options
  );
};

export const getPutCollectionFundingInstructionsAccountNumberAcceptChangesMutationOptions =
  <
    TError = null | PutCollectionFundingInstructionsAccountNumberAcceptChanges422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
        >
      >,
      TError,
      {
        organisationId: number;
        accountNumber: number;
        data: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
      >
    >,
    TError,
    {
      organisationId: number;
      accountNumber: number;
      data: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
    },
    TContext
  > => {
    const mutationKey = [
      'putCollectionFundingInstructionsAccountNumberAcceptChanges'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
        >
      >,
      {
        organisationId: number;
        accountNumber: number;
        data: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
      }
    > = (props) => {
      const { organisationId, accountNumber, data } = props ?? {};

      return putCollectionFundingInstructionsAccountNumberAcceptChanges(
        organisationId,
        accountNumber,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutCollectionFundingInstructionsAccountNumberAcceptChangesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
      >
    >
  >;
export type PutCollectionFundingInstructionsAccountNumberAcceptChangesMutationBody =
  BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
export type PutCollectionFundingInstructionsAccountNumberAcceptChangesMutationError =
  null | PutCollectionFundingInstructionsAccountNumberAcceptChanges422;

/**
 * @summary Accept funding updates
 */
export const usePutCollectionFundingInstructionsAccountNumberAcceptChanges = <
  TError = null | PutCollectionFundingInstructionsAccountNumberAcceptChanges422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
        >
      >,
      TError,
      {
        organisationId: number;
        accountNumber: number;
        data: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof putCollectionFundingInstructionsAccountNumberAcceptChanges
    >
  >,
  TError,
  {
    organisationId: number;
    accountNumber: number;
    data: BodyType<PutCollectionFundingInstructionsAccountNumberAcceptChangesBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPutCollectionFundingInstructionsAccountNumberAcceptChangesMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create Order Report (Pay-ins export)
 */
export const postCollectionOrderReports = (
  organisationId: number,
  postCollectionOrderReportsBody: BodyType<PostCollectionOrderReportsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostCollectionOrderReports200>(
    {
      url: `/collection/organisations/${organisationId}/order_reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCollectionOrderReportsBody
    },
    options
  );
};

export const getPostCollectionOrderReportsMutationOptions = <
  TError = null | PostCollectionOrderReports404 | PostCollectionOrderReports422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCollectionOrderReports>>,
    TError,
    { organisationId: number; data: BodyType<PostCollectionOrderReportsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCollectionOrderReports>>,
  TError,
  { organisationId: number; data: BodyType<PostCollectionOrderReportsBody> },
  TContext
> => {
  const mutationKey = ['postCollectionOrderReports'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCollectionOrderReports>>,
    { organisationId: number; data: BodyType<PostCollectionOrderReportsBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postCollectionOrderReports(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCollectionOrderReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCollectionOrderReports>>
>;
export type PostCollectionOrderReportsMutationBody =
  BodyType<PostCollectionOrderReportsBody>;
export type PostCollectionOrderReportsMutationError =
  | null
  | PostCollectionOrderReports404
  | PostCollectionOrderReports422;

/**
 * @summary Create Order Report (Pay-ins export)
 */
export const usePostCollectionOrderReports = <
  TError = null | PostCollectionOrderReports404 | PostCollectionOrderReports422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCollectionOrderReports>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostCollectionOrderReportsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCollectionOrderReports>>,
  TError,
  { organisationId: number; data: BodyType<PostCollectionOrderReportsBody> },
  TContext
> => {
  const mutationOptions = getPostCollectionOrderReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Order Reports
 */
export const getCollectionOrderReports = (
  organisationId: number,
  params?: GetCollectionOrderReportsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionOrderReports200>(
    {
      url: `/collection/organisations/${organisationId}/order_reports`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCollectionOrderReportsQueryKey = (
  organisationId?: number,
  params?: GetCollectionOrderReportsParams
) => {
  return [
    `/collection/organisations/${organisationId}/order_reports`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCollectionOrderReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionOrderReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrderReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrderReportsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrderReports>>
  > = () => getCollectionOrderReports(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionOrderReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrderReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionOrderReports>>
>;
export type GetCollectionOrderReportsQueryError = unknown;

export function useGetCollectionOrderReports<
  TData = Awaited<ReturnType<typeof getCollectionOrderReports>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetCollectionOrderReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReports>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrderReports<
  TData = Awaited<ReturnType<typeof getCollectionOrderReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrderReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReports>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrderReports<
  TData = Awaited<ReturnType<typeof getCollectionOrderReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrderReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Order Reports
 */

export function useGetCollectionOrderReports<
  TData = Awaited<ReturnType<typeof getCollectionOrderReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrderReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionOrderReportsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Order Report
 */
export const getCollectionOrderReportsUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionOrderReportsUuid200>(
    {
      url: `/collection/organisations/${organisationId}/order_reports/${uuid}`,
      method: 'GET'
    },
    options
  );
};

export const getGetCollectionOrderReportsUuidQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/collection/organisations/${organisationId}/order_reports/${uuid}`
  ] as const;
};

export const getGetCollectionOrderReportsUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
  TError = GetCollectionOrderReportsUuid404
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrderReportsUuidQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>
  > = () => getCollectionOrderReportsUuid(organisationId, uuid, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrderReportsUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>
>;
export type GetCollectionOrderReportsUuidQueryError =
  GetCollectionOrderReportsUuid404;

export function useGetCollectionOrderReportsUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
  TError = GetCollectionOrderReportsUuid404
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrderReportsUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
  TError = GetCollectionOrderReportsUuid404
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrderReportsUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
  TError = GetCollectionOrderReportsUuid404
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Order Report
 */

export function useGetCollectionOrderReportsUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
  TError = GetCollectionOrderReportsUuid404
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionOrderReportsUuidQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download Order Report
 */
export const getCollectionOrderReportsUuidDownload = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<string>(
    {
      url: `/collection/organisations/${organisationId}/order_reports/${uuid}/download`,
      method: 'GET'
    },
    options
  );
};

export const getGetCollectionOrderReportsUuidDownloadQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/collection/organisations/${organisationId}/order_reports/${uuid}/download`
  ] as const;
};

export const getGetCollectionOrderReportsUuidDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrderReportsUuidDownloadQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>
  > = () =>
    getCollectionOrderReportsUuidDownload(organisationId, uuid, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrderReportsUuidDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>
>;
export type GetCollectionOrderReportsUuidDownloadQueryError = null;

export function useGetCollectionOrderReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrderReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrderReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Order Report
 */

export function useGetCollectionOrderReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrderReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionOrderReportsUuidDownloadQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Order
 */
export const deleteCollectionOrdersUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteCollectionOrdersUuid200>(
    {
      url: `/collection/organisations/${organisationId}/orders/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteCollectionOrdersUuidMutationOptions = <
  TError = NoOrganisationMembershipError | ErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['deleteCollectionOrdersUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return deleteCollectionOrdersUuid(organisationId, uuid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionOrdersUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>
>;

export type DeleteCollectionOrdersUuidMutationError =
  | NoOrganisationMembershipError
  | ErrorResponse;

/**
 * @summary Delete Order
 */
export const useDeleteCollectionOrdersUuid = <
  TError = NoOrganisationMembershipError | ErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollectionOrdersUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions = getDeleteCollectionOrdersUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Show Order
 */
export const getCollectionOrdersUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionOrdersUuid200>(
    {
      url: `/collection/organisations/${organisationId}/orders/${uuid}`,
      method: 'GET'
    },
    options
  );
};

export const getGetCollectionOrdersUuidQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/collection/organisations/${organisationId}/orders/${uuid}`
  ] as const;
};

export const getGetCollectionOrdersUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrdersUuidQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrdersUuid>>
  > = () => getCollectionOrdersUuid(organisationId, uuid, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrdersUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionOrdersUuid>>
>;
export type GetCollectionOrdersUuidQueryError = unknown;

export function useGetCollectionOrdersUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrdersUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrdersUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrdersUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrdersUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Order
 */

export function useGetCollectionOrdersUuid<
  TData = Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrdersUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionOrdersUuidQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Order By UUID or External Reference
 */
export const getCollectionOrdersFindByUuidOrExternalReference = (
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionOrdersFindByUuidOrExternalReference200>(
    {
      url: `/collection/organisations/${organisationId}/orders/find_by_uuid_or_external_reference`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCollectionOrdersFindByUuidOrExternalReferenceQueryKey = (
  organisationId?: number,
  params?: GetCollectionOrdersFindByUuidOrExternalReferenceParams
) => {
  return [
    `/collection/organisations/${organisationId}/orders/find_by_uuid_or_external_reference`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCollectionOrdersFindByUuidOrExternalReferenceQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrdersFindByUuidOrExternalReferenceQueryKey(
      organisationId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>>
  > = () =>
    getCollectionOrdersFindByUuidOrExternalReference(
      organisationId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrdersFindByUuidOrExternalReferenceQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>>
  >;
export type GetCollectionOrdersFindByUuidOrExternalReferenceQueryError =
  unknown;

export function useGetCollectionOrdersFindByUuidOrExternalReference<
  TData = Awaited<
    ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrdersFindByUuidOrExternalReference<
  TData = Awaited<
    ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrdersFindByUuidOrExternalReference<
  TData = Awaited<
    ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Find Order By UUID or External Reference
 */

export function useGetCollectionOrdersFindByUuidOrExternalReference<
  TData = Awaited<
    ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionOrdersFindByUuidOrExternalReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionOrdersFindByUuidOrExternalReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCollectionOrdersFindByUuidOrExternalReferenceQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Orders
 */
export const getCollectionOrders = (
  organisationId: number,
  params?: GetCollectionOrdersParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionOrders200>(
    {
      url: `/collection/organisations/${organisationId}/orders`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCollectionOrdersQueryKey = (
  organisationId?: number,
  params?: GetCollectionOrdersParams
) => {
  return [
    `/collection/organisations/${organisationId}/orders`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCollectionOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionOrders>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionOrdersQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionOrders>>
  > = () => getCollectionOrders(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionOrders>>
>;
export type GetCollectionOrdersQueryError = unknown;

export function useGetCollectionOrders<
  TData = Awaited<ReturnType<typeof getCollectionOrders>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetCollectionOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrders>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionOrders<
  TData = Awaited<ReturnType<typeof getCollectionOrders>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionOrders>>,
          TError,
          Awaited<ReturnType<typeof getCollectionOrders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionOrders<
  TData = Awaited<ReturnType<typeof getCollectionOrders>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Orders
 */

export function useGetCollectionOrders<
  TData = Awaited<ReturnType<typeof getCollectionOrders>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCollectionOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionOrdersQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Order Refund
 */
export const postCollectionOrdersUuidRefund = (
  organisationId: number,
  uuid: string,
  postCollectionOrdersUuidRefundBody: BodyType<PostCollectionOrdersUuidRefundBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostCollectionOrdersUuidRefund200>(
    {
      url: `/collection/organisations/${organisationId}/orders/${uuid}/refund`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCollectionOrdersUuidRefundBody
    },
    options
  );
};

export const getPostCollectionOrdersUuidRefundMutationOptions = <
  TError = null | PostCollectionOrdersUuidRefund422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>,
    TError,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PostCollectionOrdersUuidRefundBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PostCollectionOrdersUuidRefundBody>;
  },
  TContext
> => {
  const mutationKey = ['postCollectionOrdersUuidRefund'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PostCollectionOrdersUuidRefundBody>;
    }
  > = (props) => {
    const { organisationId, uuid, data } = props ?? {};

    return postCollectionOrdersUuidRefund(
      organisationId,
      uuid,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCollectionOrdersUuidRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>
>;
export type PostCollectionOrdersUuidRefundMutationBody =
  BodyType<PostCollectionOrdersUuidRefundBody>;
export type PostCollectionOrdersUuidRefundMutationError =
  null | PostCollectionOrdersUuidRefund422;

/**
 * @summary Create Order Refund
 */
export const usePostCollectionOrdersUuidRefund = <
  TError = null | PostCollectionOrdersUuidRefund422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>,
      TError,
      {
        organisationId: number;
        uuid: string;
        data: BodyType<PostCollectionOrdersUuidRefundBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCollectionOrdersUuidRefund>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PostCollectionOrdersUuidRefundBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPostCollectionOrdersUuidRefundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Find Payment By UUID or Unique Reference
 */
export const getCollectionPaymentsFindByUuidOrUniqueReference = (
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionPaymentsFindByUuidOrUniqueReference200>(
    {
      url: `/collection/organisations/${organisationId}/payments/find_by_uuid_or_unique_reference`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCollectionPaymentsFindByUuidOrUniqueReferenceQueryKey = (
  organisationId?: number,
  params?: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams
) => {
  return [
    `/collection/organisations/${organisationId}/payments/find_by_uuid_or_unique_reference`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCollectionPaymentsFindByUuidOrUniqueReferenceQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionPaymentsFindByUuidOrUniqueReferenceQueryKey(
      organisationId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>>
  > = () =>
    getCollectionPaymentsFindByUuidOrUniqueReference(
      organisationId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionPaymentsFindByUuidOrUniqueReferenceQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>>
  >;
export type GetCollectionPaymentsFindByUuidOrUniqueReferenceQueryError =
  unknown;

export function useGetCollectionPaymentsFindByUuidOrUniqueReference<
  TData = Awaited<
    ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionPaymentsFindByUuidOrUniqueReference<
  TData = Awaited<
    ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionPaymentsFindByUuidOrUniqueReference<
  TData = Awaited<
    ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Find Payment By UUID or Unique Reference
 */

export function useGetCollectionPaymentsFindByUuidOrUniqueReference<
  TData = Awaited<
    ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionPaymentsFindByUuidOrUniqueReferenceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCollectionPaymentsFindByUuidOrUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCollectionPaymentsFindByUuidOrUniqueReferenceQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Payment
 */
export const getCollectionPaymentsUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionPaymentsUuid200>(
    {
      url: `/collection/organisations/${organisationId}/payments/${uuid}`,
      method: 'GET'
    },
    options
  );
};

export const getGetCollectionPaymentsUuidQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/collection/organisations/${organisationId}/payments/${uuid}`
  ] as const;
};

export const getGetCollectionPaymentsUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionPaymentsUuidQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionPaymentsUuid>>
  > = () => getCollectionPaymentsUuid(organisationId, uuid, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionPaymentsUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollectionPaymentsUuid>>
>;
export type GetCollectionPaymentsUuidQueryError = unknown;

export function useGetCollectionPaymentsUuid<
  TData = Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionPaymentsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionPaymentsUuid<
  TData = Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
          TError,
          Awaited<ReturnType<typeof getCollectionPaymentsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionPaymentsUuid<
  TData = Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Payment
 */

export function useGetCollectionPaymentsUuid<
  TData = Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionPaymentsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollectionPaymentsUuidQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Status Counts Reports
 */
export const getCollectionStatsOrdersStatusCountsReports = (
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCollectionStatsOrdersStatusCountsReports200>(
    {
      url: `/collection/organisations/${organisationId}/stats/orders/status_counts_reports`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCollectionStatsOrdersStatusCountsReportsQueryKey = (
  organisationId?: number,
  params?: GetCollectionStatsOrdersStatusCountsReportsParams
) => {
  return [
    `/collection/organisations/${organisationId}/stats/orders/status_counts_reports`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCollectionStatsOrdersStatusCountsReportsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCollectionStatsOrdersStatusCountsReportsQueryKey(
      organisationId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>
  > = () =>
    getCollectionStatsOrdersStatusCountsReports(
      organisationId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollectionStatsOrdersStatusCountsReportsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>
  >;
export type GetCollectionStatsOrdersStatusCountsReportsQueryError = unknown;

export function useGetCollectionStatsOrdersStatusCountsReports<
  TData = Awaited<
    ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollectionStatsOrdersStatusCountsReports<
  TData = Awaited<
    ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollectionStatsOrdersStatusCountsReports<
  TData = Awaited<
    ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Status Counts Reports
 */

export function useGetCollectionStatsOrdersStatusCountsReports<
  TData = Awaited<
    ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>
  >,
  TError = unknown
>(
  organisationId: number,
  params: GetCollectionStatsOrdersStatusCountsReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollectionStatsOrdersStatusCountsReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCollectionStatsOrdersStatusCountsReportsQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Countries
 */
export const getCoreCountries = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCoreCountries200>(
    { url: `/core/countries`, method: 'GET' },
    options
  );
};

export const getGetCoreCountriesQueryKey = () => {
  return [`/core/countries`] as const;
};

export const getGetCoreCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoreCountries>>,
  TError = GetCoreCountries422
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCoreCountries>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoreCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoreCountries>>
  > = () => getCoreCountries(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoreCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCoreCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoreCountries>>
>;
export type GetCoreCountriesQueryError = GetCoreCountries422;

export function useGetCoreCountries<
  TData = Awaited<ReturnType<typeof getCoreCountries>>,
  TError = GetCoreCountries422
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCoreCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoreCountries>>,
          TError,
          Awaited<ReturnType<typeof getCoreCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCoreCountries<
  TData = Awaited<ReturnType<typeof getCoreCountries>>,
  TError = GetCoreCountries422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCoreCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoreCountries>>,
          TError,
          Awaited<ReturnType<typeof getCoreCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCoreCountries<
  TData = Awaited<ReturnType<typeof getCoreCountries>>,
  TError = GetCoreCountries422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCoreCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Countries
 */

export function useGetCoreCountries<
  TData = Awaited<ReturnType<typeof getCoreCountries>>,
  TError = GetCoreCountries422
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCoreCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCoreCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get ledger balances per asset
 */
export const getCryptoBalances = (
  organisationId: number,
  params?: GetCryptoBalancesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoBalances200>(
    {
      url: `/crypto/organisations/${organisationId}/balances`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoBalancesQueryKey = (
  organisationId?: number,
  params?: GetCryptoBalancesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/balances`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoBalances>>,
  TError = GetCryptoBalances401
>(
  organisationId: number,
  params?: GetCryptoBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBalances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoBalancesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoBalances>>
  > = () => getCryptoBalances(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoBalances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoBalances>>
>;
export type GetCryptoBalancesQueryError = GetCryptoBalances401;

export function useGetCryptoBalances<
  TData = Awaited<ReturnType<typeof getCryptoBalances>>,
  TError = GetCryptoBalances401
>(
  organisationId: number,
  params: undefined | GetCryptoBalancesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoBalances>>,
          TError,
          Awaited<ReturnType<typeof getCryptoBalances>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoBalances<
  TData = Awaited<ReturnType<typeof getCryptoBalances>>,
  TError = GetCryptoBalances401
>(
  organisationId: number,
  params?: GetCryptoBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoBalances>>,
          TError,
          Awaited<ReturnType<typeof getCryptoBalances>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoBalances<
  TData = Awaited<ReturnType<typeof getCryptoBalances>>,
  TError = GetCryptoBalances401
>(
  organisationId: number,
  params?: GetCryptoBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBalances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get ledger balances per asset
 */

export function useGetCryptoBalances<
  TData = Awaited<ReturnType<typeof getCryptoBalances>>,
  TError = GetCryptoBalances401
>(
  organisationId: number,
  params?: GetCryptoBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBalances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoBalancesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the deposit wallet address for an asset and network
 */
export const getCryptoDepositAddresses = (
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoDepositAddresses200>(
    {
      url: `/crypto/organisations/${organisationId}/deposit_addresses`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoDepositAddressesQueryKey = (
  organisationId?: number,
  params?: GetCryptoDepositAddressesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/deposit_addresses`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoDepositAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
  TError = GetCryptoDepositAddresses401
>(
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoDepositAddressesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoDepositAddresses>>
  > = () => getCryptoDepositAddresses(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoDepositAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoDepositAddresses>>
>;
export type GetCryptoDepositAddressesQueryError = GetCryptoDepositAddresses401;

export function useGetCryptoDepositAddresses<
  TData = Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
  TError = GetCryptoDepositAddresses401
>(
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositAddresses>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoDepositAddresses<
  TData = Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
  TError = GetCryptoDepositAddresses401
>(
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositAddresses>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoDepositAddresses<
  TData = Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
  TError = GetCryptoDepositAddresses401
>(
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get the deposit wallet address for an asset and network
 */

export function useGetCryptoDepositAddresses<
  TData = Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
  TError = GetCryptoDepositAddresses401
>(
  organisationId: number,
  params: GetCryptoDepositAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositAddresses>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoDepositAddressesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get deposit-from currencies and their networks
 */
export const getCryptoDepositFromCurrencies = (
  organisationId: number,
  params?: GetCryptoDepositFromCurrenciesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoDepositFromCurrencies200>(
    {
      url: `/crypto/organisations/${organisationId}/deposit_from_currencies`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoDepositFromCurrenciesQueryKey = (
  organisationId?: number,
  params?: GetCryptoDepositFromCurrenciesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/deposit_from_currencies`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoDepositFromCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
  TError = GetCryptoDepositFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoDepositFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoDepositFromCurrenciesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>
  > = () =>
    getCryptoDepositFromCurrencies(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoDepositFromCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>
>;
export type GetCryptoDepositFromCurrenciesQueryError =
  GetCryptoDepositFromCurrencies401;

export function useGetCryptoDepositFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
  TError = GetCryptoDepositFromCurrencies401
>(
  organisationId: number,
  params: undefined | GetCryptoDepositFromCurrenciesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoDepositFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
  TError = GetCryptoDepositFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoDepositFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoDepositFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
  TError = GetCryptoDepositFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoDepositFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get deposit-from currencies and their networks
 */

export function useGetCryptoDepositFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
  TError = GetCryptoDepositFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoDepositFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoDepositFromCurrenciesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get deposit-from networks
 */
export const getCryptoDepositFromNetworks = (
  organisationId: number,
  params?: GetCryptoDepositFromNetworksParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoDepositFromNetworks200>(
    {
      url: `/crypto/organisations/${organisationId}/deposit_from_networks`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoDepositFromNetworksQueryKey = (
  organisationId?: number,
  params?: GetCryptoDepositFromNetworksParams
) => {
  return [
    `/crypto/organisations/${organisationId}/deposit_from_networks`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoDepositFromNetworksQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
  TError = GetCryptoDepositFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoDepositFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoDepositFromNetworksQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>
  > = () =>
    getCryptoDepositFromNetworks(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoDepositFromNetworksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>
>;
export type GetCryptoDepositFromNetworksQueryError =
  GetCryptoDepositFromNetworks401;

export function useGetCryptoDepositFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
  TError = GetCryptoDepositFromNetworks401
>(
  organisationId: number,
  params: undefined | GetCryptoDepositFromNetworksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoDepositFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
  TError = GetCryptoDepositFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoDepositFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoDepositFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
  TError = GetCryptoDepositFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoDepositFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get deposit-from networks
 */

export function useGetCryptoDepositFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
  TError = GetCryptoDepositFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoDepositFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDepositFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoDepositFromNetworksQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Layer1 deposit events grouped by transaction
 */
export const getCryptoDeposits = (
  organisationId: number,
  params?: GetCryptoDepositsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoDeposits200>(
    {
      url: `/crypto/organisations/${organisationId}/deposits`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoDepositsQueryKey = (
  organisationId?: number,
  params?: GetCryptoDepositsParams
) => {
  return [
    `/crypto/organisations/${organisationId}/deposits`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoDepositsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoDeposits>>,
  TError = GetCryptoDeposits401 | GetCryptoDeposits422
>(
  organisationId: number,
  params?: GetCryptoDepositsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDeposits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoDepositsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoDeposits>>
  > = () => getCryptoDeposits(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoDeposits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoDepositsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoDeposits>>
>;
export type GetCryptoDepositsQueryError =
  | GetCryptoDeposits401
  | GetCryptoDeposits422;

export function useGetCryptoDeposits<
  TData = Awaited<ReturnType<typeof getCryptoDeposits>>,
  TError = GetCryptoDeposits401 | GetCryptoDeposits422
>(
  organisationId: number,
  params: undefined | GetCryptoDepositsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDeposits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDeposits>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDeposits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoDeposits<
  TData = Awaited<ReturnType<typeof getCryptoDeposits>>,
  TError = GetCryptoDeposits401 | GetCryptoDeposits422
>(
  organisationId: number,
  params?: GetCryptoDepositsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDeposits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoDeposits>>,
          TError,
          Awaited<ReturnType<typeof getCryptoDeposits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoDeposits<
  TData = Awaited<ReturnType<typeof getCryptoDeposits>>,
  TError = GetCryptoDeposits401 | GetCryptoDeposits422
>(
  organisationId: number,
  params?: GetCryptoDepositsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDeposits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Layer1 deposit events grouped by transaction
 */

export function useGetCryptoDeposits<
  TData = Awaited<ReturnType<typeof getCryptoDeposits>>,
  TError = GetCryptoDeposits401 | GetCryptoDeposits422
>(
  organisationId: number,
  params?: GetCryptoDepositsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoDeposits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoDepositsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the eligible "To" virtual accounts and the default one (crypto widget account selector)
 */
export const getCryptoEligibleVbas = (
  organisationId: number,
  params?: GetCryptoEligibleVbasParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoEligibleVbas200>(
    {
      url: `/crypto/organisations/${organisationId}/eligible_vbas`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoEligibleVbasQueryKey = (
  organisationId?: number,
  params?: GetCryptoEligibleVbasParams
) => {
  return [
    `/crypto/organisations/${organisationId}/eligible_vbas`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoEligibleVbasQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
  TError = GetCryptoEligibleVbas401
>(
  organisationId: number,
  params?: GetCryptoEligibleVbasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoEligibleVbasQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoEligibleVbas>>
  > = () => getCryptoEligibleVbas(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoEligibleVbasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoEligibleVbas>>
>;
export type GetCryptoEligibleVbasQueryError = GetCryptoEligibleVbas401;

export function useGetCryptoEligibleVbas<
  TData = Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
  TError = GetCryptoEligibleVbas401
>(
  organisationId: number,
  params: undefined | GetCryptoEligibleVbasParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
          TError,
          Awaited<ReturnType<typeof getCryptoEligibleVbas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoEligibleVbas<
  TData = Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
  TError = GetCryptoEligibleVbas401
>(
  organisationId: number,
  params?: GetCryptoEligibleVbasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
          TError,
          Awaited<ReturnType<typeof getCryptoEligibleVbas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoEligibleVbas<
  TData = Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
  TError = GetCryptoEligibleVbas401
>(
  organisationId: number,
  params?: GetCryptoEligibleVbasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get the eligible "To" virtual accounts and the default one (crypto widget account selector)
 */

export function useGetCryptoEligibleVbas<
  TData = Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
  TError = GetCryptoEligibleVbas401
>(
  organisationId: number,
  params?: GetCryptoEligibleVbasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoEligibleVbas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoEligibleVbasQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get exchange-from currencies and their networks (used to build the c2c widget currency selector)
 */
export const getCryptoExchangeFromCurrencies = (
  organisationId: number,
  params?: GetCryptoExchangeFromCurrenciesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoExchangeFromCurrencies200>(
    {
      url: `/crypto/organisations/${organisationId}/exchange_from_currencies`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoExchangeFromCurrenciesQueryKey = (
  organisationId?: number,
  params?: GetCryptoExchangeFromCurrenciesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/exchange_from_currencies`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoExchangeFromCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
  TError = GetCryptoExchangeFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoExchangeFromCurrenciesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>
  > = () =>
    getCryptoExchangeFromCurrencies(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoExchangeFromCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>
>;
export type GetCryptoExchangeFromCurrenciesQueryError =
  GetCryptoExchangeFromCurrencies401;

export function useGetCryptoExchangeFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
  TError = GetCryptoExchangeFromCurrencies401
>(
  organisationId: number,
  params: undefined | GetCryptoExchangeFromCurrenciesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoExchangeFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
  TError = GetCryptoExchangeFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoExchangeFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
  TError = GetCryptoExchangeFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get exchange-from currencies and their networks (used to build the c2c widget currency selector)
 */

export function useGetCryptoExchangeFromCurrencies<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
  TError = GetCryptoExchangeFromCurrencies401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromCurrenciesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoExchangeFromCurrenciesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get exchange-from networks and their balances (used to build the crypto widget network selector)
 */
export const getCryptoExchangeFromNetworks = (
  organisationId: number,
  params?: GetCryptoExchangeFromNetworksParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoExchangeFromNetworks200>(
    {
      url: `/crypto/organisations/${organisationId}/exchange_from_networks`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoExchangeFromNetworksQueryKey = (
  organisationId?: number,
  params?: GetCryptoExchangeFromNetworksParams
) => {
  return [
    `/crypto/organisations/${organisationId}/exchange_from_networks`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoExchangeFromNetworksQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
  TError = GetCryptoExchangeFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoExchangeFromNetworksQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>
  > = () =>
    getCryptoExchangeFromNetworks(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoExchangeFromNetworksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>
>;
export type GetCryptoExchangeFromNetworksQueryError =
  GetCryptoExchangeFromNetworks401;

export function useGetCryptoExchangeFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
  TError = GetCryptoExchangeFromNetworks401
>(
  organisationId: number,
  params: undefined | GetCryptoExchangeFromNetworksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoExchangeFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
  TError = GetCryptoExchangeFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoExchangeFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
  TError = GetCryptoExchangeFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get exchange-from networks and their balances (used to build the crypto widget network selector)
 */

export function useGetCryptoExchangeFromNetworks<
  TData = Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
  TError = GetCryptoExchangeFromNetworks401
>(
  organisationId: number,
  params?: GetCryptoExchangeFromNetworksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeFromNetworks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoExchangeFromNetworksQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get exchange rate quote
 */
export const getCryptoExchangeRates = (
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoExchangeRates200>(
    {
      url: `/crypto/organisations/${organisationId}/exchange_rates`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoExchangeRatesQueryKey = (
  organisationId?: number,
  params?: GetCryptoExchangeRatesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/exchange_rates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoExchangeRatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoExchangeRates>>,
  TError = GetCryptoExchangeRates401 | GetCryptoExchangeRates422
>(
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeRates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoExchangeRatesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoExchangeRates>>
  > = () => getCryptoExchangeRates(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoExchangeRates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoExchangeRatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoExchangeRates>>
>;
export type GetCryptoExchangeRatesQueryError =
  | GetCryptoExchangeRates401
  | GetCryptoExchangeRates422;

export function useGetCryptoExchangeRates<
  TData = Awaited<ReturnType<typeof getCryptoExchangeRates>>,
  TError = GetCryptoExchangeRates401 | GetCryptoExchangeRates422
>(
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeRates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeRates>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeRates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoExchangeRates<
  TData = Awaited<ReturnType<typeof getCryptoExchangeRates>>,
  TError = GetCryptoExchangeRates401 | GetCryptoExchangeRates422
>(
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeRates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchangeRates>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchangeRates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoExchangeRates<
  TData = Awaited<ReturnType<typeof getCryptoExchangeRates>>,
  TError = GetCryptoExchangeRates401 | GetCryptoExchangeRates422
>(
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeRates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get exchange rate quote
 */

export function useGetCryptoExchangeRates<
  TData = Awaited<ReturnType<typeof getCryptoExchangeRates>>,
  TError = GetCryptoExchangeRates401 | GetCryptoExchangeRates422
>(
  organisationId: number,
  params: GetCryptoExchangeRatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchangeRates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoExchangeRatesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get exchanges list
 */
export const getCryptoExchanges = (
  organisationId: number,
  params?: GetCryptoExchangesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoExchanges200>(
    {
      url: `/crypto/organisations/${organisationId}/exchanges`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoExchangesQueryKey = (
  organisationId?: number,
  params?: GetCryptoExchangesParams
) => {
  return [
    `/crypto/organisations/${organisationId}/exchanges`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoExchangesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoExchanges>>,
  TError = GetCryptoExchanges401 | GetCryptoExchanges422
>(
  organisationId: number,
  params?: GetCryptoExchangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchanges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoExchangesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoExchanges>>
  > = () => getCryptoExchanges(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoExchanges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoExchangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoExchanges>>
>;
export type GetCryptoExchangesQueryError =
  | GetCryptoExchanges401
  | GetCryptoExchanges422;

export function useGetCryptoExchanges<
  TData = Awaited<ReturnType<typeof getCryptoExchanges>>,
  TError = GetCryptoExchanges401 | GetCryptoExchanges422
>(
  organisationId: number,
  params: undefined | GetCryptoExchangesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchanges>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchanges>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchanges>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoExchanges<
  TData = Awaited<ReturnType<typeof getCryptoExchanges>>,
  TError = GetCryptoExchanges401 | GetCryptoExchanges422
>(
  organisationId: number,
  params?: GetCryptoExchangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchanges>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoExchanges>>,
          TError,
          Awaited<ReturnType<typeof getCryptoExchanges>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoExchanges<
  TData = Awaited<ReturnType<typeof getCryptoExchanges>>,
  TError = GetCryptoExchanges401 | GetCryptoExchanges422
>(
  organisationId: number,
  params?: GetCryptoExchangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchanges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get exchanges list
 */

export function useGetCryptoExchanges<
  TData = Awaited<ReturnType<typeof getCryptoExchanges>>,
  TError = GetCryptoExchanges401 | GetCryptoExchanges422
>(
  organisationId: number,
  params?: GetCryptoExchangesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoExchanges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoExchangesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create exchange from quote uuid
 */
export const postCryptoExchanges = (
  organisationId: number,
  postCryptoExchangesBody: BodyType<PostCryptoExchangesBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostCryptoExchanges200>(
    {
      url: `/crypto/organisations/${organisationId}/exchanges`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCryptoExchangesBody
    },
    options
  );
};

export const getPostCryptoExchangesMutationOptions = <
  TError = PostCryptoExchanges401 | PostCryptoExchanges422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCryptoExchanges>>,
    TError,
    { organisationId: number; data: BodyType<PostCryptoExchangesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCryptoExchanges>>,
  TError,
  { organisationId: number; data: BodyType<PostCryptoExchangesBody> },
  TContext
> => {
  const mutationKey = ['postCryptoExchanges'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCryptoExchanges>>,
    { organisationId: number; data: BodyType<PostCryptoExchangesBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postCryptoExchanges(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCryptoExchangesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCryptoExchanges>>
>;
export type PostCryptoExchangesMutationBody = BodyType<PostCryptoExchangesBody>;
export type PostCryptoExchangesMutationError =
  | PostCryptoExchanges401
  | PostCryptoExchanges422;

/**
 * @summary Create exchange from quote uuid
 */
export const usePostCryptoExchanges = <
  TError = PostCryptoExchanges401 | PostCryptoExchanges422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCryptoExchanges>>,
      TError,
      { organisationId: number; data: BodyType<PostCryptoExchangesBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCryptoExchanges>>,
  TError,
  { organisationId: number; data: BodyType<PostCryptoExchangesBody> },
  TContext
> => {
  const mutationOptions = getPostCryptoExchangesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get token by organisation with token
 */
export const getCryptoBigedirectToken = (
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoBigedirectToken200>(
    {
      url: `/crypto/organisations/${organisationId}/bigedirect/token`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoBigedirectTokenQueryKey = (
  organisationId?: number,
  params?: GetCryptoBigedirectTokenParams
) => {
  return [
    `/crypto/organisations/${organisationId}/bigedirect/token`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoBigedirectTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
  TError = GetCryptoBigedirectToken401 | GetCryptoBigedirectToken422
>(
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoBigedirectTokenQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoBigedirectToken>>
  > = () => getCryptoBigedirectToken(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoBigedirectTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoBigedirectToken>>
>;
export type GetCryptoBigedirectTokenQueryError =
  | GetCryptoBigedirectToken401
  | GetCryptoBigedirectToken422;

export function useGetCryptoBigedirectToken<
  TData = Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
  TError = GetCryptoBigedirectToken401 | GetCryptoBigedirectToken422
>(
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getCryptoBigedirectToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoBigedirectToken<
  TData = Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
  TError = GetCryptoBigedirectToken401 | GetCryptoBigedirectToken422
>(
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getCryptoBigedirectToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoBigedirectToken<
  TData = Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
  TError = GetCryptoBigedirectToken401 | GetCryptoBigedirectToken422
>(
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get token by organisation with token
 */

export function useGetCryptoBigedirectToken<
  TData = Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
  TError = GetCryptoBigedirectToken401 | GetCryptoBigedirectToken422
>(
  organisationId: number,
  params: GetCryptoBigedirectTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoBigedirectToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoBigedirectTokenQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get token by organisation with token
 */
export const getCryptoC2cToken = (
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoC2cToken200>(
    {
      url: `/crypto/organisations/${organisationId}/c2c/token`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoC2cTokenQueryKey = (
  organisationId?: number,
  params?: GetCryptoC2cTokenParams
) => {
  return [
    `/crypto/organisations/${organisationId}/c2c/token`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoC2cTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoC2cToken>>,
  TError = GetCryptoC2cToken401 | GetCryptoC2cToken422
>(
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoC2cToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoC2cTokenQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoC2cToken>>
  > = () => getCryptoC2cToken(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoC2cToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoC2cTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoC2cToken>>
>;
export type GetCryptoC2cTokenQueryError =
  | GetCryptoC2cToken401
  | GetCryptoC2cToken422;

export function useGetCryptoC2cToken<
  TData = Awaited<ReturnType<typeof getCryptoC2cToken>>,
  TError = GetCryptoC2cToken401 | GetCryptoC2cToken422
>(
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoC2cToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoC2cToken>>,
          TError,
          Awaited<ReturnType<typeof getCryptoC2cToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoC2cToken<
  TData = Awaited<ReturnType<typeof getCryptoC2cToken>>,
  TError = GetCryptoC2cToken401 | GetCryptoC2cToken422
>(
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoC2cToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoC2cToken>>,
          TError,
          Awaited<ReturnType<typeof getCryptoC2cToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoC2cToken<
  TData = Awaited<ReturnType<typeof getCryptoC2cToken>>,
  TError = GetCryptoC2cToken401 | GetCryptoC2cToken422
>(
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoC2cToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get token by organisation with token
 */

export function useGetCryptoC2cToken<
  TData = Awaited<ReturnType<typeof getCryptoC2cToken>>,
  TError = GetCryptoC2cToken401 | GetCryptoC2cToken422
>(
  organisationId: number,
  params: GetCryptoC2cTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoC2cToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoC2cTokenQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Layer1 transaction feed items
 */
export const getCryptoTransactions = (
  organisationId: number,
  params?: GetCryptoTransactionsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCryptoTransactions200>(
    {
      url: `/crypto/organisations/${organisationId}/transactions`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCryptoTransactionsQueryKey = (
  organisationId?: number,
  params?: GetCryptoTransactionsParams
) => {
  return [
    `/crypto/organisations/${organisationId}/transactions`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCryptoTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCryptoTransactions>>,
  TError = GetCryptoTransactions401 | GetCryptoTransactions422
>(
  organisationId: number,
  params?: GetCryptoTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCryptoTransactionsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCryptoTransactions>>
  > = () => getCryptoTransactions(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCryptoTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCryptoTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCryptoTransactions>>
>;
export type GetCryptoTransactionsQueryError =
  | GetCryptoTransactions401
  | GetCryptoTransactions422;

export function useGetCryptoTransactions<
  TData = Awaited<ReturnType<typeof getCryptoTransactions>>,
  TError = GetCryptoTransactions401 | GetCryptoTransactions422
>(
  organisationId: number,
  params: undefined | GetCryptoTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCryptoTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCryptoTransactions<
  TData = Awaited<ReturnType<typeof getCryptoTransactions>>,
  TError = GetCryptoTransactions401 | GetCryptoTransactions422
>(
  organisationId: number,
  params?: GetCryptoTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCryptoTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCryptoTransactions<
  TData = Awaited<ReturnType<typeof getCryptoTransactions>>,
  TError = GetCryptoTransactions401 | GetCryptoTransactions422
>(
  organisationId: number,
  params?: GetCryptoTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Layer1 transaction feed items
 */

export function useGetCryptoTransactions<
  TData = Awaited<ReturnType<typeof getCryptoTransactions>>,
  TError = GetCryptoTransactions401 | GetCryptoTransactions422
>(
  organisationId: number,
  params?: GetCryptoTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCryptoTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCryptoTransactionsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Customer Organisation Address
 */
export const getCustomerAddress = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerAddress200>(
    { url: `/customer/organisations/${organisationId}/address`, method: 'GET' },
    options
  );
};

export const getGetCustomerAddressQueryKey = (organisationId?: number) => {
  return [`/customer/organisations/${organisationId}/address`] as const;
};

export const getGetCustomerAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAddress>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerAddressQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAddress>>
  > = () => getCustomerAddress(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAddress>>
>;
export type GetCustomerAddressQueryError = unknown;

export function useGetCustomerAddress<
  TData = Awaited<ReturnType<typeof getCustomerAddress>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAddress>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAddress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerAddress<
  TData = Awaited<ReturnType<typeof getCustomerAddress>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAddress>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAddress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerAddress<
  TData = Awaited<ReturnType<typeof getCustomerAddress>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Customer Organisation Address
 */

export function useGetCustomerAddress<
  TData = Awaited<ReturnType<typeof getCustomerAddress>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerAddressQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index business units
 */
export const getCustomerBusinessUnits = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerBusinessUnits200>(
    {
      url: `/customer/organisations/${organisationId}/business_units`,
      method: 'GET'
    },
    options
  );
};

export const getGetCustomerBusinessUnitsQueryKey = (
  organisationId?: number
) => {
  return [`/customer/organisations/${organisationId}/business_units`] as const;
};

export const getGetCustomerBusinessUnitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerBusinessUnitsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerBusinessUnits>>
  > = () => getCustomerBusinessUnits(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerBusinessUnitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerBusinessUnits>>
>;
export type GetCustomerBusinessUnitsQueryError = unknown;

export function useGetCustomerBusinessUnits<
  TData = Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusinessUnits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerBusinessUnits<
  TData = Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusinessUnits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerBusinessUnits<
  TData = Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index business units
 */

export function useGetCustomerBusinessUnits<
  TData = Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerBusinessUnitsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Configurations
 */
export const getCustomerConfigurations = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerConfigurations200>(
    {
      url: `/customer/organisations/${organisationId}/configurations`,
      method: 'GET'
    },
    options
  );
};

export const getGetCustomerConfigurationsQueryKey = (
  organisationId?: number
) => {
  return [`/customer/organisations/${organisationId}/configurations`] as const;
};

export const getGetCustomerConfigurationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerConfigurations>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerConfigurations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerConfigurationsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerConfigurations>>
  > = () => getCustomerConfigurations(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerConfigurations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerConfigurationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerConfigurations>>
>;
export type GetCustomerConfigurationsQueryError = unknown;

export function useGetCustomerConfigurations<
  TData = Awaited<ReturnType<typeof getCustomerConfigurations>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerConfigurations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerConfigurations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerConfigurations<
  TData = Awaited<ReturnType<typeof getCustomerConfigurations>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerConfigurations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerConfigurations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerConfigurations<
  TData = Awaited<ReturnType<typeof getCustomerConfigurations>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerConfigurations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Configurations
 */

export function useGetCustomerConfigurations<
  TData = Awaited<ReturnType<typeof getCustomerConfigurations>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerConfigurations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerConfigurationsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get contracted products organisation
 */
export const getCustomerContractedProducts = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerContractedProducts200>(
    {
      url: `/customer/organisations/${organisationId}/contracted_products`,
      method: 'GET'
    },
    options
  );
};

export const getGetCustomerContractedProductsQueryKey = (
  organisationId?: number
) => {
  return [
    `/customer/organisations/${organisationId}/contracted_products`
  ] as const;
};

export const getGetCustomerContractedProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerContractedProducts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerContractedProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerContractedProductsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerContractedProducts>>
  > = () => getCustomerContractedProducts(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerContractedProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerContractedProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerContractedProducts>>
>;
export type GetCustomerContractedProductsQueryError = unknown;

export function useGetCustomerContractedProducts<
  TData = Awaited<ReturnType<typeof getCustomerContractedProducts>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerContractedProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerContractedProducts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerContractedProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerContractedProducts<
  TData = Awaited<ReturnType<typeof getCustomerContractedProducts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerContractedProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerContractedProducts>>,
          TError,
          Awaited<ReturnType<typeof getCustomerContractedProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerContractedProducts<
  TData = Awaited<ReturnType<typeof getCustomerContractedProducts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerContractedProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get contracted products organisation
 */

export function useGetCustomerContractedProducts<
  TData = Awaited<ReturnType<typeof getCustomerContractedProducts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerContractedProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerContractedProductsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Creditor
 */
export const getCustomerCreditorsId = (
  organisationId: number,
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerCreditorsId200>(
    {
      url: `/customer/organisations/${organisationId}/creditors/${id}`,
      method: 'GET'
    },
    options
  );
};

export const getGetCustomerCreditorsIdQueryKey = (
  organisationId?: number,
  id?: number
) => {
  return [`/customer/organisations/${organisationId}/creditors/${id}`] as const;
};

export const getGetCustomerCreditorsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerCreditorsId>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditorsId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerCreditorsIdQueryKey(organisationId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerCreditorsId>>
  > = () => getCustomerCreditorsId(organisationId, id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && id),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerCreditorsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerCreditorsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerCreditorsId>>
>;
export type GetCustomerCreditorsIdQueryError = unknown;

export function useGetCustomerCreditorsId<
  TData = Awaited<ReturnType<typeof getCustomerCreditorsId>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditorsId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditorsId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditorsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerCreditorsId<
  TData = Awaited<ReturnType<typeof getCustomerCreditorsId>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditorsId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditorsId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditorsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerCreditorsId<
  TData = Awaited<ReturnType<typeof getCustomerCreditorsId>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditorsId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Creditor
 */

export function useGetCustomerCreditorsId<
  TData = Awaited<ReturnType<typeof getCustomerCreditorsId>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditorsId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerCreditorsIdQueryOptions(
    organisationId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Creditor
 */
export const deleteCustomerCreditorsId = (
  organisationId: number,
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteCustomerCreditorsId200>(
    {
      url: `/customer/organisations/${organisationId}/creditors/${id}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteCustomerCreditorsIdMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomerCreditorsId>>,
    TError,
    { organisationId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomerCreditorsId>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteCustomerCreditorsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomerCreditorsId>>,
    { organisationId: number; id: number }
  > = (props) => {
    const { organisationId, id } = props ?? {};

    return deleteCustomerCreditorsId(organisationId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomerCreditorsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomerCreditorsId>>
>;

export type DeleteCustomerCreditorsIdMutationError = null;

/**
 * @summary Delete Creditor
 */
export const useDeleteCustomerCreditorsId = <TError = null, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomerCreditorsId>>,
      TError,
      { organisationId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomerCreditorsId>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationOptions = getDeleteCustomerCreditorsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Validate Creditor
 */
export const postCustomerCreditorsValidate = (
  organisationId: number,
  postCustomerCreditorsValidateBody: BodyType<PostCustomerCreditorsValidateBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<null>(
    {
      url: `/customer/organisations/${organisationId}/creditors/validate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCustomerCreditorsValidateBody
    },
    options
  );
};

export const getPostCustomerCreditorsValidateMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerCreditorsValidate>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostCustomerCreditorsValidateBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerCreditorsValidate>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerCreditorsValidateBody> },
  TContext
> => {
  const mutationKey = ['postCustomerCreditorsValidate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerCreditorsValidate>>,
    {
      organisationId: number;
      data: BodyType<PostCustomerCreditorsValidateBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postCustomerCreditorsValidate(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCustomerCreditorsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerCreditorsValidate>>
>;
export type PostCustomerCreditorsValidateMutationBody =
  BodyType<PostCustomerCreditorsValidateBody>;
export type PostCustomerCreditorsValidateMutationError = null;

/**
 * @summary Validate Creditor
 */
export const usePostCustomerCreditorsValidate = <
  TError = null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerCreditorsValidate>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostCustomerCreditorsValidateBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerCreditorsValidate>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerCreditorsValidateBody> },
  TContext
> => {
  const mutationOptions =
    getPostCustomerCreditorsValidateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Creditors
 */
export const getCustomerCreditors = (
  organisationId: number,
  params?: GetCustomerCreditorsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerCreditors200>(
    {
      url: `/customer/organisations/${organisationId}/creditors`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCustomerCreditorsQueryKey = (
  organisationId?: number,
  params?: GetCustomerCreditorsParams
) => {
  return [
    `/customer/organisations/${organisationId}/creditors`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCustomerCreditorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerCreditors>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCustomerCreditorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerCreditorsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerCreditors>>
  > = () => getCustomerCreditors(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerCreditors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerCreditorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerCreditors>>
>;
export type GetCustomerCreditorsQueryError = unknown;

export function useGetCustomerCreditors<
  TData = Awaited<ReturnType<typeof getCustomerCreditors>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetCustomerCreditorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditors>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditors>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerCreditors<
  TData = Awaited<ReturnType<typeof getCustomerCreditors>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCustomerCreditorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditors>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditors>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerCreditors<
  TData = Awaited<ReturnType<typeof getCustomerCreditors>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCustomerCreditorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Creditors
 */

export function useGetCustomerCreditors<
  TData = Awaited<ReturnType<typeof getCustomerCreditors>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetCustomerCreditorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditors>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerCreditorsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Creditor
 */
export const postCustomerCreditors = (
  organisationId: number,
  postCustomerCreditorsBody: BodyType<PostCustomerCreditorsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostCustomerCreditors200>(
    {
      url: `/customer/organisations/${organisationId}/creditors`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCustomerCreditorsBody
    },
    options
  );
};

export const getPostCustomerCreditorsMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerCreditors>>,
    TError,
    { organisationId: number; data: BodyType<PostCustomerCreditorsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerCreditors>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerCreditorsBody> },
  TContext
> => {
  const mutationKey = ['postCustomerCreditors'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerCreditors>>,
    { organisationId: number; data: BodyType<PostCustomerCreditorsBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postCustomerCreditors(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCustomerCreditorsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerCreditors>>
>;
export type PostCustomerCreditorsMutationBody =
  BodyType<PostCustomerCreditorsBody>;
export type PostCustomerCreditorsMutationError = null;

/**
 * @summary Create Creditor
 */
export const usePostCustomerCreditors = <TError = null, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerCreditors>>,
      TError,
      { organisationId: number; data: BodyType<PostCustomerCreditorsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerCreditors>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerCreditorsBody> },
  TContext
> => {
  const mutationOptions = getPostCustomerCreditorsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Organisations
 */
export const getCustomerOrganisations = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerOrganisations200>(
    { url: `/customer/organisations`, method: 'GET' },
    options
  );
};

export const getGetCustomerOrganisationsQueryKey = () => {
  return [`/customer/organisations`] as const;
};

export const getGetCustomerOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerOrganisations>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerOrganisations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerOrganisationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerOrganisations>>
  > = () => getCustomerOrganisations(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerOrganisations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerOrganisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerOrganisations>>
>;
export type GetCustomerOrganisationsQueryError = unknown;

export function useGetCustomerOrganisations<
  TData = Awaited<ReturnType<typeof getCustomerOrganisations>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerOrganisations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerOrganisations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerOrganisations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerOrganisations<
  TData = Awaited<ReturnType<typeof getCustomerOrganisations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerOrganisations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerOrganisations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerOrganisations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerOrganisations<
  TData = Awaited<ReturnType<typeof getCustomerOrganisations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerOrganisations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Organisations
 */

export function useGetCustomerOrganisations<
  TData = Awaited<ReturnType<typeof getCustomerOrganisations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerOrganisations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerOrganisationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set Default Organisation
 */
export const postCustomerOrganisationsIdSetDefault = (
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<null>(
    { url: `/customer/organisations/${id}/set_default`, method: 'POST' },
    options
  );
};

export const getPostCustomerOrganisationsIdSetDefaultMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postCustomerOrganisationsIdSetDefault'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return postCustomerOrganisationsIdSetDefault(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCustomerOrganisationsIdSetDefaultMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>
>;

export type PostCustomerOrganisationsIdSetDefaultMutationError = null;

/**
 * @summary Set Default Organisation
 */
export const usePostCustomerOrganisationsIdSetDefault = <
  TError = null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerOrganisationsIdSetDefault>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getPostCustomerOrganisationsIdSetDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index roles
 */
export const getCustomerRoles = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerRoles200>(
    { url: `/customer/organisations/${organisationId}/roles`, method: 'GET' },
    options
  );
};

export const getGetCustomerRolesQueryKey = (organisationId?: number) => {
  return [`/customer/organisations/${organisationId}/roles`] as const;
};

export const getGetCustomerRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerRoles>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerRolesQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerRoles>>
  > = () => getCustomerRoles(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerRoles>>
>;
export type GetCustomerRolesQueryError = unknown;

export function useGetCustomerRoles<
  TData = Awaited<ReturnType<typeof getCustomerRoles>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerRoles>>,
          TError,
          Awaited<ReturnType<typeof getCustomerRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerRoles<
  TData = Awaited<ReturnType<typeof getCustomerRoles>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerRoles>>,
          TError,
          Awaited<ReturnType<typeof getCustomerRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerRoles<
  TData = Awaited<ReturnType<typeof getCustomerRoles>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index roles
 */

export function useGetCustomerRoles<
  TData = Awaited<ReturnType<typeof getCustomerRoles>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerRolesQueryOptions(organisationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index users
 */
export const getCustomerUsers = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerUsers200>(
    { url: `/customer/organisations/${organisationId}/users`, method: 'GET' },
    options
  );
};

export const getGetCustomerUsersQueryKey = (organisationId?: number) => {
  return [`/customer/organisations/${organisationId}/users`] as const;
};

export const getGetCustomerUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerUsers>>,
  TError = GetCustomerUsers401
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerUsersQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerUsers>>
  > = () => getCustomerUsers(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerUsers>>
>;
export type GetCustomerUsersQueryError = GetCustomerUsers401;

export function useGetCustomerUsers<
  TData = Awaited<ReturnType<typeof getCustomerUsers>>,
  TError = GetCustomerUsers401
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerUsers>>,
          TError,
          Awaited<ReturnType<typeof getCustomerUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerUsers<
  TData = Awaited<ReturnType<typeof getCustomerUsers>>,
  TError = GetCustomerUsers401
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerUsers>>,
          TError,
          Awaited<ReturnType<typeof getCustomerUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerUsers<
  TData = Awaited<ReturnType<typeof getCustomerUsers>>,
  TError = GetCustomerUsers401
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index users
 */

export function useGetCustomerUsers<
  TData = Awaited<ReturnType<typeof getCustomerUsers>>,
  TError = GetCustomerUsers401
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerUsersQueryOptions(organisationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create user
 */
export const postCustomerUsers = (
  organisationId: number,
  postCustomerUsersBody: BodyType<PostCustomerUsersBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostCustomerUsers200>(
    {
      url: `/customer/organisations/${organisationId}/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postCustomerUsersBody
    },
    options
  );
};

export const getPostCustomerUsersMutationOptions = <
  TError = PostCustomerUsers401 | PostCustomerUsers422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerUsers>>,
    TError,
    { organisationId: number; data: BodyType<PostCustomerUsersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerUsers>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerUsersBody> },
  TContext
> => {
  const mutationKey = ['postCustomerUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerUsers>>,
    { organisationId: number; data: BodyType<PostCustomerUsersBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postCustomerUsers(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCustomerUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerUsers>>
>;
export type PostCustomerUsersMutationBody = BodyType<PostCustomerUsersBody>;
export type PostCustomerUsersMutationError =
  | PostCustomerUsers401
  | PostCustomerUsers422;

/**
 * @summary Create user
 */
export const usePostCustomerUsers = <
  TError = PostCustomerUsers401 | PostCustomerUsers422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerUsers>>,
      TError,
      { organisationId: number; data: BodyType<PostCustomerUsersBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerUsers>>,
  TError,
  { organisationId: number; data: BodyType<PostCustomerUsersBody> },
  TContext
> => {
  const mutationOptions = getPostCustomerUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get user
 */
export const getCustomerUsersUserId = (
  organisationId: number,
  userId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerUsersUserId200>(
    {
      url: `/customer/organisations/${organisationId}/users/${userId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetCustomerUsersUserIdQueryKey = (
  organisationId?: number,
  userId?: number
) => {
  return [`/customer/organisations/${organisationId}/users/${userId}`] as const;
};

export const getGetCustomerUsersUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerUsersUserId>>,
  TError = GetCustomerUsersUserId401
>(
  organisationId: number,
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsersUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerUsersUserIdQueryKey(organisationId, userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerUsersUserId>>
  > = () => getCustomerUsersUserId(organisationId, userId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && userId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerUsersUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerUsersUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerUsersUserId>>
>;
export type GetCustomerUsersUserIdQueryError = GetCustomerUsersUserId401;

export function useGetCustomerUsersUserId<
  TData = Awaited<ReturnType<typeof getCustomerUsersUserId>>,
  TError = GetCustomerUsersUserId401
>(
  organisationId: number,
  userId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsersUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerUsersUserId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerUsersUserId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerUsersUserId<
  TData = Awaited<ReturnType<typeof getCustomerUsersUserId>>,
  TError = GetCustomerUsersUserId401
>(
  organisationId: number,
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsersUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerUsersUserId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerUsersUserId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerUsersUserId<
  TData = Awaited<ReturnType<typeof getCustomerUsersUserId>>,
  TError = GetCustomerUsersUserId401
>(
  organisationId: number,
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsersUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user
 */

export function useGetCustomerUsersUserId<
  TData = Awaited<ReturnType<typeof getCustomerUsersUserId>>,
  TError = GetCustomerUsersUserId401
>(
  organisationId: number,
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerUsersUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerUsersUserIdQueryOptions(
    organisationId,
    userId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update user
 */
export const putCustomerUsersUserId = (
  organisationId: number,
  userId: number,
  putCustomerUsersUserIdBody: BodyType<PutCustomerUsersUserIdBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutCustomerUsersUserId200>(
    {
      url: `/customer/organisations/${organisationId}/users/${userId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putCustomerUsersUserIdBody
    },
    options
  );
};

export const getPutCustomerUsersUserIdMutationOptions = <
  TError = PutCustomerUsersUserId401 | PutCustomerUsersUserId422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCustomerUsersUserId>>,
    TError,
    {
      organisationId: number;
      userId: number;
      data: BodyType<PutCustomerUsersUserIdBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCustomerUsersUserId>>,
  TError,
  {
    organisationId: number;
    userId: number;
    data: BodyType<PutCustomerUsersUserIdBody>;
  },
  TContext
> => {
  const mutationKey = ['putCustomerUsersUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCustomerUsersUserId>>,
    {
      organisationId: number;
      userId: number;
      data: BodyType<PutCustomerUsersUserIdBody>;
    }
  > = (props) => {
    const { organisationId, userId, data } = props ?? {};

    return putCustomerUsersUserId(organisationId, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCustomerUsersUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCustomerUsersUserId>>
>;
export type PutCustomerUsersUserIdMutationBody =
  BodyType<PutCustomerUsersUserIdBody>;
export type PutCustomerUsersUserIdMutationError =
  | PutCustomerUsersUserId401
  | PutCustomerUsersUserId422;

/**
 * @summary Update user
 */
export const usePutCustomerUsersUserId = <
  TError = PutCustomerUsersUserId401 | PutCustomerUsersUserId422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCustomerUsersUserId>>,
      TError,
      {
        organisationId: number;
        userId: number;
        data: BodyType<PutCustomerUsersUserIdBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putCustomerUsersUserId>>,
  TError,
  {
    organisationId: number;
    userId: number;
    data: BodyType<PutCustomerUsersUserIdBody>;
  },
  TContext
> => {
  const mutationOptions = getPutCustomerUsersUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get current user
 */
export const getCustomerCurrentUser = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetCustomerCurrentUser200>(
    { url: `/customer/current_user`, method: 'GET' },
    options
  );
};

export const getGetCustomerCurrentUserQueryKey = () => {
  return [`/customer/current_user`] as const;
};

export const getGetCustomerCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerCurrentUser>>,
  TError = GetCustomerCurrentUser401
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerCurrentUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerCurrentUser>>
  > = () => getCustomerCurrentUser(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCustomerCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerCurrentUser>>
>;
export type GetCustomerCurrentUserQueryError = GetCustomerCurrentUser401;

export function useGetCustomerCurrentUser<
  TData = Awaited<ReturnType<typeof getCustomerCurrentUser>>,
  TError = GetCustomerCurrentUser401
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCustomerCurrentUser<
  TData = Awaited<ReturnType<typeof getCustomerCurrentUser>>,
  TError = GetCustomerCurrentUser401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCustomerCurrentUser<
  TData = Awaited<ReturnType<typeof getCustomerCurrentUser>>,
  TError = GetCustomerCurrentUser401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCurrentUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current user
 */

export function useGetCustomerCurrentUser<
  TData = Awaited<ReturnType<typeof getCustomerCurrentUser>>,
  TError = GetCustomerCurrentUser401
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCurrentUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCustomerCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get CSV template
 */
export const getDisbursementCapabilitySchemasSchemaIdCsvTemplate = (
  organisationId: number,
  schemaId: number,
  params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<string>(
    {
      url: `/disbursement/organisations/${organisationId}/capability_schemas/${schemaId}/csv_template`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryKey = (
  organisationId?: number,
  schemaId?: number,
  params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/capability_schemas/${schemaId}/csv_template`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
    >,
    TError = GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422
  >(
    organisationId: number,
    schemaId: number,
    params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryKey(
        organisationId,
        schemaId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
      >
    > = () =>
      getDisbursementCapabilitySchemasSchemaIdCsvTemplate(
        organisationId,
        schemaId,
        params,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && schemaId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
    >
  >;
export type GetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryError =
  GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422;

export function useGetDisbursementCapabilitySchemasSchemaIdCsvTemplate<
  TData = Awaited<
    ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
  >,
  TError = GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422
>(
  organisationId: number,
  schemaId: number,
  params: undefined | GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementCapabilitySchemasSchemaIdCsvTemplate<
  TData = Awaited<
    ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
  >,
  TError = GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422
>(
  organisationId: number,
  schemaId: number,
  params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementCapabilitySchemasSchemaIdCsvTemplate<
  TData = Awaited<
    ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
  >,
  TError = GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422
>(
  organisationId: number,
  schemaId: number,
  params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get CSV template
 */

export function useGetDisbursementCapabilitySchemasSchemaIdCsvTemplate<
  TData = Awaited<
    ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
  >,
  TError = GetDisbursementCapabilitySchemasSchemaIdCsvTemplate422
>(
  organisationId: number,
  schemaId: number,
  params?: GetDisbursementCapabilitySchemasSchemaIdCsvTemplateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementCapabilitySchemasSchemaIdCsvTemplate>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementCapabilitySchemasSchemaIdCsvTemplateQueryOptions(
      organisationId,
      schemaId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get external codes
 */
export const getDisbursementExternalCodes = (
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementExternalCodes200>(
    {
      url: `/disbursement/organisations/${organisationId}/external_codes`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementExternalCodesQueryKey = (
  organisationId?: number,
  params?: GetDisbursementExternalCodesParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/external_codes`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementExternalCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
  TError = GetDisbursementExternalCodes422
>(
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementExternalCodesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementExternalCodes>>
  > = () =>
    getDisbursementExternalCodes(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementExternalCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementExternalCodes>>
>;
export type GetDisbursementExternalCodesQueryError =
  GetDisbursementExternalCodes422;

export function useGetDisbursementExternalCodes<
  TData = Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
  TError = GetDisbursementExternalCodes422
>(
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementExternalCodes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementExternalCodes<
  TData = Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
  TError = GetDisbursementExternalCodes422
>(
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementExternalCodes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementExternalCodes<
  TData = Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
  TError = GetDisbursementExternalCodes422
>(
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get external codes
 */

export function useGetDisbursementExternalCodes<
  TData = Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
  TError = GetDisbursementExternalCodes422
>(
  organisationId: number,
  params: GetDisbursementExternalCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementExternalCodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementExternalCodesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get payment instruments
 */
export const getDisbursementPaymentInstruments = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPaymentInstruments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payment_instruments`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPaymentInstrumentsQueryKey = (
  organisationId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payment_instruments`
  ] as const;
};

export const getGetDisbursementPaymentInstrumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPaymentInstrumentsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>
  > = () => getDisbursementPaymentInstruments(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPaymentInstrumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>
>;
export type GetDisbursementPaymentInstrumentsQueryError = unknown;

export function useGetDisbursementPaymentInstruments<
  TData = Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPaymentInstruments<
  TData = Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPaymentInstruments<
  TData = Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get payment instruments
 */

export function useGetDisbursementPaymentInstruments<
  TData = Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPaymentInstruments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPaymentInstrumentsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Batch Attachment
 */
export const postDisbursementPayoutBatchesPayoutBatchIdAttachments = (
  organisationId: number,
  payoutBatchId: number,
  postDisbursementPayoutBatchesPayoutBatchIdAttachmentsBody: BodyType<Blob>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  const formData = new FormData();
  formData.append(
    'data',
    postDisbursementPayoutBatchesPayoutBatchIdAttachmentsBody
  );

  return customAxiosInstance<PostDisbursementPayoutBatchesPayoutBatchIdAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    },
    options
  );
};

export const getPostDisbursementPayoutBatchesPayoutBatchIdAttachmentsMutationOptions =
  <
    TError = null | PostDisbursementPayoutBatchesPayoutBatchIdAttachments422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
      >,
      TError,
      { organisationId: number; payoutBatchId: number; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
    >,
    TError,
    { organisationId: number; payoutBatchId: number; data: BodyType<Blob> },
    TContext
  > => {
    const mutationKey = [
      'postDisbursementPayoutBatchesPayoutBatchIdAttachments'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
      >,
      { organisationId: number; payoutBatchId: number; data: BodyType<Blob> }
    > = (props) => {
      const { organisationId, payoutBatchId, data } = props ?? {};

      return postDisbursementPayoutBatchesPayoutBatchIdAttachments(
        organisationId,
        payoutBatchId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostDisbursementPayoutBatchesPayoutBatchIdAttachmentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
    >
  >;
export type PostDisbursementPayoutBatchesPayoutBatchIdAttachmentsMutationBody =
  BodyType<Blob>;
export type PostDisbursementPayoutBatchesPayoutBatchIdAttachmentsMutationError =
  null | PostDisbursementPayoutBatchesPayoutBatchIdAttachments422;

/**
 * @summary Create Batch Attachment
 */
export const usePostDisbursementPayoutBatchesPayoutBatchIdAttachments = <
  TError = null | PostDisbursementPayoutBatchesPayoutBatchIdAttachments422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
      >,
      TError,
      { organisationId: number; payoutBatchId: number; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postDisbursementPayoutBatchesPayoutBatchIdAttachments>
  >,
  TError,
  { organisationId: number; payoutBatchId: number; data: BodyType<Blob> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutBatchesPayoutBatchIdAttachmentsMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Batch Attachments
 */
export const getDisbursementPayoutBatchesPayoutBatchIdAttachments = (
  organisationId: number,
  payoutBatchId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutBatchesPayoutBatchIdAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryKey = (
  organisationId?: number,
  payoutBatchId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments`
  ] as const;
};

export const getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
    >,
    TError = null
  >(
    organisationId: number,
    payoutBatchId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryKey(
        organisationId,
        payoutBatchId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
      >
    > = () =>
      getDisbursementPayoutBatchesPayoutBatchIdAttachments(
        organisationId,
        payoutBatchId,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && payoutBatchId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
    >
  >;
export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryError =
  null;

export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutBatchId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutBatchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutBatchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Batch Attachments
 */

export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutBatchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsQueryOptions(
      organisationId,
      payoutBatchId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Batch Attachment
 */
export const deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid = (
  organisationId: number,
  payoutBatchId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidMutationOptions =
  <
    TError = null | DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
        >
      >,
      TError,
      { organisationId: number; payoutBatchId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
      >
    >,
    TError,
    { organisationId: number; payoutBatchId: number; uuid: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
        >
      >,
      { organisationId: number; payoutBatchId: number; uuid: string }
    > = (props) => {
      const { organisationId, payoutBatchId, uuid } = props ?? {};

      return deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid(
        organisationId,
        payoutBatchId,
        uuid,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
      >
    >
  >;

export type DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidMutationError =
  null | DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid422;

/**
 * @summary Delete Batch Attachment
 */
export const useDeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid = <
  TError = null | DeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
        >
      >,
      TError,
      { organisationId: number; payoutBatchId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuid
    >
  >,
  TError,
  { organisationId: number; payoutBatchId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getDeleteDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Download Batch Attachment
 */
export const getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload =
  (
    organisationId: number,
    payoutBatchId: number,
    uuid: string,
    options?: SecondParameter<typeof customAxiosInstance>
  ) => {
    return customAxiosInstance<Blob>(
      {
        url: `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments/${uuid}/download`,
        method: 'GET',
        responseType: 'blob'
      },
      options
    );
  };

export const getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryKey =
  (organisationId?: number, payoutBatchId?: number, uuid?: string) => {
    return [
      `/disbursement/organisations/${organisationId}/payout_batches/${payoutBatchId}/attachments/${uuid}/download`
    ] as const;
  };

export const getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
      >
    >,
    TError =
      | null
      | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
      | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
      | null
  >(
    organisationId: number,
    payoutBatchId: number,
    uuid: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryKey(
        organisationId,
        payoutBatchId,
        uuid
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
        >
      >
    > = () =>
      getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload(
        organisationId,
        payoutBatchId,
        uuid,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && payoutBatchId && uuid),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
      >
    >
  >;
export type GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryError =

    | null
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
    | null;

export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutBatchId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutBatchId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutBatchId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Batch Attachment
 */

export function useGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutBatchId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutBatchesPayoutBatchIdAttachmentsUuidDownloadQueryOptions(
      organisationId,
      payoutBatchId,
      uuid,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Batch Drafts
 */
export const getDisbursementPayoutBatchesBatchIdPayoutDrafts = (
  organisationId: number,
  batchId: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutBatchesBatchIdPayoutDrafts200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/payout_drafts`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryKey = (
  organisationId?: number,
  batchId?: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/payout_drafts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryKey(
      organisationId,
      batchId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>>
  > = () =>
    getDisbursementPayoutBatchesBatchIdPayoutDrafts(
      organisationId,
      batchId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && batchId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>>
  >;
export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryError = unknown;

export function useGetDisbursementPayoutBatchesBatchIdPayoutDrafts<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  params: undefined | GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatchesBatchIdPayoutDrafts<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatchesBatchIdPayoutDrafts<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Batch Drafts
 */

export function useGetDisbursementPayoutBatchesBatchIdPayoutDrafts<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  params?: GetDisbursementPayoutBatchesBatchIdPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDrafts>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutBatchesBatchIdPayoutDraftsQueryOptions(
      organisationId,
      batchId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Batch Draft
 */
export const getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId = (
  organisationId: number,
  batchId: number,
  draftId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/payout_drafts/${draftId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryKey =
  (organisationId?: number, batchId?: number, draftId?: number) => {
    return [
      `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/payout_drafts/${draftId}`
    ] as const;
  };

export const getGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
    >,
    TError = unknown
  >(
    organisationId: number,
    batchId: number,
    draftId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryKey(
        organisationId,
        batchId,
        draftId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
        >
      >
    > = () =>
      getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId(
        organisationId,
        batchId,
        draftId,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && batchId && draftId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
    >
  >;
export type GetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryError =
  unknown;

export function useGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  draftId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Batch Draft
 */

export function useGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId>
  >,
  TError = unknown
>(
  organisationId: number,
  batchId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutBatchesBatchIdPayoutDraftsDraftId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutBatchesBatchIdPayoutDraftsDraftIdQueryOptions(
      organisationId,
      batchId,
      draftId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Payout Batch
 */
export const postDisbursementPayoutBatches = (
  organisationId: number,
  postDisbursementPayoutBatchesBody: BodyType<PostDisbursementPayoutBatchesBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  const formData = new FormData();
  formData.append(`file`, postDisbursementPayoutBatchesBody.file);
  if (postDisbursementPayoutBatchesBody.name !== undefined) {
    formData.append(`name`, postDisbursementPayoutBatchesBody.name);
  }

  return customAxiosInstance<PostDisbursementPayoutBatches202>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    },
    options
  );
};

export const getPostDisbursementPayoutBatchesMutationOptions = <
  TError = null | PostDisbursementPayoutBatches422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutBatches>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostDisbursementPayoutBatchesBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutBatches>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutBatchesBody> },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutBatches'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutBatches>>,
    {
      organisationId: number;
      data: BodyType<PostDisbursementPayoutBatchesBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postDisbursementPayoutBatches(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutBatchesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDisbursementPayoutBatches>>
>;
export type PostDisbursementPayoutBatchesMutationBody =
  BodyType<PostDisbursementPayoutBatchesBody>;
export type PostDisbursementPayoutBatchesMutationError =
  null | PostDisbursementPayoutBatches422;

/**
 * @summary Create Payout Batch
 */
export const usePostDisbursementPayoutBatches = <
  TError = null | PostDisbursementPayoutBatches422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutBatches>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostDisbursementPayoutBatchesBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutBatches>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutBatchesBody> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutBatchesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Payout Batches
 */
export const getDisbursementPayoutBatches = (
  organisationId: number,
  params?: GetDisbursementPayoutBatchesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutBatches200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementPayoutBatchesQueryKey = (
  organisationId?: number,
  params?: GetDisbursementPayoutBatchesParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_batches`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementPayoutBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
  TError = GetDisbursementPayoutBatches422
>(
  organisationId: number,
  params?: GetDisbursementPayoutBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutBatchesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutBatches>>
  > = () =>
    getDisbursementPayoutBatches(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutBatches>>
>;
export type GetDisbursementPayoutBatchesQueryError =
  GetDisbursementPayoutBatches422;

export function useGetDisbursementPayoutBatches<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
  TError = GetDisbursementPayoutBatches422
>(
  organisationId: number,
  params: undefined | GetDisbursementPayoutBatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutBatches>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatches<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
  TError = GetDisbursementPayoutBatches422
>(
  organisationId: number,
  params?: GetDisbursementPayoutBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutBatches>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatches<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
  TError = GetDisbursementPayoutBatches422
>(
  organisationId: number,
  params?: GetDisbursementPayoutBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Payout Batches
 */

export function useGetDisbursementPayoutBatches<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
  TError = GetDisbursementPayoutBatches422
>(
  organisationId: number,
  params?: GetDisbursementPayoutBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatches>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutBatchesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Payout Batch
 */
export const getDisbursementPayoutBatchesBatchId = (
  organisationId: number,
  batchId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutBatchesBatchId200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${batchId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutBatchesBatchIdQueryKey = (
  organisationId?: number,
  batchId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_batches/${batchId}`
  ] as const;
};

export const getGetDisbursementPayoutBatchesBatchIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
  TError = GetDisbursementPayoutBatchesBatchId422
>(
  organisationId: number,
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutBatchesBatchIdQueryKey(organisationId, batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>
  > = () =>
    getDisbursementPayoutBatchesBatchId(
      organisationId,
      batchId,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && batchId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutBatchesBatchIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>
>;
export type GetDisbursementPayoutBatchesBatchIdQueryError =
  GetDisbursementPayoutBatchesBatchId422;

export function useGetDisbursementPayoutBatchesBatchId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
  TError = GetDisbursementPayoutBatchesBatchId422
>(
  organisationId: number,
  batchId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutBatchesBatchId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
  TError = GetDisbursementPayoutBatchesBatchId422
>(
  organisationId: number,
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutBatchesBatchId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
  TError = GetDisbursementPayoutBatchesBatchId422
>(
  organisationId: number,
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Payout Batch
 */

export function useGetDisbursementPayoutBatchesBatchId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
  TError = GetDisbursementPayoutBatchesBatchId422
>(
  organisationId: number,
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutBatchesBatchId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutBatchesBatchIdQueryOptions(
    organisationId,
    batchId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Approve Payout Batch
 */
export const postDisbursementPayoutBatchesBatchIdApprove = (
  organisationId: number,
  batchId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutBatchesBatchIdApprove200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/approve`,
      method: 'POST'
    },
    options
  );
};

export const getPostDisbursementPayoutBatchesBatchIdApproveMutationOptions = <
  TError = PostDisbursementPayoutBatchesBatchIdApprove401,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>,
    TError,
    { organisationId: number; batchId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>,
  TError,
  { organisationId: number; batchId: number },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutBatchesBatchIdApprove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>,
    { organisationId: number; batchId: number }
  > = (props) => {
    const { organisationId, batchId } = props ?? {};

    return postDisbursementPayoutBatchesBatchIdApprove(
      organisationId,
      batchId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutBatchesBatchIdApproveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>
  >;

export type PostDisbursementPayoutBatchesBatchIdApproveMutationError =
  PostDisbursementPayoutBatchesBatchIdApprove401;

/**
 * @summary Approve Payout Batch
 */
export const usePostDisbursementPayoutBatchesBatchIdApprove = <
  TError = PostDisbursementPayoutBatchesBatchIdApprove401,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>,
      TError,
      { organisationId: number; batchId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdApprove>>,
  TError,
  { organisationId: number; batchId: number },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutBatchesBatchIdApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reject Payout Batch
 */
export const postDisbursementPayoutBatchesBatchIdReject = (
  organisationId: number,
  batchId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutBatchesBatchIdReject200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_batches/${batchId}/reject`,
      method: 'POST'
    },
    options
  );
};

export const getPostDisbursementPayoutBatchesBatchIdRejectMutationOptions = <
  TError = null | PostDisbursementPayoutBatchesBatchIdReject422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>,
    TError,
    { organisationId: number; batchId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>,
  TError,
  { organisationId: number; batchId: number },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutBatchesBatchIdReject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>,
    { organisationId: number; batchId: number }
  > = (props) => {
    const { organisationId, batchId } = props ?? {};

    return postDisbursementPayoutBatchesBatchIdReject(
      organisationId,
      batchId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutBatchesBatchIdRejectMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>
  >;

export type PostDisbursementPayoutBatchesBatchIdRejectMutationError =
  null | PostDisbursementPayoutBatchesBatchIdReject422;

/**
 * @summary Reject Payout Batch
 */
export const usePostDisbursementPayoutBatchesBatchIdReject = <
  TError = null | PostDisbursementPayoutBatchesBatchIdReject422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>,
      TError,
      { organisationId: number; batchId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutBatchesBatchIdReject>>,
  TError,
  { organisationId: number; batchId: number },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutBatchesBatchIdRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create Draft Attachment
 */
export const postDisbursementPayoutDraftsPayoutDraftIdAttachments = (
  organisationId: number,
  payoutDraftId: number,
  postDisbursementPayoutDraftsPayoutDraftIdAttachmentsBody: BodyType<Blob>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  const formData = new FormData();
  formData.append(
    'data',
    postDisbursementPayoutDraftsPayoutDraftIdAttachmentsBody
  );

  return customAxiosInstance<PostDisbursementPayoutDraftsPayoutDraftIdAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    },
    options
  );
};

export const getPostDisbursementPayoutDraftsPayoutDraftIdAttachmentsMutationOptions =
  <
    TError = null | PostDisbursementPayoutDraftsPayoutDraftIdAttachments422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
      >,
      TError,
      { organisationId: number; payoutDraftId: number; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
    >,
    TError,
    { organisationId: number; payoutDraftId: number; data: BodyType<Blob> },
    TContext
  > => {
    const mutationKey = [
      'postDisbursementPayoutDraftsPayoutDraftIdAttachments'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
      >,
      { organisationId: number; payoutDraftId: number; data: BodyType<Blob> }
    > = (props) => {
      const { organisationId, payoutDraftId, data } = props ?? {};

      return postDisbursementPayoutDraftsPayoutDraftIdAttachments(
        organisationId,
        payoutDraftId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostDisbursementPayoutDraftsPayoutDraftIdAttachmentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
    >
  >;
export type PostDisbursementPayoutDraftsPayoutDraftIdAttachmentsMutationBody =
  BodyType<Blob>;
export type PostDisbursementPayoutDraftsPayoutDraftIdAttachmentsMutationError =
  null | PostDisbursementPayoutDraftsPayoutDraftIdAttachments422;

/**
 * @summary Create Draft Attachment
 */
export const usePostDisbursementPayoutDraftsPayoutDraftIdAttachments = <
  TError = null | PostDisbursementPayoutDraftsPayoutDraftIdAttachments422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
      >,
      TError,
      { organisationId: number; payoutDraftId: number; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postDisbursementPayoutDraftsPayoutDraftIdAttachments>
  >,
  TError,
  { organisationId: number; payoutDraftId: number; data: BodyType<Blob> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutDraftsPayoutDraftIdAttachmentsMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Draft Attachments
 */
export const getDisbursementPayoutDraftsPayoutDraftIdAttachments = (
  organisationId: number,
  payoutDraftId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutDraftsPayoutDraftIdAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryKey = (
  organisationId?: number,
  payoutDraftId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments`
  ] as const;
};

export const getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
    >,
    TError = null
  >(
    organisationId: number,
    payoutDraftId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryKey(
        organisationId,
        payoutDraftId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
      >
    > = () =>
      getDisbursementPayoutDraftsPayoutDraftIdAttachments(
        organisationId,
        payoutDraftId,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && payoutDraftId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
    >
  >;
export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryError =
  null;

export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutDraftId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutDraftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutDraftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Draft Attachments
 */

export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
  >,
  TError = null
>(
  organisationId: number,
  payoutDraftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutDraftsPayoutDraftIdAttachments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsQueryOptions(
      organisationId,
      payoutDraftId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Draft Attachment
 */
export const deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid = (
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidMutationOptions =
  <
    TError = null | DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
        >
      >,
      TError,
      { organisationId: number; payoutDraftId: string; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
      >
    >,
    TError,
    { organisationId: number; payoutDraftId: string; uuid: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
        >
      >,
      { organisationId: number; payoutDraftId: string; uuid: string }
    > = (props) => {
      const { organisationId, payoutDraftId, uuid } = props ?? {};

      return deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid(
        organisationId,
        payoutDraftId,
        uuid,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
      >
    >
  >;

export type DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidMutationError =
  null | DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid422;

/**
 * @summary Delete Draft Attachment
 */
export const useDeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid = <
  TError = null | DeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
        >
      >,
      TError,
      { organisationId: number; payoutDraftId: string; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuid
    >
  >,
  TError,
  { organisationId: number; payoutDraftId: string; uuid: string },
  TContext
> => {
  const mutationOptions =
    getDeleteDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Download Draft Attachment
 */
export const getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload = (
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<Blob>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments/${uuid}/download`,
      method: 'GET',
      responseType: 'blob'
    },
    options
  );
};

export const getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryKey =
  (organisationId?: number, payoutDraftId?: string, uuid?: string) => {
    return [
      `/disbursement/organisations/${organisationId}/payout_drafts/${payoutDraftId}/attachments/${uuid}/download`
    ] as const;
  };

export const getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
      >
    >,
    TError =
      | null
      | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
      | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
      | null
  >(
    organisationId: number,
    payoutDraftId: string,
    uuid: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryKey(
        organisationId,
        payoutDraftId,
        uuid
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
        >
      >
    > = () =>
      getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload(
        organisationId,
        payoutDraftId,
        uuid,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && payoutDraftId && uuid),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
      >
    >
  >;
export type GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryError =

    | null
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
    | null;

export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Draft Attachment
 */

export function useGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404One
    | GetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  payoutDraftId: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutDraftsPayoutDraftIdAttachmentsUuidDownloadQueryOptions(
      organisationId,
      payoutDraftId,
      uuid,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Payout Drafts
 */
export const getDisbursementPayoutDrafts = (
  organisationId: number,
  params?: GetDisbursementPayoutDraftsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutDrafts200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementPayoutDraftsQueryKey = (
  organisationId?: number,
  params?: GetDisbursementPayoutDraftsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_drafts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementPayoutDraftsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutDraftsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>
  > = () => getDisbursementPayoutDrafts(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutDraftsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>
>;
export type GetDisbursementPayoutDraftsQueryError = unknown;

export function useGetDisbursementPayoutDrafts<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetDisbursementPayoutDraftsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutDrafts<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutDrafts<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Payout Drafts
 */

export function useGetDisbursementPayoutDrafts<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutDraftsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDrafts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutDraftsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Payout Draft
 */
export const postDisbursementPayoutDrafts = (
  organisationId: number,
  postDisbursementPayoutDraftsBody: BodyType<PostDisbursementPayoutDraftsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<CreatedPayoutDraft>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postDisbursementPayoutDraftsBody
    },
    options
  );
};

export const getPostDisbursementPayoutDraftsMutationOptions = <
  TError = null | PayoutDraftValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostDisbursementPayoutDraftsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutDraftsBody> },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutDrafts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>,
    { organisationId: number; data: BodyType<PostDisbursementPayoutDraftsBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postDisbursementPayoutDrafts(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutDraftsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>
>;
export type PostDisbursementPayoutDraftsMutationBody =
  BodyType<PostDisbursementPayoutDraftsBody>;
export type PostDisbursementPayoutDraftsMutationError =
  null | PayoutDraftValidationError;

/**
 * @summary Create Payout Draft
 */
export const usePostDisbursementPayoutDrafts = <
  TError = null | PayoutDraftValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostDisbursementPayoutDraftsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutDrafts>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutDraftsBody> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutDraftsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get Payout Draft
 */
export const getDisbursementPayoutDraftsDraftId = (
  organisationId: number,
  draftId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutDraftsDraftId200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${draftId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutDraftsDraftIdQueryKey = (
  organisationId?: number,
  draftId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_drafts/${draftId}`
  ] as const;
};

export const getGetDisbursementPayoutDraftsDraftIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
  TError = unknown
>(
  organisationId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutDraftsDraftIdQueryKey(organisationId, draftId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>
  > = () =>
    getDisbursementPayoutDraftsDraftId(organisationId, draftId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && draftId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutDraftsDraftIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>
>;
export type GetDisbursementPayoutDraftsDraftIdQueryError = unknown;

export function useGetDisbursementPayoutDraftsDraftId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
  TError = unknown
>(
  organisationId: number,
  draftId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutDraftsDraftId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
  TError = unknown
>(
  organisationId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutDraftsDraftId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
  TError = unknown
>(
  organisationId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Payout Draft
 */

export function useGetDisbursementPayoutDraftsDraftId<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
  TError = unknown
>(
  organisationId: number,
  draftId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsDraftId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutDraftsDraftIdQueryOptions(
    organisationId,
    draftId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates a payout draft
 */
export const putDisbursementPayoutDraftsDraftId = (
  organisationId: number,
  draftId: number,
  putDisbursementPayoutDraftsDraftIdBody: BodyType<PutDisbursementPayoutDraftsDraftIdBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutDisbursementPayoutDraftsDraftId200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${draftId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putDisbursementPayoutDraftsDraftIdBody
    },
    options
  );
};

export const getPutDisbursementPayoutDraftsDraftIdMutationOptions = <
  TError = PutDisbursementPayoutDraftsDraftId401 | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>,
    TError,
    {
      organisationId: number;
      draftId: number;
      data: BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>,
  TError,
  {
    organisationId: number;
    draftId: number;
    data: BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
  },
  TContext
> => {
  const mutationKey = ['putDisbursementPayoutDraftsDraftId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>,
    {
      organisationId: number;
      draftId: number;
      data: BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
    }
  > = (props) => {
    const { organisationId, draftId, data } = props ?? {};

    return putDisbursementPayoutDraftsDraftId(
      organisationId,
      draftId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDisbursementPayoutDraftsDraftIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>
>;
export type PutDisbursementPayoutDraftsDraftIdMutationBody =
  BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
export type PutDisbursementPayoutDraftsDraftIdMutationError =
  PutDisbursementPayoutDraftsDraftId401 | null;

/**
 * @summary Updates a payout draft
 */
export const usePutDisbursementPayoutDraftsDraftId = <
  TError = PutDisbursementPayoutDraftsDraftId401 | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>,
      TError,
      {
        organisationId: number;
        draftId: number;
        data: BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putDisbursementPayoutDraftsDraftId>>,
  TError,
  {
    organisationId: number;
    draftId: number;
    data: BodyType<PutDisbursementPayoutDraftsDraftIdBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPutDisbursementPayoutDraftsDraftIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Approve Payout Draft
 */
export const postDisbursementPayoutDraftsDraftIdApprove = (
  organisationId: number,
  draftId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutDraftsDraftIdApprove200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${draftId}/approve`,
      method: 'POST'
    },
    options
  );
};

export const getPostDisbursementPayoutDraftsDraftIdApproveMutationOptions = <
  TError =
    | PostDisbursementPayoutDraftsDraftIdApprove401
    | PostDisbursementPayoutDraftsDraftIdApprove422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>,
    TError,
    { organisationId: number; draftId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>,
  TError,
  { organisationId: number; draftId: number },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutDraftsDraftIdApprove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>,
    { organisationId: number; draftId: number }
  > = (props) => {
    const { organisationId, draftId } = props ?? {};

    return postDisbursementPayoutDraftsDraftIdApprove(
      organisationId,
      draftId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutDraftsDraftIdApproveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>
  >;

export type PostDisbursementPayoutDraftsDraftIdApproveMutationError =
  | PostDisbursementPayoutDraftsDraftIdApprove401
  | PostDisbursementPayoutDraftsDraftIdApprove422;

/**
 * @summary Approve Payout Draft
 */
export const usePostDisbursementPayoutDraftsDraftIdApprove = <
  TError =
    | PostDisbursementPayoutDraftsDraftIdApprove401
    | PostDisbursementPayoutDraftsDraftIdApprove422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>,
      TError,
      { organisationId: number; draftId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdApprove>>,
  TError,
  { organisationId: number; draftId: number },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutDraftsDraftIdApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reject Payout Draft
 */
export const postDisbursementPayoutDraftsDraftIdReject = (
  organisationId: number,
  draftId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutDraftsDraftIdReject200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${draftId}/reject`,
      method: 'POST'
    },
    options
  );
};

export const getPostDisbursementPayoutDraftsDraftIdRejectMutationOptions = <
  TError =
    | PostDisbursementPayoutDraftsDraftIdReject401
    | PostDisbursementPayoutDraftsDraftIdReject422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>,
    TError,
    { organisationId: number; draftId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>,
  TError,
  { organisationId: number; draftId: number },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutDraftsDraftIdReject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>,
    { organisationId: number; draftId: number }
  > = (props) => {
    const { organisationId, draftId } = props ?? {};

    return postDisbursementPayoutDraftsDraftIdReject(
      organisationId,
      draftId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutDraftsDraftIdRejectMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>
  >;

export type PostDisbursementPayoutDraftsDraftIdRejectMutationError =
  | PostDisbursementPayoutDraftsDraftIdReject401
  | PostDisbursementPayoutDraftsDraftIdReject422;

/**
 * @summary Reject Payout Draft
 */
export const usePostDisbursementPayoutDraftsDraftIdReject = <
  TError =
    | PostDisbursementPayoutDraftsDraftIdReject401
    | PostDisbursementPayoutDraftsDraftIdReject422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>,
      TError,
      { organisationId: number; draftId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsDraftIdReject>>,
  TError,
  { organisationId: number; draftId: number },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutDraftsDraftIdRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Destroy Payout Draft
 */
export const deleteDisbursementPayoutDraftsId = (
  organisationId: number,
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<null>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${id}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteDisbursementPayoutDraftsIdMutationOptions = <
  TError = null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>,
    TError,
    { organisationId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteDisbursementPayoutDraftsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>,
    { organisationId: number; id: number }
  > = (props) => {
    const { organisationId, id } = props ?? {};

    return deleteDisbursementPayoutDraftsId(organisationId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDisbursementPayoutDraftsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>
>;

export type DeleteDisbursementPayoutDraftsIdMutationError = null | null;

/**
 * @summary Destroy Payout Draft
 */
export const useDeleteDisbursementPayoutDraftsId = <
  TError = null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>,
      TError,
      { organisationId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDisbursementPayoutDraftsId>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteDisbursementPayoutDraftsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Payout Draft Summary
 */
export const getDisbursementPayoutDraftsIdSummary = (
  organisationId: number,
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<CreatedPayoutDraft>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${id}/summary`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutDraftsIdSummaryQueryKey = (
  organisationId?: number,
  id?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_drafts/${id}/summary`
  ] as const;
};

export const getGetDisbursementPayoutDraftsIdSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutDraftsIdSummaryQueryKey(organisationId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>
  > = () =>
    getDisbursementPayoutDraftsIdSummary(organisationId, id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && id),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutDraftsIdSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>
>;
export type GetDisbursementPayoutDraftsIdSummaryQueryError = unknown;

export function useGetDisbursementPayoutDraftsIdSummary<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutDraftsIdSummary<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutDraftsIdSummary<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Payout Draft Summary
 */

export function useGetDisbursementPayoutDraftsIdSummary<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
  TError = unknown
>(
  organisationId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutDraftsIdSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutDraftsIdSummaryQueryOptions(
    organisationId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Publish Payout Draft
 */
export const postDisbursementPayoutDraftsIdPublish = (
  organisationId: number,
  id: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutDraftsIdPublish200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_drafts/${id}/publish`,
      method: 'POST'
    },
    options
  );
};

export const getPostDisbursementPayoutDraftsIdPublishMutationOptions = <
  TError = null | PayoutDraftValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>,
    TError,
    { organisationId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutDraftsIdPublish'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>,
    { organisationId: number; id: number }
  > = (props) => {
    const { organisationId, id } = props ?? {};

    return postDisbursementPayoutDraftsIdPublish(
      organisationId,
      id,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutDraftsIdPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>
>;

export type PostDisbursementPayoutDraftsIdPublishMutationError =
  null | PayoutDraftValidationError;

/**
 * @summary Publish Payout Draft
 */
export const usePostDisbursementPayoutDraftsIdPublish = <
  TError = null | PayoutDraftValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>,
      TError,
      { organisationId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutDraftsIdPublish>>,
  TError,
  { organisationId: number; id: number },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutDraftsIdPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create Payout Report
 */
export const postDisbursementPayoutReports = (
  organisationId: number,
  postDisbursementPayoutReportsBody: BodyType<PostDisbursementPayoutReportsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementPayoutReports200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postDisbursementPayoutReportsBody
    },
    options
  );
};

export const getPostDisbursementPayoutReportsMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementPayoutReports>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostDisbursementPayoutReportsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementPayoutReports>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutReportsBody> },
  TContext
> => {
  const mutationKey = ['postDisbursementPayoutReports'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementPayoutReports>>,
    {
      organisationId: number;
      data: BodyType<PostDisbursementPayoutReportsBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postDisbursementPayoutReports(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementPayoutReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDisbursementPayoutReports>>
>;
export type PostDisbursementPayoutReportsMutationBody =
  BodyType<PostDisbursementPayoutReportsBody>;
export type PostDisbursementPayoutReportsMutationError = null;

/**
 * @summary Create Payout Report
 */
export const usePostDisbursementPayoutReports = <
  TError = null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementPayoutReports>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostDisbursementPayoutReportsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementPayoutReports>>,
  TError,
  { organisationId: number; data: BodyType<PostDisbursementPayoutReportsBody> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Payout Reports
 */
export const getDisbursementPayoutReports = (
  organisationId: number,
  params?: GetDisbursementPayoutReportsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutReports200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_reports`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementPayoutReportsQueryKey = (
  organisationId?: number,
  params?: GetDisbursementPayoutReportsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_reports`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementPayoutReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutReportsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutReports>>
  > = () =>
    getDisbursementPayoutReports(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutReports>>
>;
export type GetDisbursementPayoutReportsQueryError = unknown;

export function useGetDisbursementPayoutReports<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetDisbursementPayoutReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutReports<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutReports<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Payout Reports
 */

export function useGetDisbursementPayoutReports<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementPayoutReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutReportsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Payout Report
 */
export const getDisbursementPayoutReportsUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutReportsUuid200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_reports/${uuid}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutReportsUuidQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_reports/${uuid}`
  ] as const;
};

export const getGetDisbursementPayoutReportsUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutReportsUuidQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>
  > = () =>
    getDisbursementPayoutReportsUuid(organisationId, uuid, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutReportsUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>
>;
export type GetDisbursementPayoutReportsUuidQueryError = unknown;

export function useGetDisbursementPayoutReportsUuid<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutReportsUuid<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutReportsUuid<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Payout Report
 */

export function useGetDisbursementPayoutReportsUuid<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
  TError = unknown
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutReportsUuidQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download Payout Report
 */
export const getDisbursementPayoutReportsUuidDownload = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<string>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_reports/${uuid}/download`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutReportsUuidDownloadQueryKey = (
  organisationId?: number,
  uuid?: string
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_reports/${uuid}/download`
  ] as const;
};

export const getGetDisbursementPayoutReportsUuidDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutReportsUuidDownloadQueryKey(organisationId, uuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>
  > = () =>
    getDisbursementPayoutReportsUuidDownload(
      organisationId,
      uuid,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uuid),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutReportsUuidDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>
>;
export type GetDisbursementPayoutReportsUuidDownloadQueryError = null;

export function useGetDisbursementPayoutReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Payout Report
 */

export function useGetDisbursementPayoutReportsUuidDownload<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
  TError = null
>(
  organisationId: number,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutReportsUuidDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutReportsUuidDownloadQueryOptions(
    organisationId,
    uuid,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Payout Request Attachment
 */
export const postDisbursementPayoutRequestsUniqueReferenceAttachments = (
  organisationId: number,
  uniqueReference: string,
  postDisbursementPayoutRequestsUniqueReferenceAttachmentsBody: BodyType<Blob>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  const formData = new FormData();
  formData.append(
    'data',
    postDisbursementPayoutRequestsUniqueReferenceAttachmentsBody
  );

  return customAxiosInstance<PostDisbursementPayoutRequestsUniqueReferenceAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    },
    options
  );
};

export const getPostDisbursementPayoutRequestsUniqueReferenceAttachmentsMutationOptions =
  <
    TError = null | PostDisbursementPayoutRequestsUniqueReferenceAttachments422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postDisbursementPayoutRequestsUniqueReferenceAttachments
        >
      >,
      TError,
      { organisationId: number; uniqueReference: string; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postDisbursementPayoutRequestsUniqueReferenceAttachments
      >
    >,
    TError,
    { organisationId: number; uniqueReference: string; data: BodyType<Blob> },
    TContext
  > => {
    const mutationKey = [
      'postDisbursementPayoutRequestsUniqueReferenceAttachments'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postDisbursementPayoutRequestsUniqueReferenceAttachments
        >
      >,
      { organisationId: number; uniqueReference: string; data: BodyType<Blob> }
    > = (props) => {
      const { organisationId, uniqueReference, data } = props ?? {};

      return postDisbursementPayoutRequestsUniqueReferenceAttachments(
        organisationId,
        uniqueReference,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostDisbursementPayoutRequestsUniqueReferenceAttachmentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postDisbursementPayoutRequestsUniqueReferenceAttachments
      >
    >
  >;
export type PostDisbursementPayoutRequestsUniqueReferenceAttachmentsMutationBody =
  BodyType<Blob>;
export type PostDisbursementPayoutRequestsUniqueReferenceAttachmentsMutationError =
  null | PostDisbursementPayoutRequestsUniqueReferenceAttachments422;

/**
 * @summary Create Payout Request Attachment
 */
export const usePostDisbursementPayoutRequestsUniqueReferenceAttachments = <
  TError = null | PostDisbursementPayoutRequestsUniqueReferenceAttachments422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postDisbursementPayoutRequestsUniqueReferenceAttachments
        >
      >,
      TError,
      { organisationId: number; uniqueReference: string; data: BodyType<Blob> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postDisbursementPayoutRequestsUniqueReferenceAttachments>
  >,
  TError,
  { organisationId: number; uniqueReference: string; data: BodyType<Blob> },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementPayoutRequestsUniqueReferenceAttachmentsMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Payout Request Attachments
 */
export const getDisbursementPayoutRequestsUniqueReferenceAttachments = (
  organisationId: number,
  uniqueReference: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutRequestsUniqueReferenceAttachments200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryKey =
  (organisationId?: number, uniqueReference?: string) => {
    return [
      `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments`
    ] as const;
  };

export const getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
    >,
    TError = null
  >(
    organisationId: number,
    uniqueReference: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryKey(
        organisationId,
        uniqueReference
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
        >
      >
    > = () =>
      getDisbursementPayoutRequestsUniqueReferenceAttachments(
        organisationId,
        uniqueReference,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && uniqueReference),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
    >
  >;
export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryError =
  null;

export function useGetDisbursementPayoutRequestsUniqueReferenceAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
  >,
  TError = null
>(
  organisationId: number,
  uniqueReference: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutRequestsUniqueReferenceAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
  >,
  TError = null
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutRequestsUniqueReferenceAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
  >,
  TError = null
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Payout Request Attachments
 */

export function useGetDisbursementPayoutRequestsUniqueReferenceAttachments<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReferenceAttachments>
  >,
  TError = null
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsQueryOptions(
      organisationId,
      uniqueReference,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Payout Request Attachment
 */
export const deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid = (
  organisationId: number,
  uniqueReference: string,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidMutationOptions =
  <
    TError = null | DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
        >
      >,
      TError,
      { organisationId: number; uniqueReference: string; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
      >
    >,
    TError,
    { organisationId: number; uniqueReference: string; uuid: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
        >
      >,
      { organisationId: number; uniqueReference: string; uuid: string }
    > = (props) => {
      const { organisationId, uniqueReference, uuid } = props ?? {};

      return deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid(
        organisationId,
        uniqueReference,
        uuid,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
      >
    >
  >;

export type DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidMutationError =
  null | DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid422;

/**
 * @summary Delete Payout Request Attachment
 */
export const useDeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid =
  <
    TError = null | DeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid422,
    TContext = unknown
  >(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
          >
        >,
        TError,
        { organisationId: number; uniqueReference: string; uuid: string },
        TContext
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuid
      >
    >,
    TError,
    { organisationId: number; uniqueReference: string; uuid: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * @summary Download Payout Request Attachment
 */
export const getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload =
  (
    organisationId: number,
    uniqueReference: string,
    uuid: string,
    options?: SecondParameter<typeof customAxiosInstance>
  ) => {
    return customAxiosInstance<Blob>(
      {
        url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments/${uuid}/download`,
        method: 'GET',
        responseType: 'blob'
      },
      options
    );
  };

export const getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryKey =
  (organisationId?: number, uniqueReference?: string, uuid?: string) => {
    return [
      `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}/attachments/${uuid}/download`
    ] as const;
  };

export const getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
      >
    >,
    TError =
      | null
      | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
      | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
      | null
  >(
    organisationId: number,
    uniqueReference: string,
    uuid: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryKey(
        organisationId,
        uniqueReference,
        uuid
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
        >
      >
    > = () =>
      getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload(
        organisationId,
        uniqueReference,
        uuid,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && uniqueReference && uuid),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
      >
    >
  >;
export type GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryError =

    | null
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
    | null;

export function useGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  uniqueReference: string,
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  uniqueReference: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  uniqueReference: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Payout Request Attachment
 */

export function useGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload<
  TData = Awaited<
    ReturnType<
      typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
    >
  >,
  TError =
    | null
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404One
    | GetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload404Two
    | null
>(
  organisationId: number,
  uniqueReference: string,
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownload
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutRequestsUniqueReferenceAttachmentsUuidDownloadQueryOptions(
      organisationId,
      uniqueReference,
      uuid,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Payout Requests
 */
export const getDisbursementPayoutRequests = (
  organisationId: number,
  params?: GetDisbursementPayoutRequestsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutRequests200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementPayoutRequestsQueryKey = (
  organisationId?: number,
  params?: GetDisbursementPayoutRequestsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_requests`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementPayoutRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
  TError = GetDisbursementPayoutRequests422
>(
  organisationId: number,
  params?: GetDisbursementPayoutRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutRequestsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutRequests>>
  > = () =>
    getDisbursementPayoutRequests(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementPayoutRequests>>
>;
export type GetDisbursementPayoutRequestsQueryError =
  GetDisbursementPayoutRequests422;

export function useGetDisbursementPayoutRequests<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
  TError = GetDisbursementPayoutRequests422
>(
  organisationId: number,
  params: undefined | GetDisbursementPayoutRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutRequests<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
  TError = GetDisbursementPayoutRequests422
>(
  organisationId: number,
  params?: GetDisbursementPayoutRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementPayoutRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutRequests<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
  TError = GetDisbursementPayoutRequests422
>(
  organisationId: number,
  params?: GetDisbursementPayoutRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Payout Requests
 */

export function useGetDisbursementPayoutRequests<
  TData = Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
  TError = GetDisbursementPayoutRequests422
>(
  organisationId: number,
  params?: GetDisbursementPayoutRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementPayoutRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementPayoutRequestsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Payout Request
 */
export const getDisbursementPayoutRequestsUniqueReference = (
  organisationId: number,
  uniqueReference: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementPayoutRequestsUniqueReference200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementPayoutRequestsUniqueReferenceQueryKey = (
  organisationId?: number,
  uniqueReference?: string
) => {
  return [
    `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}`
  ] as const;
};

export const getGetDisbursementPayoutRequestsUniqueReferenceQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
  >,
  TError = GetDisbursementPayoutRequestsUniqueReference422
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementPayoutRequestsUniqueReferenceQueryKey(
      organisationId,
      uniqueReference
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>>
  > = () =>
    getDisbursementPayoutRequestsUniqueReference(
      organisationId,
      uniqueReference,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && uniqueReference),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementPayoutRequestsUniqueReferenceQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>>
  >;
export type GetDisbursementPayoutRequestsUniqueReferenceQueryError =
  GetDisbursementPayoutRequestsUniqueReference422;

export function useGetDisbursementPayoutRequestsUniqueReference<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
  >,
  TError = GetDisbursementPayoutRequestsUniqueReference422
>(
  organisationId: number,
  uniqueReference: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementPayoutRequestsUniqueReference<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
  >,
  TError = GetDisbursementPayoutRequestsUniqueReference422
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementPayoutRequestsUniqueReference<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
  >,
  TError = GetDisbursementPayoutRequestsUniqueReference422
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Payout Request
 */

export function useGetDisbursementPayoutRequestsUniqueReference<
  TData = Awaited<
    ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
  >,
  TError = GetDisbursementPayoutRequestsUniqueReference422
>(
  organisationId: number,
  uniqueReference: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementPayoutRequestsUniqueReference>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementPayoutRequestsUniqueReferenceQueryOptions(
      organisationId,
      uniqueReference,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancel Payout Requests
 */
export const deleteDisbursementPayoutRequestsUniqueReference = (
  organisationId: number,
  uniqueReference: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteDisbursementPayoutRequestsUniqueReference200>(
    {
      url: `/disbursement/organisations/${organisationId}/payout_requests/${uniqueReference}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteDisbursementPayoutRequestsUniqueReferenceMutationOptions =
  <
    TError = null | DeleteDisbursementPayoutRequestsUniqueReference422,
    TContext = unknown
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>
      >,
      TError,
      { organisationId: number; uniqueReference: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>>,
    TError,
    { organisationId: number; uniqueReference: string },
    TContext
  > => {
    const mutationKey = ['deleteDisbursementPayoutRequestsUniqueReference'];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>
      >,
      { organisationId: number; uniqueReference: string }
    > = (props) => {
      const { organisationId, uniqueReference } = props ?? {};

      return deleteDisbursementPayoutRequestsUniqueReference(
        organisationId,
        uniqueReference,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDisbursementPayoutRequestsUniqueReferenceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>>
  >;

export type DeleteDisbursementPayoutRequestsUniqueReferenceMutationError =
  null | DeleteDisbursementPayoutRequestsUniqueReference422;

/**
 * @summary Cancel Payout Requests
 */
export const useDeleteDisbursementPayoutRequestsUniqueReference = <
  TError = null | DeleteDisbursementPayoutRequestsUniqueReference422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>
      >,
      TError,
      { organisationId: number; uniqueReference: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDisbursementPayoutRequestsUniqueReference>>,
  TError,
  { organisationId: number; uniqueReference: string },
  TContext
> => {
  const mutationOptions =
    getDeleteDisbursementPayoutRequestsUniqueReferenceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get product schemas
 */
export const getDisbursementProductSchemas = (
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementProductSchemas200>(
    {
      url: `/disbursement/organisations/${organisationId}/product_schemas`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementProductSchemasQueryKey = (
  organisationId?: number,
  params?: GetDisbursementProductSchemasParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/product_schemas`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementProductSchemasQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
  TError = GetDisbursementProductSchemas422
>(
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementProductSchemasQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementProductSchemas>>
  > = () =>
    getDisbursementProductSchemas(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementProductSchemasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementProductSchemas>>
>;
export type GetDisbursementProductSchemasQueryError =
  GetDisbursementProductSchemas422;

export function useGetDisbursementProductSchemas<
  TData = Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
  TError = GetDisbursementProductSchemas422
>(
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementProductSchemas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementProductSchemas<
  TData = Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
  TError = GetDisbursementProductSchemas422
>(
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementProductSchemas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementProductSchemas<
  TData = Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
  TError = GetDisbursementProductSchemas422
>(
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get product schemas
 */

export function useGetDisbursementProductSchemas<
  TData = Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
  TError = GetDisbursementProductSchemas422
>(
  organisationId: number,
  params: GetDisbursementProductSchemasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementProductSchemas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementProductSchemasQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Schema Fields Definition
 */
export const getDisbursementSchemaFieldsDefinitionSchemaId = (
  organisationId: number,
  schemaId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<SchemaFieldsDefinition>(
    {
      url: `/disbursement/organisations/${organisationId}/schema_fields_definition/${schemaId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementSchemaFieldsDefinitionSchemaIdQueryKey = (
  organisationId?: number,
  schemaId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/schema_fields_definition/${schemaId}`
  ] as const;
};

export const getGetDisbursementSchemaFieldsDefinitionSchemaIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
  >,
  TError = GetDisbursementSchemaFieldsDefinitionSchemaId422
>(
  organisationId: number,
  schemaId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementSchemaFieldsDefinitionSchemaIdQueryKey(
      organisationId,
      schemaId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>>
  > = () =>
    getDisbursementSchemaFieldsDefinitionSchemaId(
      organisationId,
      schemaId,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && schemaId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementSchemaFieldsDefinitionSchemaIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>>
  >;
export type GetDisbursementSchemaFieldsDefinitionSchemaIdQueryError =
  GetDisbursementSchemaFieldsDefinitionSchemaId422;

export function useGetDisbursementSchemaFieldsDefinitionSchemaId<
  TData = Awaited<
    ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
  >,
  TError = GetDisbursementSchemaFieldsDefinitionSchemaId422
>(
  organisationId: number,
  schemaId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementSchemaFieldsDefinitionSchemaId<
  TData = Awaited<
    ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
  >,
  TError = GetDisbursementSchemaFieldsDefinitionSchemaId422
>(
  organisationId: number,
  schemaId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementSchemaFieldsDefinitionSchemaId<
  TData = Awaited<
    ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
  >,
  TError = GetDisbursementSchemaFieldsDefinitionSchemaId422
>(
  organisationId: number,
  schemaId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Schema Fields Definition
 */

export function useGetDisbursementSchemaFieldsDefinitionSchemaId<
  TData = Awaited<
    ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
  >,
  TError = GetDisbursementSchemaFieldsDefinitionSchemaId422
>(
  organisationId: number,
  schemaId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementSchemaFieldsDefinitionSchemaId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementSchemaFieldsDefinitionSchemaIdQueryOptions(
      organisationId,
      schemaId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get payout reason code stats
 */
export const getDisbursementStatsPayoutRequestsReasonCodes = (
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementStatsPayoutRequestsReasonCodes200>(
    {
      url: `/disbursement/organisations/${organisationId}/stats/payout_requests/reason_codes`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementStatsPayoutRequestsReasonCodesQueryKey = (
  organisationId?: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/stats/payout_requests/reason_codes`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementStatsPayoutRequestsReasonCodesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
  >,
  TError = GetDisbursementStatsPayoutRequestsReasonCodes422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementStatsPayoutRequestsReasonCodesQueryKey(
      organisationId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>>
  > = () =>
    getDisbursementStatsPayoutRequestsReasonCodes(
      organisationId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementStatsPayoutRequestsReasonCodesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>>
  >;
export type GetDisbursementStatsPayoutRequestsReasonCodesQueryError =
  GetDisbursementStatsPayoutRequestsReasonCodes422;

export function useGetDisbursementStatsPayoutRequestsReasonCodes<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
  >,
  TError = GetDisbursementStatsPayoutRequestsReasonCodes422
>(
  organisationId: number,
  params: undefined | GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementStatsPayoutRequestsReasonCodes<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
  >,
  TError = GetDisbursementStatsPayoutRequestsReasonCodes422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementStatsPayoutRequestsReasonCodes<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
  >,
  TError = GetDisbursementStatsPayoutRequestsReasonCodes422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get payout reason code stats
 */

export function useGetDisbursementStatsPayoutRequestsReasonCodes<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
  >,
  TError = GetDisbursementStatsPayoutRequestsReasonCodes422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsReasonCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsReasonCodes>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementStatsPayoutRequestsReasonCodesQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get payout state category stats
 */
export const getDisbursementStatsPayoutRequestsStateCategories = (
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementStatsPayoutRequestsStateCategories200>(
    {
      url: `/disbursement/organisations/${organisationId}/stats/payout_requests/state_categories`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementStatsPayoutRequestsStateCategoriesQueryKey = (
  organisationId?: number,
  params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/stats/payout_requests/state_categories`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementStatsPayoutRequestsStateCategoriesQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
    >,
    TError = GetDisbursementStatsPayoutRequestsStateCategories422
  >(
    organisationId: number,
    params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementStatsPayoutRequestsStateCategoriesQueryKey(
        organisationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
      >
    > = () =>
      getDisbursementStatsPayoutRequestsStateCategories(
        organisationId,
        params,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organisationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementStatsPayoutRequestsStateCategoriesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
    >
  >;
export type GetDisbursementStatsPayoutRequestsStateCategoriesQueryError =
  GetDisbursementStatsPayoutRequestsStateCategories422;

export function useGetDisbursementStatsPayoutRequestsStateCategories<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
  >,
  TError = GetDisbursementStatsPayoutRequestsStateCategories422
>(
  organisationId: number,
  params: undefined | GetDisbursementStatsPayoutRequestsStateCategoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementStatsPayoutRequestsStateCategories<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
  >,
  TError = GetDisbursementStatsPayoutRequestsStateCategories422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementStatsPayoutRequestsStateCategories<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
  >,
  TError = GetDisbursementStatsPayoutRequestsStateCategories422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get payout state category stats
 */

export function useGetDisbursementStatsPayoutRequestsStateCategories<
  TData = Awaited<
    ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
  >,
  TError = GetDisbursementStatsPayoutRequestsStateCategories422
>(
  organisationId: number,
  params?: GetDisbursementStatsPayoutRequestsStateCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementStatsPayoutRequestsStateCategories>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementStatsPayoutRequestsStateCategoriesQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get withdrawal account authorizations
 */
export const getDisbursementWithdrawalAccountAuthorizations = (
  organisationId: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementWithdrawalAccountAuthorizations200>(
    {
      url: `/disbursement/organisations/${organisationId}/withdrawal_account_authorizations`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementWithdrawalAccountAuthorizationsQueryKey = (
  organisationId?: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/withdrawal_account_authorizations`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementWithdrawalAccountAuthorizationsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
  >,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementWithdrawalAccountAuthorizationsQueryKey(
      organisationId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>>
  > = () =>
    getDisbursementWithdrawalAccountAuthorizations(
      organisationId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementWithdrawalAccountAuthorizationsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>>
  >;
export type GetDisbursementWithdrawalAccountAuthorizationsQueryError = unknown;

export function useGetDisbursementWithdrawalAccountAuthorizations<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
  >,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetDisbursementWithdrawalAccountAuthorizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementWithdrawalAccountAuthorizations<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
  >,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementWithdrawalAccountAuthorizations<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
  >,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get withdrawal account authorizations
 */

export function useGetDisbursementWithdrawalAccountAuthorizations<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
  >,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalAccountAuthorizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDisbursementWithdrawalAccountAuthorizations>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementWithdrawalAccountAuthorizationsQueryOptions(
      organisationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Organisations Withdrawal Accounts
 */
export const getDisbursementWithdrawalAccounts = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementWithdrawalAccounts200>(
    {
      url: `/disbursement/organisations/${organisationId}/withdrawal_accounts`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementWithdrawalAccountsQueryKey = (
  organisationId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/withdrawal_accounts`
  ] as const;
};

export const getGetDisbursementWithdrawalAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementWithdrawalAccountsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>
  > = () => getDisbursementWithdrawalAccounts(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementWithdrawalAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>
>;
export type GetDisbursementWithdrawalAccountsQueryError = unknown;

export function useGetDisbursementWithdrawalAccounts<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementWithdrawalAccounts<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementWithdrawalAccounts<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organisations Withdrawal Accounts
 */

export function useGetDisbursementWithdrawalAccounts<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementWithdrawalAccountsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Withdrawal Request
 */
export const postDisbursementWithdrawalRequests = (
  organisationId: number,
  postDisbursementWithdrawalRequestsBody: BodyType<PostDisbursementWithdrawalRequestsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostDisbursementWithdrawalRequests201>(
    {
      url: `/disbursement/organisations/${organisationId}/withdrawal_requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postDisbursementWithdrawalRequestsBody
    },
    options
  );
};

export const getPostDisbursementWithdrawalRequestsMutationOptions = <
  TError = null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostDisbursementWithdrawalRequestsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostDisbursementWithdrawalRequestsBody>;
  },
  TContext
> => {
  const mutationKey = ['postDisbursementWithdrawalRequests'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>,
    {
      organisationId: number;
      data: BodyType<PostDisbursementWithdrawalRequestsBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postDisbursementWithdrawalRequests(
      organisationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDisbursementWithdrawalRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>
>;
export type PostDisbursementWithdrawalRequestsMutationBody =
  BodyType<PostDisbursementWithdrawalRequestsBody>;
export type PostDisbursementWithdrawalRequestsMutationError = null;

/**
 * @summary Create Withdrawal Request
 */
export const usePostDisbursementWithdrawalRequests = <
  TError = null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostDisbursementWithdrawalRequestsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postDisbursementWithdrawalRequests>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostDisbursementWithdrawalRequestsBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPostDisbursementWithdrawalRequestsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Withdrawal Requests
 */
export const getDisbursementWithdrawalRequests = (
  organisationId: number,
  params?: GetDisbursementWithdrawalRequestsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementWithdrawalRequests200>(
    {
      url: `/disbursement/organisations/${organisationId}/withdrawal_requests`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDisbursementWithdrawalRequestsQueryKey = (
  organisationId?: number,
  params?: GetDisbursementWithdrawalRequestsParams
) => {
  return [
    `/disbursement/organisations/${organisationId}/withdrawal_requests`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisbursementWithdrawalRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDisbursementWithdrawalRequestsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>
  > = () =>
    getDisbursementWithdrawalRequests(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDisbursementWithdrawalRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>
>;
export type GetDisbursementWithdrawalRequestsQueryError = unknown;

export function useGetDisbursementWithdrawalRequests<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetDisbursementWithdrawalRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementWithdrawalRequests<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
          TError,
          Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementWithdrawalRequests<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Withdrawal Requests
 */

export function useGetDisbursementWithdrawalRequests<
  TData = Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDisbursementWithdrawalRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisbursementWithdrawalRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDisbursementWithdrawalRequestsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show Withdrawal Request
 */
export const getDisbursementWithdrawalRequestsWithdrawalRequestId = (
  organisationId: number,
  withdrawalRequestId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDisbursementWithdrawalRequestsWithdrawalRequestId200>(
    {
      url: `/disbursement/organisations/${organisationId}/withdrawal_requests/${withdrawalRequestId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryKey = (
  organisationId?: number,
  withdrawalRequestId?: number
) => {
  return [
    `/disbursement/organisations/${organisationId}/withdrawal_requests/${withdrawalRequestId}`
  ] as const;
};

export const getGetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
    >,
    TError = unknown
  >(
    organisationId: number,
    withdrawalRequestId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxiosInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryKey(
        organisationId,
        withdrawalRequestId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
      >
    > = () =>
      getDisbursementWithdrawalRequestsWithdrawalRequestId(
        organisationId,
        withdrawalRequestId,
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(organisationId && withdrawalRequestId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
    >
  >;
export type GetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryError =
  unknown;

export function useGetDisbursementWithdrawalRequestsWithdrawalRequestId<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
  >,
  TError = unknown
>(
  organisationId: number,
  withdrawalRequestId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDisbursementWithdrawalRequestsWithdrawalRequestId<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
  >,
  TError = unknown
>(
  organisationId: number,
  withdrawalRequestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDisbursementWithdrawalRequestsWithdrawalRequestId<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
  >,
  TError = unknown
>(
  organisationId: number,
  withdrawalRequestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show Withdrawal Request
 */

export function useGetDisbursementWithdrawalRequestsWithdrawalRequestId<
  TData = Awaited<
    ReturnType<typeof getDisbursementWithdrawalRequestsWithdrawalRequestId>
  >,
  TError = unknown
>(
  organisationId: number,
  withdrawalRequestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDisbursementWithdrawalRequestsWithdrawalRequestId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDisbursementWithdrawalRequestsWithdrawalRequestIdQueryOptions(
      organisationId,
      withdrawalRequestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Organisations with authenticated user
 */
export const getDocumentationOrganisations = (
  params?: GetDocumentationOrganisationsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDocumentationOrganisations200>(
    { url: `/documentation/organisations`, method: 'GET', params },
    options
  );
};

export const getGetDocumentationOrganisationsQueryKey = (
  params?: GetDocumentationOrganisationsParams
) => {
  return [`/documentation/organisations`, ...(params ? [params] : [])] as const;
};

export const getGetDocumentationOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentationOrganisations>>,
  TError = unknown
>(
  params?: GetDocumentationOrganisationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationOrganisations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentationOrganisationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentationOrganisations>>
  > = () => getDocumentationOrganisations(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentationOrganisations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDocumentationOrganisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentationOrganisations>>
>;
export type GetDocumentationOrganisationsQueryError = unknown;

export function useGetDocumentationOrganisations<
  TData = Awaited<ReturnType<typeof getDocumentationOrganisations>>,
  TError = unknown
>(
  params: undefined | GetDocumentationOrganisationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationOrganisations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationOrganisations>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationOrganisations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentationOrganisations<
  TData = Awaited<ReturnType<typeof getDocumentationOrganisations>>,
  TError = unknown
>(
  params?: GetDocumentationOrganisationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationOrganisations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationOrganisations>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationOrganisations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentationOrganisations<
  TData = Awaited<ReturnType<typeof getDocumentationOrganisations>>,
  TError = unknown
>(
  params?: GetDocumentationOrganisationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationOrganisations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organisations with authenticated user
 */

export function useGetDocumentationOrganisations<
  TData = Awaited<ReturnType<typeof getDocumentationOrganisations>>,
  TError = unknown
>(
  params?: GetDocumentationOrganisationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationOrganisations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDocumentationOrganisationsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Organisation by ID with standard auth
 */
export const getDocumentation = (
  organisationId: number,
  params?: GetDocumentationParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDocumentation200>(
    {
      url: `/documentation/organisations/${organisationId}`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDocumentationQueryKey = (
  organisationId?: number,
  params?: GetDocumentationParams
) => {
  return [
    `/documentation/organisations/${organisationId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDocumentationQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentation>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDocumentationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentationQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentation>>
  > = () => getDocumentation(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDocumentationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentation>>
>;
export type GetDocumentationQueryError = unknown;

export function useGetDocumentation<
  TData = Awaited<ReturnType<typeof getDocumentation>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetDocumentationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentation>>,
          TError,
          Awaited<ReturnType<typeof getDocumentation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentation<
  TData = Awaited<ReturnType<typeof getDocumentation>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDocumentationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentation>>,
          TError,
          Awaited<ReturnType<typeof getDocumentation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentation<
  TData = Awaited<ReturnType<typeof getDocumentation>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDocumentationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organisation by ID with standard auth
 */

export function useGetDocumentation<
  TData = Awaited<ReturnType<typeof getDocumentation>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetDocumentationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDocumentationQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get products by organisation with token
 */
export const getDocumentationProducts = (
  organisationId: number,
  params: GetDocumentationProductsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDocumentationProducts200>(
    {
      url: `/documentation/organisations/${organisationId}/products`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDocumentationProductsQueryKey = (
  organisationId?: number,
  params?: GetDocumentationProductsParams
) => {
  return [
    `/documentation/organisations/${organisationId}/products`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDocumentationProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentationProducts>>,
  TError = unknown
>(
  organisationId: number,
  params: GetDocumentationProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentationProductsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentationProducts>>
  > = () => getDocumentationProducts(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentationProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDocumentationProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentationProducts>>
>;
export type GetDocumentationProductsQueryError = unknown;

export function useGetDocumentationProducts<
  TData = Awaited<ReturnType<typeof getDocumentationProducts>>,
  TError = unknown
>(
  organisationId: number,
  params: GetDocumentationProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationProducts>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentationProducts<
  TData = Awaited<ReturnType<typeof getDocumentationProducts>>,
  TError = unknown
>(
  organisationId: number,
  params: GetDocumentationProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationProducts>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentationProducts<
  TData = Awaited<ReturnType<typeof getDocumentationProducts>>,
  TError = unknown
>(
  organisationId: number,
  params: GetDocumentationProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get products by organisation with token
 */

export function useGetDocumentationProducts<
  TData = Awaited<ReturnType<typeof getDocumentationProducts>>,
  TError = unknown
>(
  organisationId: number,
  params: GetDocumentationProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDocumentationProductsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get single product with token
 */
export const getDocumentationProductsProductId = (
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetDocumentationProductsProductId200>(
    {
      url: `/documentation/organisations/${organisationId}/products/${productId}`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetDocumentationProductsProductIdQueryKey = (
  organisationId?: number,
  productId?: number,
  params?: GetDocumentationProductsProductIdParams
) => {
  return [
    `/documentation/organisations/${organisationId}/products/${productId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDocumentationProductsProductIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
  TError = unknown
>(
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentationProductsProductIdQueryKey(
      organisationId,
      productId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentationProductsProductId>>
  > = () =>
    getDocumentationProductsProductId(
      organisationId,
      productId,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && productId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDocumentationProductsProductIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentationProductsProductId>>
>;
export type GetDocumentationProductsProductIdQueryError = unknown;

export function useGetDocumentationProductsProductId<
  TData = Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
  TError = unknown
>(
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationProductsProductId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentationProductsProductId<
  TData = Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
  TError = unknown
>(
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentationProductsProductId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentationProductsProductId<
  TData = Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
  TError = unknown
>(
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get single product with token
 */

export function useGetDocumentationProductsProductId<
  TData = Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
  TError = unknown
>(
  organisationId: number,
  productId: number,
  params: GetDocumentationProductsProductIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentationProductsProductId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDocumentationProductsProductIdQueryOptions(
    organisationId,
    productId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get flipper features
 */
export const getFeatureFlags = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetFeatureFlags200>(
    { url: `/feature_flags`, method: 'GET' },
    options
  );
};

export const getGetFeatureFlagsQueryKey = () => {
  return [`/feature_flags`] as const;
};

export const getGetFeatureFlagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeatureFlagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeatureFlags>>
  > = () => getFeatureFlags(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeatureFlags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFeatureFlagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeatureFlags>>
>;
export type GetFeatureFlagsQueryError = unknown;

export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get flipper features
 */

export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFeatureFlagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch currencies
 */
export const getFxCurrencies = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetFxCurrencies200>(
    { url: `/fx/organisations/${organisationId}/currencies`, method: 'GET' },
    options
  );
};

export const getGetFxCurrenciesQueryKey = (organisationId?: number) => {
  return [`/fx/organisations/${organisationId}/currencies`] as const;
};

export const getGetFxCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFxCurrencies>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFxCurrenciesQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFxCurrencies>>
  > = () => getFxCurrencies(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFxCurrencies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFxCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFxCurrencies>>
>;
export type GetFxCurrenciesQueryError = unknown;

export function useGetFxCurrencies<
  TData = Awaited<ReturnType<typeof getFxCurrencies>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getFxCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFxCurrencies<
  TData = Awaited<ReturnType<typeof getFxCurrencies>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxCurrencies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxCurrencies>>,
          TError,
          Awaited<ReturnType<typeof getFxCurrencies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFxCurrencies<
  TData = Awaited<ReturnType<typeof getFxCurrencies>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Fetch currencies
 */

export function useGetFxCurrencies<
  TData = Awaited<ReturnType<typeof getFxCurrencies>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxCurrencies>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFxCurrenciesQueryOptions(organisationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Retrieve Exchange Rate
 */
export const getFxExchangeRate = (
  organisationId: number,
  params: GetFxExchangeRateParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetFxExchangeRate200>(
    {
      url: `/fx/organisations/${organisationId}/exchange_rate`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetFxExchangeRateQueryKey = (
  organisationId?: number,
  params?: GetFxExchangeRateParams
) => {
  return [
    `/fx/organisations/${organisationId}/exchange_rate`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetFxExchangeRateQueryOptions = <
  TData = Awaited<ReturnType<typeof getFxExchangeRate>>,
  TError = GetFxExchangeRate404 | GetFxExchangeRate422
>(
  organisationId: number,
  params: GetFxExchangeRateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxExchangeRate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFxExchangeRateQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFxExchangeRate>>
  > = () => getFxExchangeRate(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFxExchangeRate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFxExchangeRateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFxExchangeRate>>
>;
export type GetFxExchangeRateQueryError =
  | GetFxExchangeRate404
  | GetFxExchangeRate422;

export function useGetFxExchangeRate<
  TData = Awaited<ReturnType<typeof getFxExchangeRate>>,
  TError = GetFxExchangeRate404 | GetFxExchangeRate422
>(
  organisationId: number,
  params: GetFxExchangeRateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxExchangeRate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxExchangeRate>>,
          TError,
          Awaited<ReturnType<typeof getFxExchangeRate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFxExchangeRate<
  TData = Awaited<ReturnType<typeof getFxExchangeRate>>,
  TError = GetFxExchangeRate404 | GetFxExchangeRate422
>(
  organisationId: number,
  params: GetFxExchangeRateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxExchangeRate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxExchangeRate>>,
          TError,
          Awaited<ReturnType<typeof getFxExchangeRate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFxExchangeRate<
  TData = Awaited<ReturnType<typeof getFxExchangeRate>>,
  TError = GetFxExchangeRate404 | GetFxExchangeRate422
>(
  organisationId: number,
  params: GetFxExchangeRateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxExchangeRate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Retrieve Exchange Rate
 */

export function useGetFxExchangeRate<
  TData = Awaited<ReturnType<typeof getFxExchangeRate>>,
  TError = GetFxExchangeRate404 | GetFxExchangeRate422
>(
  organisationId: number,
  params: GetFxExchangeRateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFxExchangeRate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFxExchangeRateQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch markups
 */
export const getFxMarkups = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetFxMarkups200>(
    { url: `/fx/organisations/${organisationId}/markups`, method: 'GET' },
    options
  );
};

export const getGetFxMarkupsQueryKey = (organisationId?: number) => {
  return [`/fx/organisations/${organisationId}/markups`] as const;
};

export const getGetFxMarkupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFxMarkups>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFxMarkups>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFxMarkupsQueryKey(organisationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFxMarkups>>> = () =>
    getFxMarkups(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFxMarkups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFxMarkupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFxMarkups>>
>;
export type GetFxMarkupsQueryError = unknown;

export function useGetFxMarkups<
  TData = Awaited<ReturnType<typeof getFxMarkups>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFxMarkups>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxMarkups>>,
          TError,
          Awaited<ReturnType<typeof getFxMarkups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFxMarkups<
  TData = Awaited<ReturnType<typeof getFxMarkups>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFxMarkups>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxMarkups>>,
          TError,
          Awaited<ReturnType<typeof getFxMarkups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFxMarkups<
  TData = Awaited<ReturnType<typeof getFxMarkups>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFxMarkups>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Fetch markups
 */

export function useGetFxMarkups<
  TData = Awaited<ReturnType<typeof getFxMarkups>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFxMarkups>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFxMarkupsQueryOptions(organisationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List external_app auth schemes
 */
export const getIntegrationAuthSchemes = (
  organisationId: number,
  params?: GetIntegrationAuthSchemesParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetIntegrationAuthSchemes200>(
    {
      url: `/integration/organisations/${organisationId}/auth_schemes`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetIntegrationAuthSchemesQueryKey = (
  organisationId?: number,
  params?: GetIntegrationAuthSchemesParams
) => {
  return [
    `/integration/organisations/${organisationId}/auth_schemes`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetIntegrationAuthSchemesQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationAuthSchemesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntegrationAuthSchemesQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntegrationAuthSchemes>>
  > = () => getIntegrationAuthSchemes(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntegrationAuthSchemesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationAuthSchemes>>
>;
export type GetIntegrationAuthSchemesQueryError = null | null;

export function useGetIntegrationAuthSchemes<
  TData = Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
  TError = null | null
>(
  organisationId: number,
  params: undefined | GetIntegrationAuthSchemesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationAuthSchemes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationAuthSchemes<
  TData = Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationAuthSchemesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationAuthSchemes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationAuthSchemes<
  TData = Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationAuthSchemesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List external_app auth schemes
 */

export function useGetIntegrationAuthSchemes<
  TData = Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationAuthSchemesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationAuthSchemes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntegrationAuthSchemesQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a PKCS auth scheme
 */
export const postIntegrationAuthSchemes = (
  organisationId: number,
  postIntegrationAuthSchemesBody: BodyType<PostIntegrationAuthSchemesBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationAuthSchemes201>(
    {
      url: `/integration/organisations/${organisationId}/auth_schemes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postIntegrationAuthSchemesBody
    },
    options
  );
};

export const getPostIntegrationAuthSchemesMutationOptions = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationAuthSchemes>>,
    TError,
    { organisationId: number; data: BodyType<PostIntegrationAuthSchemesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationAuthSchemes>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationAuthSchemesBody> },
  TContext
> => {
  const mutationKey = ['postIntegrationAuthSchemes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationAuthSchemes>>,
    { organisationId: number; data: BodyType<PostIntegrationAuthSchemesBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationAuthSchemes(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationAuthSchemesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationAuthSchemes>>
>;
export type PostIntegrationAuthSchemesMutationBody =
  BodyType<PostIntegrationAuthSchemesBody>;
export type PostIntegrationAuthSchemesMutationError =
  null | null | IntegrationValidationError;

/**
 * @summary Create a PKCS auth scheme
 */
export const usePostIntegrationAuthSchemes = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationAuthSchemes>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostIntegrationAuthSchemesBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationAuthSchemes>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationAuthSchemesBody> },
  TContext
> => {
  const mutationOptions = getPostIntegrationAuthSchemesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a JWT (sign) auth scheme
 */
export const postIntegrationAuthSchemesSign = (
  organisationId: number,
  postIntegrationAuthSchemesSignBody: BodyType<PostIntegrationAuthSchemesSignBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationAuthSchemesSign201>(
    {
      url: `/integration/organisations/${organisationId}/auth_schemes/sign`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postIntegrationAuthSchemesSignBody
    },
    options
  );
};

export const getPostIntegrationAuthSchemesSignMutationOptions = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostIntegrationAuthSchemesSignBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostIntegrationAuthSchemesSignBody>;
  },
  TContext
> => {
  const mutationKey = ['postIntegrationAuthSchemesSign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>,
    {
      organisationId: number;
      data: BodyType<PostIntegrationAuthSchemesSignBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationAuthSchemesSign(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationAuthSchemesSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>
>;
export type PostIntegrationAuthSchemesSignMutationBody =
  BodyType<PostIntegrationAuthSchemesSignBody>;
export type PostIntegrationAuthSchemesSignMutationError =
  null | IntegrationValidationError;

/**
 * @summary Create a JWT (sign) auth scheme
 */
export const usePostIntegrationAuthSchemesSign = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostIntegrationAuthSchemesSignBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesSign>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostIntegrationAuthSchemesSignBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPostIntegrationAuthSchemesSignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Enable a disabled scheme
 */
export const postIntegrationAuthSchemesUuidEnable = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationAuthSchemesUuidEnable200>(
    {
      url: `/integration/organisations/${organisationId}/auth_schemes/${uuid}/enable`,
      method: 'POST'
    },
    options
  );
};

export const getPostIntegrationAuthSchemesUuidEnableMutationOptions = <
  TError = null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['postIntegrationAuthSchemesUuidEnable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return postIntegrationAuthSchemesUuidEnable(
      organisationId,
      uuid,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationAuthSchemesUuidEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>
>;

export type PostIntegrationAuthSchemesUuidEnableMutationError = null | null;

/**
 * @summary Enable a disabled scheme
 */
export const usePostIntegrationAuthSchemesUuidEnable = <
  TError = null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationAuthSchemesUuidEnable>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getPostIntegrationAuthSchemesUuidEnableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Disable a scheme (soft delete)
 */
export const deleteIntegrationAuthSchemesUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteIntegrationAuthSchemesUuid200>(
    {
      url: `/integration/organisations/${organisationId}/auth_schemes/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteIntegrationAuthSchemesUuidMutationOptions = <
  TError = null | null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['deleteIntegrationAuthSchemesUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return deleteIntegrationAuthSchemesUuid(
      organisationId,
      uuid,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntegrationAuthSchemesUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>
>;

export type DeleteIntegrationAuthSchemesUuidMutationError = null | null | null;

/**
 * @summary Disable a scheme (soft delete)
 */
export const useDeleteIntegrationAuthSchemesUuid = <
  TError = null | null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteIntegrationAuthSchemesUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getDeleteIntegrationAuthSchemesUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List business units
 */
export const getIntegrationBusinessUnits = (
  organisationId: number,
  params?: GetIntegrationBusinessUnitsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetIntegrationBusinessUnits200>(
    {
      url: `/integration/organisations/${organisationId}/business_units`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetIntegrationBusinessUnitsQueryKey = (
  organisationId?: number,
  params?: GetIntegrationBusinessUnitsParams
) => {
  return [
    `/integration/organisations/${organisationId}/business_units`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetIntegrationBusinessUnitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationBusinessUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntegrationBusinessUnitsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntegrationBusinessUnits>>
  > = () => getIntegrationBusinessUnits(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntegrationBusinessUnitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationBusinessUnits>>
>;
export type GetIntegrationBusinessUnitsQueryError = null | null;

export function useGetIntegrationBusinessUnits<
  TData = Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
  TError = null | null
>(
  organisationId: number,
  params: undefined | GetIntegrationBusinessUnitsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationBusinessUnits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationBusinessUnits<
  TData = Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationBusinessUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationBusinessUnits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationBusinessUnits<
  TData = Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationBusinessUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List business units
 */

export function useGetIntegrationBusinessUnits<
  TData = Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationBusinessUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationBusinessUnits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntegrationBusinessUnitsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a business unit
 */
export const postIntegrationBusinessUnits = (
  organisationId: number,
  postIntegrationBusinessUnitsBody: BodyType<PostIntegrationBusinessUnitsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationBusinessUnits201>(
    {
      url: `/integration/organisations/${organisationId}/business_units`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postIntegrationBusinessUnitsBody
    },
    options
  );
};

export const getPostIntegrationBusinessUnitsMutationOptions = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationBusinessUnits>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostIntegrationBusinessUnitsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationBusinessUnits>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationBusinessUnitsBody> },
  TContext
> => {
  const mutationKey = ['postIntegrationBusinessUnits'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationBusinessUnits>>,
    { organisationId: number; data: BodyType<PostIntegrationBusinessUnitsBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationBusinessUnits(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationBusinessUnitsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationBusinessUnits>>
>;
export type PostIntegrationBusinessUnitsMutationBody =
  BodyType<PostIntegrationBusinessUnitsBody>;
export type PostIntegrationBusinessUnitsMutationError =
  null | null | IntegrationValidationError;

/**
 * @summary Create a business unit
 */
export const usePostIntegrationBusinessUnits = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationBusinessUnits>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostIntegrationBusinessUnitsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationBusinessUnits>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationBusinessUnitsBody> },
  TContext
> => {
  const mutationOptions =
    getPostIntegrationBusinessUnitsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Rename a business unit
 */
export const patchIntegrationBusinessUnitsUuid = (
  organisationId: number,
  uuid: string,
  patchIntegrationBusinessUnitsUuidBody: BodyType<PatchIntegrationBusinessUnitsUuidBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PatchIntegrationBusinessUnitsUuid200>(
    {
      url: `/integration/organisations/${organisationId}/business_units/${uuid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchIntegrationBusinessUnitsUuidBody
    },
    options
  );
};

export const getPatchIntegrationBusinessUnitsUuidMutationOptions = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>,
    TError,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PatchIntegrationBusinessUnitsUuidBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PatchIntegrationBusinessUnitsUuidBody>;
  },
  TContext
> => {
  const mutationKey = ['patchIntegrationBusinessUnitsUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PatchIntegrationBusinessUnitsUuidBody>;
    }
  > = (props) => {
    const { organisationId, uuid, data } = props ?? {};

    return patchIntegrationBusinessUnitsUuid(
      organisationId,
      uuid,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchIntegrationBusinessUnitsUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>
>;
export type PatchIntegrationBusinessUnitsUuidMutationBody =
  BodyType<PatchIntegrationBusinessUnitsUuidBody>;
export type PatchIntegrationBusinessUnitsUuidMutationError =
  null | null | IntegrationValidationError;

/**
 * @summary Rename a business unit
 */
export const usePatchIntegrationBusinessUnitsUuid = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>,
      TError,
      {
        organisationId: number;
        uuid: string;
        data: BodyType<PatchIntegrationBusinessUnitsUuidBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchIntegrationBusinessUnitsUuid>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PatchIntegrationBusinessUnitsUuidBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPatchIntegrationBusinessUnitsUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a business unit
 */
export const deleteIntegrationBusinessUnitsUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteIntegrationBusinessUnitsUuid200>(
    {
      url: `/integration/organisations/${organisationId}/business_units/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteIntegrationBusinessUnitsUuidMutationOptions = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['deleteIntegrationBusinessUnitsUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return deleteIntegrationBusinessUnitsUuid(
      organisationId,
      uuid,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntegrationBusinessUnitsUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>
>;

export type DeleteIntegrationBusinessUnitsUuidMutationError =
  null | null | IntegrationValidationError;

/**
 * @summary Delete a business unit
 */
export const useDeleteIntegrationBusinessUnitsUuid = <
  TError = null | null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteIntegrationBusinessUnitsUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getDeleteIntegrationBusinessUnitsUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mark a business unit as the organisation default
 */
export const postIntegrationBusinessUnitsUuidSetDefault = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationBusinessUnitsUuidSetDefault200>(
    {
      url: `/integration/organisations/${organisationId}/business_units/${uuid}/set_default`,
      method: 'POST'
    },
    options
  );
};

export const getPostIntegrationBusinessUnitsUuidSetDefaultMutationOptions = <
  TError = null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['postIntegrationBusinessUnitsUuidSetDefault'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return postIntegrationBusinessUnitsUuidSetDefault(
      organisationId,
      uuid,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationBusinessUnitsUuidSetDefaultMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>
  >;

export type PostIntegrationBusinessUnitsUuidSetDefaultMutationError =
  | null
  | null;

/**
 * @summary Mark a business unit as the organisation default
 */
export const usePostIntegrationBusinessUnitsUuidSetDefault = <
  TError = null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationBusinessUnitsUuidSetDefault>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getPostIntegrationBusinessUnitsUuidSetDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List MCP tokens
 */
export const getIntegrationMcpTokens = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetIntegrationMcpTokens200>(
    {
      url: `/integration/organisations/${organisationId}/mcp_tokens`,
      method: 'GET'
    },
    options
  );
};

export const getGetIntegrationMcpTokensQueryKey = (organisationId?: number) => {
  return [`/integration/organisations/${organisationId}/mcp_tokens`] as const;
};

export const getGetIntegrationMcpTokensQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntegrationMcpTokensQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntegrationMcpTokens>>
  > = () => getIntegrationMcpTokens(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntegrationMcpTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationMcpTokens>>
>;
export type GetIntegrationMcpTokensQueryError = null | null;

export function useGetIntegrationMcpTokens<
  TData = Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
  TError = null | null
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationMcpTokens>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationMcpTokens<
  TData = Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationMcpTokens>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationMcpTokens<
  TData = Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List MCP tokens
 */

export function useGetIntegrationMcpTokens<
  TData = Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationMcpTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntegrationMcpTokensQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create an MCP token
 */
export const postIntegrationMcpTokens = (
  organisationId: number,
  postIntegrationMcpTokensBody: BodyType<PostIntegrationMcpTokensBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostIntegrationMcpTokens201>(
    {
      url: `/integration/organisations/${organisationId}/mcp_tokens`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postIntegrationMcpTokensBody
    },
    options
  );
};

export const getPostIntegrationMcpTokensMutationOptions = <
  TError = null | null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationMcpTokens>>,
    TError,
    { organisationId: number; data: BodyType<PostIntegrationMcpTokensBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationMcpTokens>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationMcpTokensBody> },
  TContext
> => {
  const mutationKey = ['postIntegrationMcpTokens'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationMcpTokens>>,
    { organisationId: number; data: BodyType<PostIntegrationMcpTokensBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationMcpTokens(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationMcpTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationMcpTokens>>
>;
export type PostIntegrationMcpTokensMutationBody =
  BodyType<PostIntegrationMcpTokensBody>;
export type PostIntegrationMcpTokensMutationError = null | null | null;

/**
 * @summary Create an MCP token
 */
export const usePostIntegrationMcpTokens = <
  TError = null | null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationMcpTokens>>,
      TError,
      { organisationId: number; data: BodyType<PostIntegrationMcpTokensBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationMcpTokens>>,
  TError,
  { organisationId: number; data: BodyType<PostIntegrationMcpTokensBody> },
  TContext
> => {
  const mutationOptions = getPostIntegrationMcpTokensMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revoke an MCP token
 */
export const deleteIntegrationMcpTokensUuid = (
  organisationId: number,
  uuid: string,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<DeleteIntegrationMcpTokensUuid200>(
    {
      url: `/integration/organisations/${organisationId}/mcp_tokens/${uuid}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteIntegrationMcpTokensUuidMutationOptions = <
  TError = null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>,
    TError,
    { organisationId: number; uuid: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationKey = ['deleteIntegrationMcpTokensUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>,
    { organisationId: number; uuid: string }
  > = (props) => {
    const { organisationId, uuid } = props ?? {};

    return deleteIntegrationMcpTokensUuid(organisationId, uuid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntegrationMcpTokensUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>
>;

export type DeleteIntegrationMcpTokensUuidMutationError = null | null;

/**
 * @summary Revoke an MCP token
 */
export const useDeleteIntegrationMcpTokensUuid = <
  TError = null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>,
      TError,
      { organisationId: number; uuid: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteIntegrationMcpTokensUuid>>,
  TError,
  { organisationId: number; uuid: string },
  TContext
> => {
  const mutationOptions =
    getDeleteIntegrationMcpTokensUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List webhooks
 */
export const getIntegrationWebhooks = (
  organisationId: number,
  params?: GetIntegrationWebhooksParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetIntegrationWebhooks200>(
    {
      url: `/integration/organisations/${organisationId}/webhooks`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetIntegrationWebhooksQueryKey = (
  organisationId?: number,
  params?: GetIntegrationWebhooksParams
) => {
  return [
    `/integration/organisations/${organisationId}/webhooks`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetIntegrationWebhooksQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationWebhooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntegrationWebhooksQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntegrationWebhooks>>
  > = () => getIntegrationWebhooks(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationWebhooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntegrationWebhooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationWebhooks>>
>;
export type GetIntegrationWebhooksQueryError = null | null;

export function useGetIntegrationWebhooks<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>,
  TError = null | null
>(
  organisationId: number,
  params: undefined | GetIntegrationWebhooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationWebhooks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationWebhooks<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationWebhooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationWebhooks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationWebhooks<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationWebhooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List webhooks
 */

export function useGetIntegrationWebhooks<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>,
  TError = null | null
>(
  organisationId: number,
  params?: GetIntegrationWebhooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntegrationWebhooksQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create webhooks
 */
export const postIntegrationWebhooks = (
  organisationId: number,
  webhookCreateRequest: BodyType<WebhookCreateRequest>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<WebhookCreateResponse | WebhookCreateResponse>(
    {
      url: `/integration/organisations/${organisationId}/webhooks`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: webhookCreateRequest
    },
    options
  );
};

export const getPostIntegrationWebhooksMutationOptions = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationWebhooks>>,
    TError,
    { organisationId: number; data: BodyType<WebhookCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationWebhooks>>,
  TError,
  { organisationId: number; data: BodyType<WebhookCreateRequest> },
  TContext
> => {
  const mutationKey = ['postIntegrationWebhooks'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationWebhooks>>,
    { organisationId: number; data: BodyType<WebhookCreateRequest> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationWebhooks(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationWebhooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationWebhooks>>
>;
export type PostIntegrationWebhooksMutationBody =
  BodyType<WebhookCreateRequest>;
export type PostIntegrationWebhooksMutationError =
  null | IntegrationValidationError;

/**
 * @summary Create webhooks
 */
export const usePostIntegrationWebhooks = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationWebhooks>>,
      TError,
      { organisationId: number; data: BodyType<WebhookCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationWebhooks>>,
  TError,
  { organisationId: number; data: BodyType<WebhookCreateRequest> },
  TContext
> => {
  const mutationOptions = getPostIntegrationWebhooksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The authoritative set of events POST /webhooks accepts and the formats each
publishes. Build the event picker from this rather than a hardcoded list.
`default_format` is the format applied when a create request names none.

 * @summary List subscribable webhook events
 */
export const getIntegrationWebhooksEvents = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<WebhookEventsResponse>(
    {
      url: `/integration/organisations/${organisationId}/webhooks/events`,
      method: 'GET'
    },
    options
  );
};

export const getGetIntegrationWebhooksEventsQueryKey = (
  organisationId?: number
) => {
  return [
    `/integration/organisations/${organisationId}/webhooks/events`
  ] as const;
};

export const getGetIntegrationWebhooksEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntegrationWebhooksEventsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>
  > = () => getIntegrationWebhooksEvents(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntegrationWebhooksEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>
>;
export type GetIntegrationWebhooksEventsQueryError = null | null;

export function useGetIntegrationWebhooksEvents<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
  TError = null | null
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationWebhooksEvents<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationWebhooksEvents<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List subscribable webhook events
 */

export function useGetIntegrationWebhooksEvents<
  TData = Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
  TError = null | null
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrationWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntegrationWebhooksEventsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a webhook
 */
export const patchIntegrationWebhooksUuid = (
  organisationId: number,
  uuid: string,
  webhookUpdateRequest: BodyType<WebhookUpdateRequest>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<WebhookResponse>(
    {
      url: `/integration/organisations/${organisationId}/webhooks/${uuid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: webhookUpdateRequest
    },
    options
  );
};

export const getPatchIntegrationWebhooksUuidMutationOptions = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>,
    TError,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<WebhookUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<WebhookUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchIntegrationWebhooksUuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<WebhookUpdateRequest>;
    }
  > = (props) => {
    const { organisationId, uuid, data } = props ?? {};

    return patchIntegrationWebhooksUuid(
      organisationId,
      uuid,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchIntegrationWebhooksUuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>
>;
export type PatchIntegrationWebhooksUuidMutationBody =
  BodyType<WebhookUpdateRequest>;
export type PatchIntegrationWebhooksUuidMutationError =
  null | IntegrationValidationError;

/**
 * @summary Update a webhook
 */
export const usePatchIntegrationWebhooksUuid = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>,
      TError,
      {
        organisationId: number;
        uuid: string;
        data: BodyType<WebhookUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchIntegrationWebhooksUuid>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<WebhookUpdateRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getPatchIntegrationWebhooksUuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Bulk-update webhooks
 */
export const postIntegrationWebhooksBulkUpdate = (
  organisationId: number,
  webhookBulkUpdateRequest: BodyType<WebhookBulkUpdateRequest>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<WebhookBulkUpdateResponse>(
    {
      url: `/integration/organisations/${organisationId}/webhooks/bulk_update`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: webhookBulkUpdateRequest
    },
    options
  );
};

export const getPostIntegrationWebhooksBulkUpdateMutationOptions = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>,
    TError,
    { organisationId: number; data: BodyType<WebhookBulkUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>,
  TError,
  { organisationId: number; data: BodyType<WebhookBulkUpdateRequest> },
  TContext
> => {
  const mutationKey = ['postIntegrationWebhooksBulkUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>,
    { organisationId: number; data: BodyType<WebhookBulkUpdateRequest> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postIntegrationWebhooksBulkUpdate(
      organisationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationWebhooksBulkUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>
>;
export type PostIntegrationWebhooksBulkUpdateMutationBody =
  BodyType<WebhookBulkUpdateRequest>;
export type PostIntegrationWebhooksBulkUpdateMutationError =
  null | IntegrationValidationError;

/**
 * @summary Bulk-update webhooks
 */
export const usePostIntegrationWebhooksBulkUpdate = <
  TError = null | IntegrationValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>,
      TError,
      { organisationId: number; data: BodyType<WebhookBulkUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postIntegrationWebhooksBulkUpdate>>,
  TError,
  { organisationId: number; data: BodyType<WebhookBulkUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getPostIntegrationWebhooksBulkUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns the calling organisation's documentation link — the magic-token
URL the customer docs SPA accepts — resolved from the presented MCP
token. The same URL the admin UI mints for staff hand-off.

Authentication: the presented MCP token is the sole credential
(`Authorization: Bearer tenant_mcp_…`); no user session/JWT is involved.
The owning organisation comes from the token itself, never from the
request.

404 semantics: the link is minted from server-side configuration; when
that configuration is absent the endpoint answers 404 with
`documentation_link_not_available` — distinct from the 401 auth shape.

Every response carries `Cache-Control: no-store` so no intermediary
outlives token revocation.

Consumer of the contract: PEGO-13897 (mcp_onboarding docs search).

 * @summary Fetch the customer-specific documentation link
 */
export const getMcpDocumentationLink = (
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetMcpDocumentationLink200>(
    { url: `/mcp/documentation_link`, method: 'GET' },
    options
  );
};

export const getGetMcpDocumentationLinkQueryKey = () => {
  return [`/mcp/documentation_link`] as const;
};

export const getGetMcpDocumentationLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof getMcpDocumentationLink>>,
  TError = GetMcpDocumentationLink401 | GetMcpDocumentationLink404
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMcpDocumentationLink>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMcpDocumentationLinkQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMcpDocumentationLink>>
  > = () => getMcpDocumentationLink(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMcpDocumentationLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMcpDocumentationLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMcpDocumentationLink>>
>;
export type GetMcpDocumentationLinkQueryError =
  | GetMcpDocumentationLink401
  | GetMcpDocumentationLink404;

export function useGetMcpDocumentationLink<
  TData = Awaited<ReturnType<typeof getMcpDocumentationLink>>,
  TError = GetMcpDocumentationLink401 | GetMcpDocumentationLink404
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpDocumentationLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMcpDocumentationLink>>,
          TError,
          Awaited<ReturnType<typeof getMcpDocumentationLink>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMcpDocumentationLink<
  TData = Awaited<ReturnType<typeof getMcpDocumentationLink>>,
  TError = GetMcpDocumentationLink401 | GetMcpDocumentationLink404
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpDocumentationLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMcpDocumentationLink>>,
          TError,
          Awaited<ReturnType<typeof getMcpDocumentationLink>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMcpDocumentationLink<
  TData = Awaited<ReturnType<typeof getMcpDocumentationLink>>,
  TError = GetMcpDocumentationLink401 | GetMcpDocumentationLink404
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpDocumentationLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Fetch the customer-specific documentation link
 */

export function useGetMcpDocumentationLink<
  TData = Awaited<ReturnType<typeof getMcpDocumentationLink>>,
  TError = GetMcpDocumentationLink401 | GetMcpDocumentationLink404
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpDocumentationLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMcpDocumentationLinkQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Retrieve In-App Alerts
 */
export const getNotificationsAlerts = (
  organisationId: number,
  params?: GetNotificationsAlertsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetNotificationsAlerts200>(
    {
      url: `/notifications/organisations/${organisationId}/alerts`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetNotificationsAlertsQueryKey = (
  organisationId?: number,
  params?: GetNotificationsAlertsParams
) => {
  return [
    `/notifications/organisations/${organisationId}/alerts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetNotificationsAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsAlerts>>,
  TError = null
>(
  organisationId: number,
  params?: GetNotificationsAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationsAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNotificationsAlertsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationsAlerts>>
  > = () => getNotificationsAlerts(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsAlerts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetNotificationsAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsAlerts>>
>;
export type GetNotificationsAlertsQueryError = null;

export function useGetNotificationsAlerts<
  TData = Awaited<ReturnType<typeof getNotificationsAlerts>>,
  TError = null
>(
  organisationId: number,
  params: undefined | GetNotificationsAlertsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationsAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsAlerts>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsAlerts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetNotificationsAlerts<
  TData = Awaited<ReturnType<typeof getNotificationsAlerts>>,
  TError = null
>(
  organisationId: number,
  params?: GetNotificationsAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationsAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsAlerts>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsAlerts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNotificationsAlerts<
  TData = Awaited<ReturnType<typeof getNotificationsAlerts>>,
  TError = null
>(
  organisationId: number,
  params?: GetNotificationsAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationsAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Retrieve In-App Alerts
 */

export function useGetNotificationsAlerts<
  TData = Awaited<ReturnType<typeof getNotificationsAlerts>>,
  TError = null
>(
  organisationId: number,
  params?: GetNotificationsAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationsAlerts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetNotificationsAlertsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Index Accounts Request
 */
export const getVirtualBankAccounts = (
  organisationId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankAccounts200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/accounts`,
      method: 'GET'
    },
    options
  );
};

export const getGetVirtualBankAccountsQueryKey = (organisationId?: number) => {
  return [`/virtual_bank/organisations/${organisationId}/accounts`] as const;
};

export const getGetVirtualBankAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getVirtualBankAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVirtualBankAccountsQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankAccounts>>
  > = () => getVirtualBankAccounts(organisationId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankAccounts>>
>;
export type GetVirtualBankAccountsQueryError = unknown;

export function useGetVirtualBankAccounts<
  TData = Awaited<ReturnType<typeof getVirtualBankAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankAccounts<
  TData = Awaited<ReturnType<typeof getVirtualBankAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankAccounts<
  TData = Awaited<ReturnType<typeof getVirtualBankAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Accounts Request
 */

export function useGetVirtualBankAccounts<
  TData = Awaited<ReturnType<typeof getVirtualBankAccounts>>,
  TError = unknown
>(
  organisationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVirtualBankAccountsQueryOptions(
    organisationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Account summary Request
 */
export const getVirtualBankAccountsAccountNumberSummary = (
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankAccountsAccountNumberSummary200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/accounts/${accountNumber}/summary`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetVirtualBankAccountsAccountNumberSummaryQueryKey = (
  organisationId?: number,
  accountNumber?: number,
  params?: GetVirtualBankAccountsAccountNumberSummaryParams
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/accounts/${accountNumber}/summary`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetVirtualBankAccountsAccountNumberSummaryQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
  >,
  TError = null
>(
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankAccountsAccountNumberSummaryQueryKey(
      organisationId,
      accountNumber,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>
  > = () =>
    getVirtualBankAccountsAccountNumberSummary(
      organisationId,
      accountNumber,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && accountNumber),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankAccountsAccountNumberSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>
>;
export type GetVirtualBankAccountsAccountNumberSummaryQueryError = null;

export function useGetVirtualBankAccountsAccountNumberSummary<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
  >,
  TError = null
>(
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
          >,
          TError,
          Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankAccountsAccountNumberSummary<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
  >,
  TError = null
>(
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
          >,
          TError,
          Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankAccountsAccountNumberSummary<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
  >,
  TError = null
>(
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Account summary Request
 */

export function useGetVirtualBankAccountsAccountNumberSummary<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>
  >,
  TError = null
>(
  organisationId: number,
  accountNumber: number,
  params: GetVirtualBankAccountsAccountNumberSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetVirtualBankAccountsAccountNumberSummaryQueryOptions(
      organisationId,
      accountNumber,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create inter account movement
 */
export const postVirtualBankInterAccountMovements = (
  organisationId: number,
  postVirtualBankInterAccountMovementsBody: BodyType<PostVirtualBankInterAccountMovementsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostVirtualBankInterAccountMovements200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/inter_account_movements`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postVirtualBankInterAccountMovementsBody
    },
    options
  );
};

export const getPostVirtualBankInterAccountMovementsMutationOptions = <
  TError = null | PostVirtualBankInterAccountMovements422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>,
    TError,
    {
      organisationId: number;
      data: BodyType<PostVirtualBankInterAccountMovementsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostVirtualBankInterAccountMovementsBody>;
  },
  TContext
> => {
  const mutationKey = ['postVirtualBankInterAccountMovements'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>,
    {
      organisationId: number;
      data: BodyType<PostVirtualBankInterAccountMovementsBody>;
    }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postVirtualBankInterAccountMovements(
      organisationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostVirtualBankInterAccountMovementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>
>;
export type PostVirtualBankInterAccountMovementsMutationBody =
  BodyType<PostVirtualBankInterAccountMovementsBody>;
export type PostVirtualBankInterAccountMovementsMutationError =
  null | PostVirtualBankInterAccountMovements422;

/**
 * @summary Create inter account movement
 */
export const usePostVirtualBankInterAccountMovements = <
  TError = null | PostVirtualBankInterAccountMovements422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PostVirtualBankInterAccountMovementsBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postVirtualBankInterAccountMovements>>,
  TError,
  {
    organisationId: number;
    data: BodyType<PostVirtualBankInterAccountMovementsBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPostVirtualBankInterAccountMovementsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index Account Movements Request
 */
export const getVirtualBankAccountsAccountNumberMovements = (
  organisationId: number,
  accountNumber: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankAccountsAccountNumberMovements200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/accounts/${accountNumber}/movements`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetVirtualBankAccountsAccountNumberMovementsQueryKey = (
  organisationId?: number,
  accountNumber?: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/accounts/${accountNumber}/movements`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetVirtualBankAccountsAccountNumberMovementsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
  >,
  TError = unknown
>(
  organisationId: number,
  accountNumber: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankAccountsAccountNumberMovementsQueryKey(
      organisationId,
      accountNumber,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>>
  > = () =>
    getVirtualBankAccountsAccountNumberMovements(
      organisationId,
      accountNumber,
      params,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && accountNumber),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankAccountsAccountNumberMovementsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>>
  >;
export type GetVirtualBankAccountsAccountNumberMovementsQueryError = unknown;

export function useGetVirtualBankAccountsAccountNumberMovements<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
  >,
  TError = unknown
>(
  organisationId: number,
  accountNumber: number,
  params: undefined | GetVirtualBankAccountsAccountNumberMovementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
          >,
          TError,
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankAccountsAccountNumberMovements<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
  >,
  TError = unknown
>(
  organisationId: number,
  accountNumber: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
          >,
          TError,
          Awaited<
            ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankAccountsAccountNumberMovements<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
  >,
  TError = unknown
>(
  organisationId: number,
  accountNumber: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index Account Movements Request
 */

export function useGetVirtualBankAccountsAccountNumberMovements<
  TData = Awaited<
    ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
  >,
  TError = unknown
>(
  organisationId: number,
  accountNumber: number,
  params?: GetVirtualBankAccountsAccountNumberMovementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVirtualBankAccountsAccountNumberMovements>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetVirtualBankAccountsAccountNumberMovementsQueryOptions(
      organisationId,
      accountNumber,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Account Movements
 */
export const getVirtualBankMovementsSearch = (
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankMovementsSearch200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/movements/search`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetVirtualBankMovementsSearchQueryKey = (
  organisationId?: number,
  params?: GetVirtualBankMovementsSearchParams
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/movements/search`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetVirtualBankMovementsSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
  TError = unknown
>(
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankMovementsSearchQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>
  > = () =>
    getVirtualBankMovementsSearch(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankMovementsSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>
>;
export type GetVirtualBankMovementsSearchQueryError = unknown;

export function useGetVirtualBankMovementsSearch<
  TData = Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
  TError = unknown
>(
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankMovementsSearch<
  TData = Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
  TError = unknown
>(
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankMovementsSearch<
  TData = Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
  TError = unknown
>(
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search Account Movements
 */

export function useGetVirtualBankMovementsSearch<
  TData = Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
  TError = unknown
>(
  organisationId: number,
  params: GetVirtualBankMovementsSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankMovementsSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVirtualBankMovementsSearchQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create statement
 */
export const postVirtualBankStatements = (
  organisationId: number,
  postVirtualBankStatementsBody: BodyType<PostVirtualBankStatementsBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostVirtualBankStatements200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/statements`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postVirtualBankStatementsBody
    },
    options
  );
};

export const getPostVirtualBankStatementsMutationOptions = <
  TError = null | null,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postVirtualBankStatements>>,
    TError,
    { organisationId: number; data: BodyType<PostVirtualBankStatementsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postVirtualBankStatements>>,
  TError,
  { organisationId: number; data: BodyType<PostVirtualBankStatementsBody> },
  TContext
> => {
  const mutationKey = ['postVirtualBankStatements'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postVirtualBankStatements>>,
    { organisationId: number; data: BodyType<PostVirtualBankStatementsBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return postVirtualBankStatements(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostVirtualBankStatementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postVirtualBankStatements>>
>;
export type PostVirtualBankStatementsMutationBody =
  BodyType<PostVirtualBankStatementsBody>;
export type PostVirtualBankStatementsMutationError = null | null;

/**
 * @summary Create statement
 */
export const usePostVirtualBankStatements = <
  TError = null | null,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postVirtualBankStatements>>,
      TError,
      { organisationId: number; data: BodyType<PostVirtualBankStatementsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postVirtualBankStatements>>,
  TError,
  { organisationId: number; data: BodyType<PostVirtualBankStatementsBody> },
  TContext
> => {
  const mutationOptions = getPostVirtualBankStatementsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Index statements
 */
export const getVirtualBankStatements = (
  organisationId: number,
  params?: GetVirtualBankStatementsParams,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankStatements200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/statements`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetVirtualBankStatementsQueryKey = (
  organisationId?: number,
  params?: GetVirtualBankStatementsParams
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/statements`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetVirtualBankStatementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getVirtualBankStatements>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetVirtualBankStatementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankStatementsQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankStatements>>
  > = () => getVirtualBankStatements(organisationId, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankStatements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankStatementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankStatements>>
>;
export type GetVirtualBankStatementsQueryError = unknown;

export function useGetVirtualBankStatements<
  TData = Awaited<ReturnType<typeof getVirtualBankStatements>>,
  TError = unknown
>(
  organisationId: number,
  params: undefined | GetVirtualBankStatementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatements>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankStatements<
  TData = Awaited<ReturnType<typeof getVirtualBankStatements>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetVirtualBankStatementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatements>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankStatements<
  TData = Awaited<ReturnType<typeof getVirtualBankStatements>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetVirtualBankStatementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Index statements
 */

export function useGetVirtualBankStatements<
  TData = Awaited<ReturnType<typeof getVirtualBankStatements>>,
  TError = unknown
>(
  organisationId: number,
  params?: GetVirtualBankStatementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatements>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVirtualBankStatementsQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Show statement
 */
export const getVirtualBankStatementsStatementId = (
  organisationId: number,
  statementId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<GetVirtualBankStatementsStatementId200>(
    {
      url: `/virtual_bank/organisations/${organisationId}/statements/${statementId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetVirtualBankStatementsStatementIdQueryKey = (
  organisationId?: number,
  statementId?: number
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/statements/${statementId}`
  ] as const;
};

export const getGetVirtualBankStatementsStatementIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
  TError = GetVirtualBankStatementsStatementId422
>(
  organisationId: number,
  statementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankStatementsStatementIdQueryKey(organisationId, statementId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>
  > = () =>
    getVirtualBankStatementsStatementId(
      organisationId,
      statementId,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && statementId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankStatementsStatementIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>
>;
export type GetVirtualBankStatementsStatementIdQueryError =
  GetVirtualBankStatementsStatementId422;

export function useGetVirtualBankStatementsStatementId<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
  TError = GetVirtualBankStatementsStatementId422
>(
  organisationId: number,
  statementId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankStatementsStatementId<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
  TError = GetVirtualBankStatementsStatementId422
>(
  organisationId: number,
  statementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankStatementsStatementId<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
  TError = GetVirtualBankStatementsStatementId422
>(
  organisationId: number,
  statementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Show statement
 */

export function useGetVirtualBankStatementsStatementId<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
  TError = GetVirtualBankStatementsStatementId422
>(
  organisationId: number,
  statementId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsStatementId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVirtualBankStatementsStatementIdQueryOptions(
    organisationId,
    statementId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download statement file
 */
export const getVirtualBankStatementsFileIdDownload = (
  organisationId: number,
  fileId: number,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<string>(
    {
      url: `/virtual_bank/organisations/${organisationId}/statements/${fileId}/download`,
      method: 'GET'
    },
    options
  );
};

export const getGetVirtualBankStatementsFileIdDownloadQueryKey = (
  organisationId?: number,
  fileId?: number
) => {
  return [
    `/virtual_bank/organisations/${organisationId}/statements/${fileId}/download`
  ] as const;
};

export const getGetVirtualBankStatementsFileIdDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
  TError = null
>(
  organisationId: number,
  fileId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVirtualBankStatementsFileIdDownloadQueryKey(organisationId, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>
  > = () =>
    getVirtualBankStatementsFileIdDownload(
      organisationId,
      fileId,
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organisationId && fileId),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVirtualBankStatementsFileIdDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>
>;
export type GetVirtualBankStatementsFileIdDownloadQueryError = null;

export function useGetVirtualBankStatementsFileIdDownload<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
  TError = null
>(
  organisationId: number,
  fileId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVirtualBankStatementsFileIdDownload<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
  TError = null
>(
  organisationId: number,
  fileId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVirtualBankStatementsFileIdDownload<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
  TError = null
>(
  organisationId: number,
  fileId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download statement file
 */

export function useGetVirtualBankStatementsFileIdDownload<
  TData = Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
  TError = null
>(
  organisationId: number,
  fileId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVirtualBankStatementsFileIdDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVirtualBankStatementsFileIdDownloadQueryOptions(
    organisationId,
    fileId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
